webpackJsonp([1],{

/***/ "/Suc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0fkY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BpBR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EUPG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GT0P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-analytics/dist/vue-analytics.js
var vue_analytics = __webpack_require__("AYPi");
var vue_analytics_default = /*#__PURE__*/__webpack_require__.n(vue_analytics);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/js-search/dist/commonjs/index.js
var commonjs = __webpack_require__("5KK7");
var commonjs_default = /*#__PURE__*/__webpack_require__.n(commonjs);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FeatherIcon.vue
//
//
//
//

var feather = __webpack_require__("/qmR");
//  feather.icons.x
// {
//    name: 'x',
//    contents: '<line ... /><line ... />`,
//    tags: ['cancel', 'close', 'delete', 'remove'],
//    attrs: {
//      class: 'feather feather-x',
//      xmlns: 'http://www.w3.org/2000/svg',
//      width: 24,
//      height: 24,
//      viewBox: '0 0 24 24',
//      fill: 'none',
//      stroke: 'currentColor',
//      'stroke-width': 2,
//      'stroke-linecap': 'round',
//      'stroke-linejoin': 'round',
//    }
// }
/* harmony default export */ var FeatherIcon = ({
  name: 'feather-icon',
  props: ['icon', 'options'],
  computed: {
    iconSvg: function iconSvg() {
      return feather.icons[this.icon].toSvg(this.options);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3395e3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeatherIcon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{domProps:{"innerHTML":_vm._s(_vm.iconSvg)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_FeatherIcon = (esExports);
// CONCATENATED MODULE: ./src/components/FeatherIcon.vue
function injectStyle (ssrContext) {
  __webpack_require__("0fkY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  FeatherIcon,
  components_FeatherIcon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_FeatherIcon = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PublishPage.vue

//
//
//
//
//



/* harmony default export */ var PublishPage = ({
  name: 'kpPage',
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  props: ['page', 'width', 'height', 'classes'],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['basePath']), {
    styleObject: function styleObject() {
      return {
        width: this.width + 'px',
        height: this.height + 'px',
        'background-image': 'url(' + this.basePath + '/static/_content/' + this.page.original + ')'
      };
    }
  }),
  updated: function updated() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  },
  mounted: function mounted() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dc8f292","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PublishPage.vue
var PublishPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page",class:_vm.classes,style:(_vm.styleObject),attrs:{"data-page":((_vm.page.pageIndex + 1) + "-" + (_vm.page.sectionIndex + 1))},domProps:{"innerHTML":_vm._s(_vm.page.content)}})}
var PublishPage_staticRenderFns = []
var PublishPage_esExports = { render: PublishPage_render, staticRenderFns: PublishPage_staticRenderFns }
/* harmony default export */ var components_PublishPage = (PublishPage_esExports);
// CONCATENATED MODULE: ./src/components/PublishPage.vue
function PublishPage_injectStyle (ssrContext) {
  __webpack_require__("ZQhR")
}
var PublishPage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PublishPage___vue_template_functional__ = false
/* styles */
var PublishPage___vue_styles__ = PublishPage_injectStyle
/* scopeId */
var PublishPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PublishPage___vue_module_identifier__ = null
var PublishPage_Component = PublishPage_normalizeComponent(
  PublishPage,
  components_PublishPage,
  PublishPage___vue_template_functional__,
  PublishPage___vue_styles__,
  PublishPage___vue_scopeId__,
  PublishPage___vue_module_identifier__
)

/* harmony default export */ var src_components_PublishPage = (PublishPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobilePage.vue

//
//
//
//
//
//
//



/* harmony default export */ var MobilePage = ({
  name: 'kpMobilePage',
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentMobilePage', 'mobilePageContent']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3190bf5a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobilePage.vue
var MobilePage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mobile-page",class:_vm.currentMobilePage.cssClass},[_c('header',{staticClass:"mobile-header",domProps:{"textContent":_vm._s(_vm.currentMobilePage.title)}}),_vm._v(" "),_c('article',{staticClass:"mobile-content",domProps:{"innerHTML":_vm._s(_vm.mobilePageContent(_vm.currentMobilePage))}})])}
var MobilePage_staticRenderFns = []
var MobilePage_esExports = { render: MobilePage_render, staticRenderFns: MobilePage_staticRenderFns }
/* harmony default export */ var mobile_MobilePage = (MobilePage_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobilePage.vue
function MobilePage_injectStyle (ssrContext) {
  __webpack_require__("QkI9")
}
var MobilePage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobilePage___vue_template_functional__ = false
/* styles */
var MobilePage___vue_styles__ = MobilePage_injectStyle
/* scopeId */
var MobilePage___vue_scopeId__ = "data-v-3190bf5a"
/* moduleIdentifier (server only) */
var MobilePage___vue_module_identifier__ = null
var MobilePage_Component = MobilePage_normalizeComponent(
  MobilePage,
  mobile_MobilePage,
  MobilePage___vue_template_functional__,
  MobilePage___vue_styles__,
  MobilePage___vue_scopeId__,
  MobilePage___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobilePage = (MobilePage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileNavigationBar.vue

//
//
//
//
//
//
//




/* harmony default export */ var MobileNavigationBar = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['title', 'companyLogo', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-772adcfe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileNavigationBar.vue
var MobileNavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-bar",attrs:{"id":"mobile-nav-bar"},on:{"click":_vm.toggleContents}},[_c('img',{attrs:{"id":"mobile-nav-bar__logo","src":_vm.companyLogo}}),_vm._v(" "),_c('div',{staticClass:"nav-menu-button",attrs:{"id":"mobile-nav-button"}},[_c('feather-icon',{attrs:{"icon":"menu"}})],1)])}
var MobileNavigationBar_staticRenderFns = []
var MobileNavigationBar_esExports = { render: MobileNavigationBar_render, staticRenderFns: MobileNavigationBar_staticRenderFns }
/* harmony default export */ var mobile_MobileNavigationBar = (MobileNavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileNavigationBar.vue
function MobileNavigationBar_injectStyle (ssrContext) {
  __webpack_require__("WN8W")
}
var MobileNavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileNavigationBar___vue_template_functional__ = false
/* styles */
var MobileNavigationBar___vue_styles__ = MobileNavigationBar_injectStyle
/* scopeId */
var MobileNavigationBar___vue_scopeId__ = "data-v-772adcfe"
/* moduleIdentifier (server only) */
var MobileNavigationBar___vue_module_identifier__ = null
var MobileNavigationBar_Component = MobileNavigationBar_normalizeComponent(
  MobileNavigationBar,
  mobile_MobileNavigationBar,
  MobileNavigationBar___vue_template_functional__,
  MobileNavigationBar___vue_styles__,
  MobileNavigationBar___vue_scopeId__,
  MobileNavigationBar___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileNavigationBar = (MobileNavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileMenu.vue

//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MobileMenu = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['mobilePages', 'mobilePageLink', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba2690a0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileMenu.vue
var MobileMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showContents)?_c('div',{attrs:{"id":"mobile-menu"}},[_c('ul',{attrs:{"id":"mobile-list"}},_vm._l((_vm.mobilePages),function(mobilePage,index){return (!mobilePage.hideInMenu)?_c('li',{key:index,on:{"click":_vm.toggleContents}},[_c('router-link',{attrs:{"to":_vm.mobilePageLink(mobilePage)}},[_vm._v(_vm._s(mobilePage.title))])],1):_vm._e()}))]):_vm._e()}
var MobileMenu_staticRenderFns = []
var MobileMenu_esExports = { render: MobileMenu_render, staticRenderFns: MobileMenu_staticRenderFns }
/* harmony default export */ var mobile_MobileMenu = (MobileMenu_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileMenu.vue
function MobileMenu_injectStyle (ssrContext) {
  __webpack_require__("NZMO")
}
var MobileMenu_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileMenu___vue_template_functional__ = false
/* styles */
var MobileMenu___vue_styles__ = MobileMenu_injectStyle
/* scopeId */
var MobileMenu___vue_scopeId__ = "data-v-ba2690a0"
/* moduleIdentifier (server only) */
var MobileMenu___vue_module_identifier__ = null
var MobileMenu_Component = MobileMenu_normalizeComponent(
  MobileMenu,
  mobile_MobileMenu,
  MobileMenu___vue_template_functional__,
  MobileMenu___vue_styles__,
  MobileMenu___vue_scopeId__,
  MobileMenu___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileMenu = (MobileMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var MobileContainer = ({
  components: {
    MobilePage: components_mobile_MobilePage,
    MobileNavigationBar: components_mobile_MobileNavigationBar,
    MobileMenu: components_mobile_MobileMenu
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['nextMobilePage', 'previousMobilePage', 'currentMobilePage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a441386","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileContainer.vue
var MobileContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mobile-container"}},[_c('mobile-navigation-bar'),_vm._v(" "),(_vm.currentMobilePage)?_c('mobile-page'):_vm._e(),_vm._v(" "),_c('mobile-menu'),_vm._v(" "),_c('div',{staticClass:"nav-buttons",attrs:{"id":"navButtons"}},[(_vm.previousMobilePage)?_c('button',{staticClass:"advert-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnPrev","onclick":"Publish.goToPreviousMobilePage();"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('button',{staticClass:"aqua-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnNext","onclick":"Publish.goToNextMobilePage();"}}):_vm._e()])],1)}
var MobileContainer_staticRenderFns = []
var MobileContainer_esExports = { render: MobileContainer_render, staticRenderFns: MobileContainer_staticRenderFns }
/* harmony default export */ var mobile_MobileContainer = (MobileContainer_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileContainer.vue
function MobileContainer_injectStyle (ssrContext) {
  __webpack_require__("oPvi")
}
var MobileContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileContainer___vue_template_functional__ = false
/* styles */
var MobileContainer___vue_styles__ = MobileContainer_injectStyle
/* scopeId */
var MobileContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileContainer___vue_module_identifier__ = null
var MobileContainer_Component = MobileContainer_normalizeComponent(
  MobileContainer,
  mobile_MobileContainer,
  MobileContainer___vue_template_functional__,
  MobileContainer___vue_styles__,
  MobileContainer___vue_scopeId__,
  MobileContainer___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileContainer = (MobileContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LanguagesPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var LanguagesPanel = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['languages']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c0d9e23","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LanguagesPanel.vue
var LanguagesPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"languages-fade"}},[_c('nav',{staticClass:"languages-panel"},[_c('ul',{staticClass:"languages-list"},_vm._l((_vm.languages),function(language,index){return _c('li',{key:index,staticClass:"languages-item"},[_c('a',{attrs:{"rel":"alternate","href":language.href,"target":"_blank"}},[_vm._v(_vm._s(language.code))])])}))])])}
var LanguagesPanel_staticRenderFns = []
var LanguagesPanel_esExports = { render: LanguagesPanel_render, staticRenderFns: LanguagesPanel_staticRenderFns }
/* harmony default export */ var components_LanguagesPanel = (LanguagesPanel_esExports);
// CONCATENATED MODULE: ./src/components/LanguagesPanel.vue
function LanguagesPanel_injectStyle (ssrContext) {
  __webpack_require__("i9d8")
}
var LanguagesPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var LanguagesPanel___vue_template_functional__ = false
/* styles */
var LanguagesPanel___vue_styles__ = LanguagesPanel_injectStyle
/* scopeId */
var LanguagesPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LanguagesPanel___vue_module_identifier__ = null
var LanguagesPanel_Component = LanguagesPanel_normalizeComponent(
  LanguagesPanel,
  components_LanguagesPanel,
  LanguagesPanel___vue_template_functional__,
  LanguagesPanel___vue_styles__,
  LanguagesPanel___vue_scopeId__,
  LanguagesPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_LanguagesPanel = (LanguagesPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var NavigationBar = ({
  props: ["logoURL", "title", "page", "companyName", "width"],
  components: {
    FeatherIcon: src_components_FeatherIcon,
    LanguagesPanel: src_components_LanguagesPanel
  },
  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "rightToLeft", "companyLogo", "downloadPath", "showContents", "showLanguages", "showSearch", "showGuide", "isZoomed", "isMobile", "mobileSwitch", "currentMobilePage"]), {
    divider: function divider() {
      if (this.rightToLeft) return "chevron-left";
      return "chevron-right";
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS",
    toggleLanguages: "TOGGLE_LANGUAGES",
    toggleZoom: "TOGGLE_ZOOM",
    toggleSearch: "TOGGLE_SEARCH",
    toggleGuide: "TOGGLE_GUIDE",
    toggleReader: "TOGGLE_READER"
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ef52442","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationBar.vue
var NavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"nav-bar"},[_c('div',{staticClass:"nav-bar__container"},[_c('div',{staticClass:"nav-bar__logo"},[_c('img',{staticClass:"nav-bar__logo-image",attrs:{"src":_vm.companyLogo,"alt":_vm.companyName}})]),_vm._v(" "),_c('div',{staticClass:"nav-bar__text"},[_c('span',{staticClass:"nav-bar__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__divider"},[_c('feather-icon',{attrs:{"icon":_vm.divider}})],1):_vm._e(),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__page"},[_vm._v(_vm._s(_vm.page))]):_vm._e()]),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && !_vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Reader is available")]):_vm._e(),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && _vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Return to magazine")]):_vm._e(),_vm._v(" "),_c('nav',{staticClass:"nav-bar__links"},[_c('ul',[(!((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader))?[(_vm.guideEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showGuide},on:{"click":_vm.toggleGuide}},[_c('feather-icon',{attrs:{"icon":"help-circle"},on:{"click":_vm.toggleGuide}})],1):_vm._e(),_vm._v(" "),((_vm.zoomEnabled && (!_vm.isMobile)))?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.isZoomed},on:{"click":_vm.toggleZoom}},[_c('feather-icon',{attrs:{"icon":"zoom-in"},on:{"click":_vm.toggleZoom}})],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showSearch},on:{"click":_vm.toggleSearch}},[_c('feather-icon',{attrs:{"icon":"search"}})],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showLanguages},on:{"click":_vm.toggleLanguages}},[_c('feather-icon',{attrs:{"icon":"globe"}}),_vm._v(" "),_c('languages-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLanguages),expression:"showLanguages"}]})],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('a',{attrs:{"href":_vm.downloadPath,"download":""}},[_c('feather-icon',{attrs:{"icon":"download"}})],1)]):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('feather-icon',{attrs:{"icon":"printer"}})],1):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"grid"}})],1):_vm._e()],2)])])])}
var NavigationBar_staticRenderFns = []
var NavigationBar_esExports = { render: NavigationBar_render, staticRenderFns: NavigationBar_staticRenderFns }
/* harmony default export */ var components_NavigationBar = (NavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/NavigationBar.vue
function NavigationBar_injectStyle (ssrContext) {
  __webpack_require__("/Suc")
}
var NavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationBar___vue_template_functional__ = false
/* styles */
var NavigationBar___vue_styles__ = NavigationBar_injectStyle
/* scopeId */
var NavigationBar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationBar___vue_module_identifier__ = null
var NavigationBar_Component = NavigationBar_normalizeComponent(
  NavigationBar,
  components_NavigationBar,
  NavigationBar___vue_template_functional__,
  NavigationBar___vue_styles__,
  NavigationBar___vue_scopeId__,
  NavigationBar___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationBar = (NavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationLink.vue
//
//
//
//
//
//



/* harmony default export */ var NavigationLink = ({
  props: ['to', 'rotation', 'color', 'classes'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74b6e97a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationLink.vue
var NavigationLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes},[_c('router-link',{attrs:{"to":_vm.to}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)],1)}
var NavigationLink_staticRenderFns = []
var NavigationLink_esExports = { render: NavigationLink_render, staticRenderFns: NavigationLink_staticRenderFns }
/* harmony default export */ var components_NavigationLink = (NavigationLink_esExports);
// CONCATENATED MODULE: ./src/components/NavigationLink.vue
function NavigationLink_injectStyle (ssrContext) {
  __webpack_require__("Pg37")
}
var NavigationLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationLink___vue_template_functional__ = false
/* styles */
var NavigationLink___vue_styles__ = NavigationLink_injectStyle
/* scopeId */
var NavigationLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationLink___vue_module_identifier__ = null
var NavigationLink_Component = NavigationLink_normalizeComponent(
  NavigationLink,
  components_NavigationLink,
  NavigationLink___vue_template_functional__,
  NavigationLink___vue_styles__,
  NavigationLink___vue_scopeId__,
  NavigationLink___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationLink = (NavigationLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MobileLink.vue
//
//
//
//
//
//



/* harmony default export */ var MobileLink = ({
  props: ['to', 'rotation', 'color', 'classes', 'click'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48277a17","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileLink.vue
var MobileLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes,on:{"click":_vm.click}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)}
var MobileLink_staticRenderFns = []
var MobileLink_esExports = { render: MobileLink_render, staticRenderFns: MobileLink_staticRenderFns }
/* harmony default export */ var components_MobileLink = (MobileLink_esExports);
// CONCATENATED MODULE: ./src/components/MobileLink.vue
function MobileLink_injectStyle (ssrContext) {
  __webpack_require__("EUPG")
}
var MobileLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileLink___vue_template_functional__ = false
/* styles */
var MobileLink___vue_styles__ = MobileLink_injectStyle
/* scopeId */
var MobileLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileLink___vue_module_identifier__ = null
var MobileLink_Component = MobileLink_normalizeComponent(
  MobileLink,
  components_MobileLink,
  MobileLink___vue_template_functional__,
  MobileLink___vue_styles__,
  MobileLink___vue_scopeId__,
  MobileLink___vue_module_identifier__
)

/* harmony default export */ var src_components_MobileLink = (MobileLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentItem.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ContentItem = ({
  props: ['page', 'index'],
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'basePath', 'currentPage'])),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['goToPage']), Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS"
  }), {

    getBackgroundURL: function getBackgroundURL(index, sectionIndex) {
      if (sectionIndex == 0) {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '.png)';
      } else {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '-' + (sectionIndex + 1) + '.png)';
      }
    },

    toggleExpanded: function toggleExpanded(index) {
      this.isExpanded = !this.isExpanded;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-883f7ca2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentItem.vue
var ContentItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"contents-item"},[_c('div',{staticClass:"contents-item__section",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == 0}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1))]),_vm._v(" "),_c('p',{staticClass:"contents-item__text--title"},[_vm._v(_vm._s(_vm.page[0].title))]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"content-item__chevrons"},[_c('div',{staticClass:"contents-item__expander",on:{"click":function($event){_vm.toggleExpanded(_vm.index)}}},[(_vm.isExpanded)?_c('feather-icon',{attrs:{"icon":"chevron-up"}}):_c('feather-icon',{attrs:{"icon":"chevron-down"}})],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}})]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"contents-item__sections",class:{'collapsed': !_vm.isExpanded}},_vm._l((_vm.page),function(section,sectionIndex){return (sectionIndex != 0)?_c('div',{key:(_vm.index+1) + '-' + (sectionIndex + 1),staticClass:"contents-item__subsection",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == sectionIndex}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1)+" - "+_vm._s(sectionIndex + 1))])]),_vm._v(" "),_c('div',{staticClass:"contents-section__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, sectionIndex)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}})]):_vm._e()})):_vm._e()])}
var ContentItem_staticRenderFns = []
var ContentItem_esExports = { render: ContentItem_render, staticRenderFns: ContentItem_staticRenderFns }
/* harmony default export */ var components_ContentItem = (ContentItem_esExports);
// CONCATENATED MODULE: ./src/components/ContentItem.vue
function ContentItem_injectStyle (ssrContext) {
  __webpack_require__("T53c")
}
var ContentItem_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentItem___vue_template_functional__ = false
/* styles */
var ContentItem___vue_styles__ = ContentItem_injectStyle
/* scopeId */
var ContentItem___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentItem___vue_module_identifier__ = null
var ContentItem_Component = ContentItem_normalizeComponent(
  ContentItem,
  components_ContentItem,
  ContentItem___vue_template_functional__,
  ContentItem___vue_styles__,
  ContentItem___vue_scopeId__,
  ContentItem___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentItem = (ContentItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentsPanel.vue

//
//
//
//
//
//
//
//
//





/* harmony default export */ var ContentsPanel = ({
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon,
    ContentItem: src_components_ContentItem
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'basePath', 'currentPage', 'showContents']))

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14d3008a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentsPanel.vue
var ContentsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('nav',{staticClass:"contents-panel"},[_c('ul',{staticClass:"contents-list"},_vm._l((_vm.pages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})}))])])}
var ContentsPanel_staticRenderFns = []
var ContentsPanel_esExports = { render: ContentsPanel_render, staticRenderFns: ContentsPanel_staticRenderFns }
/* harmony default export */ var components_ContentsPanel = (ContentsPanel_esExports);
// CONCATENATED MODULE: ./src/components/ContentsPanel.vue
function ContentsPanel_injectStyle (ssrContext) {
  __webpack_require__("U2l4")
}
var ContentsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentsPanel___vue_template_functional__ = false
/* styles */
var ContentsPanel___vue_styles__ = ContentsPanel_injectStyle
/* scopeId */
var ContentsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentsPanel___vue_module_identifier__ = null
var ContentsPanel_Component = ContentsPanel_normalizeComponent(
  ContentsPanel,
  components_ContentsPanel,
  ContentsPanel___vue_template_functional__,
  ContentsPanel___vue_styles__,
  ContentsPanel___vue_scopeId__,
  ContentsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentsPanel = (ContentsPanel_Component.exports);

// CONCATENATED MODULE: ./src/helpers/modules/trackingHandler.js
/* harmony default export */ var trackingHandler = ({
  init: function init() {
    // Events

    //External Links clicked
    document.addEventListener('click', this.trackOutboundLinks, false);
    //Video Played
    //https://medium.com/@matt_west/track-html5-video-events-using-google-analytics-and-javascript-3be691b8bd45

  },
  trackOutboundLinks: function trackOutboundLinks(event) {
    if (event.target.tagName != 'A') return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Outbound Link',
        eventAction: 'Click',
        eventLabel: event.target.href,
        transport: 'beacon'
      });
    }
  },
  trackSearchTerms: function trackSearchTerms(searchTerm) {
    if (searchTerm == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Search',
        eventAction: 'Search',
        eventLabel: searchTerm
      });
    }
  },
  trackVideoPlay: function trackVideoPlay(filename) {
    if (filename == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Video',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  },
  trackAudioPlay: function trackAudioPlay(filename) {
    if (filename == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Audio',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SearchPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var SearchPanel = ({
  // TODO Highlight search text */

  data: function data() {
    return {
      searchText: '',
      searchResults: [],
      noResults: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'rightToLeft', 'basePath'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleSearch: 'TOGGLE_SEARCH'
  }), Object(vuex_esm["b" /* mapActions */])(['goToPage']), {
    // getBackgroundURL: (index) => "url(/static/_thumbs/"+(index)+"="+1+"-w140-h105.png)",
    // getBackgroundURL: (background) => 'url(/static/_content/'+ background +')',
    getBackgroundURL: function getBackgroundURL(background) {
      return this.basePath + '/static/_thumbs/' + background + '.png';
    },
    search: function search() {
      this.noResults = false;
      trackingHandler.trackSearchTerms(this.searchText);
      this.searchResults = window.search.search(this.searchText);
      if (this.searchResults.length == 0) {
        this.noResults = true;
      }
    },
    goToResultPage: function goToResultPage(pageIndex, sectionIndex) {
      this.goToPage({ pageIndex: pageIndex, sectionIndex: sectionIndex });
      this.toggleSearch();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05e5c2ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchPanel.vue
var SearchPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"search-fade"}},[_c('div',{staticClass:"search-container"},[_c('div',{staticClass:"search-panel"},[_c('div',{staticClass:"search-bar"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"search-input",attrs:{"type":"text","placeholder":"Search Publication"},domProps:{"value":(_vm.searchText)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.search($event)},"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"search-button",on:{"click":_vm.search}},[_c('feather-icon',{attrs:{"icon":"search"}})],1)]),_vm._v(" "),_c('transition-group',{staticClass:"search-results",attrs:{"name":"list","tag":"ul"}},_vm._l((_vm.searchResults),function(searchResult){return _c('li',{key:searchResult.id,staticClass:"search-result",on:{"click":function($event){_vm.goToResultPage(searchResult.pageIndex, searchResult.sectionIndex)}}},[_c('img',{staticClass:"search-result__image",attrs:{"src":_vm.getBackgroundURL(searchResult.thumb),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"search-result__text"},[_c('div',{staticClass:"search-result__title"},[_vm._v("\n            "+_vm._s(searchResult.id)+". "+_vm._s(searchResult.title)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"search-result__body"},[_vm._v("\n            "+_vm._s(searchResult.body)+"\n          ")])])])})),_vm._v(" "),(_vm.noResults)?_c('div',{attrs:{"id":"noResultsContainer"}},[_c('h2',[_vm._v("No results found. Please try again")])]):_vm._e()],1)])])}
var SearchPanel_staticRenderFns = []
var SearchPanel_esExports = { render: SearchPanel_render, staticRenderFns: SearchPanel_staticRenderFns }
/* harmony default export */ var components_SearchPanel = (SearchPanel_esExports);
// CONCATENATED MODULE: ./src/components/SearchPanel.vue
function SearchPanel_injectStyle (ssrContext) {
  __webpack_require__("V6ic")
}
var SearchPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SearchPanel___vue_template_functional__ = false
/* styles */
var SearchPanel___vue_styles__ = SearchPanel_injectStyle
/* scopeId */
var SearchPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SearchPanel___vue_module_identifier__ = null
var SearchPanel_Component = SearchPanel_normalizeComponent(
  SearchPanel,
  components_SearchPanel,
  SearchPanel___vue_template_functional__,
  SearchPanel___vue_styles__,
  SearchPanel___vue_scopeId__,
  SearchPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_SearchPanel = (SearchPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ExternalResource.vue
//
//
//
//

/* harmony default export */ var ExternalResource = ({
  props: ['source']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1f72b0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExternalResource.vue
var ExternalResource_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('script',{attrs:{"type":"application/javascript","src":_vm.source}})}
var ExternalResource_staticRenderFns = []
var ExternalResource_esExports = { render: ExternalResource_render, staticRenderFns: ExternalResource_staticRenderFns }
/* harmony default export */ var components_ExternalResource = (ExternalResource_esExports);
// CONCATENATED MODULE: ./src/components/ExternalResource.vue
var ExternalResource_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ExternalResource___vue_template_functional__ = false
/* styles */
var ExternalResource___vue_styles__ = null
/* scopeId */
var ExternalResource___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ExternalResource___vue_module_identifier__ = null
var ExternalResource_Component = ExternalResource_normalizeComponent(
  ExternalResource,
  components_ExternalResource,
  ExternalResource___vue_template_functional__,
  ExternalResource___vue_styles__,
  ExternalResource___vue_scopeId__,
  ExternalResource___vue_module_identifier__
)

/* harmony default export */ var src_components_ExternalResource = (ExternalResource_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PageDots.vue

//
//
//
//
//
//



/* harmony default export */ var PageDots = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentPages', 'width', 'height', 'zeroedPageIndex', 'zeroedSectionIndex', 'rightToLeft']), {
    styleObject: function styleObject() {
      var xTranslation = -(this.width / 2 + 20);
      var yTranslation = -(this.height / 2 - 5);
      if (this.rightToLeft) {
        xTranslation = this.width / 2;
      }
      return {
        transform: 'translate(' + xTranslation + 'px, ' + yTranslation + 'px)',
        width: '20px'
      };
    }
  }),
  methods: {
    activePage: function activePage(page) {
      if (this.zeroedPageIndex == page.pageIndex && this.zeroedSectionIndex == page.sectionIndex) return true;
      return false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-745923cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageDots.vue
var PageDots_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-dots",style:(_vm.styleObject)},_vm._l((_vm.currentPages),function(page,index){return _c('div',{key:index,staticClass:"page-dot",class:{'page-dot--active': _vm.activePage(page)}})}))}
var PageDots_staticRenderFns = []
var PageDots_esExports = { render: PageDots_render, staticRenderFns: PageDots_staticRenderFns }
/* harmony default export */ var components_PageDots = (PageDots_esExports);
// CONCATENATED MODULE: ./src/components/PageDots.vue
function PageDots_injectStyle (ssrContext) {
  __webpack_require__("pXbK")
}
var PageDots_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PageDots___vue_template_functional__ = false
/* styles */
var PageDots___vue_styles__ = PageDots_injectStyle
/* scopeId */
var PageDots___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageDots___vue_module_identifier__ = null
var PageDots_Component = PageDots_normalizeComponent(
  PageDots,
  components_PageDots,
  PageDots___vue_template_functional__,
  PageDots___vue_styles__,
  PageDots___vue_scopeId__,
  PageDots___vue_module_identifier__
)

/* harmony default export */ var src_components_PageDots = (PageDots_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/VideoContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var VideoContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['videoURL', 'isDoublePage']), {
    isYoutube: function isYoutube() {
      return this.videoURL.search('youtube') !== -1;
    },
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22bcc19e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoContainer.vue
var VideoContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[(_vm.isYoutube)?_c('div',{attrs:{"id":"video-container"}},[_c('div',{staticClass:"embed-container"},[_c('iframe',{attrs:{"id":"video","width":"854","height":"480","src":_vm.videoURL,"frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2):_c('div',{attrs:{"id":"video-container"}},[_c('video',{attrs:{"id":"video","src":_vm.videoURL,"autoplay":"","controls":"controls","width":"967","height":"544"}},[_c('source',{attrs:{"src":_vm.videoURL,"type":"video/mp4"}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var VideoContainer_staticRenderFns = []
var VideoContainer_esExports = { render: VideoContainer_render, staticRenderFns: VideoContainer_staticRenderFns }
/* harmony default export */ var components_VideoContainer = (VideoContainer_esExports);
// CONCATENATED MODULE: ./src/components/VideoContainer.vue
function VideoContainer_injectStyle (ssrContext) {
  __webpack_require__("Zf2O")
}
var VideoContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var VideoContainer___vue_template_functional__ = false
/* styles */
var VideoContainer___vue_styles__ = VideoContainer_injectStyle
/* scopeId */
var VideoContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var VideoContainer___vue_module_identifier__ = null
var VideoContainer_Component = VideoContainer_normalizeComponent(
  VideoContainer,
  components_VideoContainer,
  VideoContainer___vue_template_functional__,
  VideoContainer___vue_styles__,
  VideoContainer___vue_scopeId__,
  VideoContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_VideoContainer = (VideoContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GalleryContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GalleryContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(["galleryImages", "galleryCaptions", "basePath", "galleryIndex", "isDoublePage"]), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    nextOptions: function nextOptions() {
      return {
        width: 50,
        height: 50
      };
    },
    prevOptions: function prevOptions() {
      return {
        class: "r180",
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobileNextOptions: function mobileNextOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobilePrevOptions: function mobilePrevOptions() {
      return {
        class: "r180",
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10484467","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GalleryContainer.vue
var GalleryContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"gallery-container"}},[(_vm.isDoublePage)?[_c('feather-icon',{attrs:{"id":"gallery-next","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.nextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.prevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('feather-icon',{attrs:{"id":"gallery-next-mobile","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.mobileNextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous-mobile","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.mobilePrevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close-mobile","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)],_vm._v(" "),_vm._l((_vm.galleryImages),function(image,index){return _c('img',{class:{'active': index == _vm.galleryIndex, 'inactive': index != _vm.galleryIndex},attrs:{"src":_vm.basePath + '/static/_content/' + image,"alt":""}})}),_vm._v(" "),_c('div',{staticClass:"gallery-captions"},[(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])?_c('p',{staticClass:"gallery-caption"},[_vm._v("\n        "+_vm._s(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])+"\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"gallery-dots"},_vm._l((_vm.galleryImages),function(image,index){return _c('div',{staticClass:"gallery-dot",class:{'gallery-dot--active': index == _vm.galleryIndex}})}))],2)])}
var GalleryContainer_staticRenderFns = []
var GalleryContainer_esExports = { render: GalleryContainer_render, staticRenderFns: GalleryContainer_staticRenderFns }
/* harmony default export */ var components_GalleryContainer = (GalleryContainer_esExports);
// CONCATENATED MODULE: ./src/components/GalleryContainer.vue
function GalleryContainer_injectStyle (ssrContext) {
  __webpack_require__("S4/L")
}
var GalleryContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GalleryContainer___vue_template_functional__ = false
/* styles */
var GalleryContainer___vue_styles__ = GalleryContainer_injectStyle
/* scopeId */
var GalleryContainer___vue_scopeId__ = "data-v-10484467"
/* moduleIdentifier (server only) */
var GalleryContainer___vue_module_identifier__ = null
var GalleryContainer_Component = GalleryContainer_normalizeComponent(
  GalleryContainer,
  components_GalleryContainer,
  GalleryContainer___vue_template_functional__,
  GalleryContainer___vue_styles__,
  GalleryContainer___vue_scopeId__,
  GalleryContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GalleryContainer = (GalleryContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GuideContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GuideContainer = ({
    name: 'guide',
    components: {
        FeatherIcon: src_components_FeatherIcon
    },
    computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
        sectionIndices: function sectionIndices(state) {
            return state.sectionIndices;
        }
    }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "isMobile"]))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c172f84","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GuideContainer.vue
var GuideContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"guide-container"}},[_c('div',{attrs:{"id":"guide-page"}},[_c('div',{staticClass:"guide-title"},[_c('h4',[_vm._v("User Guide")])]),_vm._v(" "),_c('ul',{staticClass:"guide-items"},[_c('li',[_c('div',[_c('feather-icon',{staticClass:"guide-icons guide-navigation-prev",attrs:{"icon":"play"}}),_vm._v(" "),(_vm.isMobile && !(_vm.sectionIndices.length == 0))?_c('feather-icon',{staticClass:"guide-icons guide-navigation-down",attrs:{"icon":"play"}}):_vm._e(),_vm._v(" "),_c('feather-icon',{staticClass:"guide-icons guide-navigation-next",attrs:{"icon":"play"}})],1),_vm._v(" "),(_vm.isMobile)?_c('p',[_vm._v("Navigate using the arrows or by swiping")]):_c('p',[_vm._v("Navigate using arrows, your keyboard or by dragging the page")])]),_vm._v(" "),(_vm.zoomEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"zoom-in"}}),_vm._v(" "),_c('p',[_vm._v("Zoom in and out")])],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"search"}}),_vm._v(" "),_c('p',[_vm._v("Search for words or phrases")])],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"globe"}}),_vm._v(" "),_c('p',[_vm._v("Change language")])],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"download"}}),_vm._v(" "),_c('p',[_vm._v("Download PDF")])],1):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"printer"}}),_vm._v(" "),_c('p',[_vm._v("Print PDF")])],1):_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"grid"}}),_vm._v(" "),_c('p',[_vm._v("Content navigation")])],1):_vm._e(),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"viewBox":"0 0 160.62 157.733","enable-background":"new 0 0 160.62 157.733"}},[_c('g',[_c('path',{attrs:{"fill":"#000","d":"M81.691,67.001c7.996,0,14.477,6.481,14.477,14.477s-6.481,14.477-14.477,14.477\n                            c-7.995,0-14.476-6.482-14.476-14.477S73.697,67.001,81.691,67.001z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#000","d":"M124.263,52.933h-23.92l-0.716-5.581c0-3.189-2.585-5.774-5.774-5.774H69.218\n                            c-3.188,0-5.773,2.585-5.773,5.774l-0.716,5.581H39.001c-2.126,0-3.85,1.627-3.85,3.753v49.656c0,2.126,1.724,3.945,3.85,3.945\n                            h85.262c2.125,0,3.849-1.819,3.849-3.945V56.686C128.112,54.56,126.388,52.933,124.263,52.933z M81.65,105.2\n                            c-13.074,0-23.672-10.599-23.672-23.672S68.576,57.856,81.65,57.856s23.672,10.598,23.672,23.671S94.724,105.2,81.65,105.2z\n                            M123.685,63.134h-20.209v-5.966h20.209V63.134z"}})]),_vm._v(" "),_c('g',[_c('path',{attrs:{"fill":"#000","d":"M154.856,78.867h-5.764c-0.001,9.313-1.884,18.156-5.29,26.209c-5.107,12.077-13.654,22.371-24.404,29.633\n                            c-5.375,3.631-11.298,6.504-17.62,8.47s-13.041,3.026-20.026,3.027c-9.314-0.001-18.156-1.884-26.21-5.29\n                            c-12.077-5.107-22.371-13.653-29.632-24.404c-3.631-5.375-6.504-11.298-8.471-17.62c-1.966-6.322-3.026-13.041-3.026-20.026\n                            c0.001-9.314,1.884-18.157,5.29-26.21C24.81,40.58,33.357,30.286,44.107,23.024c5.375-3.631,11.298-6.504,17.619-8.471\n                            c6.322-1.966,13.041-3.026,20.027-3.026c9.313,0,18.156,1.884,26.209,5.29c12.077,5.107,22.371,13.653,29.632,24.404\n                            c3.631,5.375,6.504,11.298,8.471,17.619c1.966,6.322,3.026,13.041,3.026,20.027H154.856h5.764c0.001-10.874-2.207-21.262-6.2-30.7\n                            c-5.991-14.161-15.983-26.191-28.567-34.694c-6.292-4.251-13.235-7.62-20.649-9.926C97.791,1.241,89.907,0,81.753,0\n                            C70.88-0.001,60.491,2.207,51.052,6.2c-14.161,5.991-26.19,15.983-34.693,28.567c-4.251,6.292-7.62,13.235-9.926,20.648\n                            c-2.306,7.413-3.547,15.296-3.546,23.451c-0.001,10.873,2.207,21.262,6.2,30.7c5.991,14.161,15.983,26.191,28.567,34.694\n                            c6.292,4.251,13.235,7.62,20.648,9.926c7.413,2.306,15.296,3.547,23.451,3.546c10.874,0.001,21.262-2.207,30.7-6.2\n                            c14.161-5.991,26.191-15.984,34.694-28.568c4.251-6.292,7.621-13.235,9.926-20.648c2.306-7.413,3.547-15.296,3.547-23.45H154.856\n                            L154.856,78.867z"}})])]),_vm._v(" "),_c('p',[_vm._v("Image gallery")])]),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"675px","height":"675px","viewBox":"0 0 675 675","enable-background":"new 0 0 675 675","xml:space":"preserve"}},[_c('circle',{attrs:{"fill":"none","stroke":"#000","stroke-width":"30","stroke-miterlimit":"10","cx":"339.195","cy":"340","r":"321"}}),_vm._v(" "),_c('polyline',{attrs:{"fill":"#000","points":"558,356 207,563 207,117 "}})]),_vm._v(" "),_c('p',[_vm._v("Video")])]),_vm._v(" "),(_vm.guideEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"help-circle"}}),_vm._v(" "),_c('p',[_vm._v("User guide")])],1):_vm._e()])])])])}
var GuideContainer_staticRenderFns = []
var GuideContainer_esExports = { render: GuideContainer_render, staticRenderFns: GuideContainer_staticRenderFns }
/* harmony default export */ var components_GuideContainer = (GuideContainer_esExports);
// CONCATENATED MODULE: ./src/components/GuideContainer.vue
function GuideContainer_injectStyle (ssrContext) {
  __webpack_require__("GT0P")
}
var GuideContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GuideContainer___vue_template_functional__ = false
/* styles */
var GuideContainer___vue_styles__ = GuideContainer_injectStyle
/* scopeId */
var GuideContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var GuideContainer___vue_module_identifier__ = null
var GuideContainer_Component = GuideContainer_normalizeComponent(
  GuideContainer,
  components_GuideContainer,
  GuideContainer___vue_template_functional__,
  GuideContainer___vue_styles__,
  GuideContainer___vue_scopeId__,
  GuideContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GuideContainer = (GuideContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AudioContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var AudioContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['audioURL', 'isDoublePage']), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94cb9f4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AudioContainer.vue
var AudioContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"audio-container"}},[_c('audio',{staticStyle:{"width":"300px","height":"36px"},attrs:{"controls":"","controlsList":"nodownload","autoplay":"","preload":"metadata"}},[_c('source',{attrs:{"src":_vm.audioURL,"type":"audio/mp3"}}),_vm._v("\n      Your browser does not support the audio element.\n    ")]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"audio-close","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"audio-close-mobile","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var AudioContainer_staticRenderFns = []
var AudioContainer_esExports = { render: AudioContainer_render, staticRenderFns: AudioContainer_staticRenderFns }
/* harmony default export */ var components_AudioContainer = (AudioContainer_esExports);
// CONCATENATED MODULE: ./src/components/AudioContainer.vue
function AudioContainer_injectStyle (ssrContext) {
  __webpack_require__("BpBR")
}
var AudioContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var AudioContainer___vue_template_functional__ = false
/* styles */
var AudioContainer___vue_styles__ = AudioContainer_injectStyle
/* scopeId */
var AudioContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AudioContainer___vue_module_identifier__ = null
var AudioContainer_Component = AudioContainer_normalizeComponent(
  AudioContainer,
  components_AudioContainer,
  AudioContainer___vue_template_functional__,
  AudioContainer___vue_styles__,
  AudioContainer___vue_scopeId__,
  AudioContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_AudioContainer = (AudioContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















/* harmony default export */ var App = ({
  name: 'app',
  components: {
    PublishPage: src_components_PublishPage,
    NavigationBar: src_components_NavigationBar,
    NavigationLink: src_components_NavigationLink,
    ExternalResource: src_components_ExternalResource,
    ContentsPanel: src_components_ContentsPanel,
    LanguagesPanel: src_components_LanguagesPanel,
    SearchPanel: src_components_SearchPanel,
    PageDots: src_components_PageDots,
    GalleryContainer: src_components_GalleryContainer,
    MobileContainer: components_mobile_MobileContainer,
    VideoContainer: src_components_VideoContainer,
    GuideContainer: src_components_GuideContainer,
    MobileLink: src_components_MobileLink,
    AudioContainer: src_components_AudioContainer
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['title', 'description', 'width', 'height', 'visiblePages', 'currentPage', 'previousPage', 'nextPage', 'nextNextPage', 'previousPreviousPage', 'previousPageURI', 'nextPageURI', 'previousSection', 'nextSection', 'previousSectionURI', 'nextSectionURI', 'previousMobilePage', 'nextMobilePage', 'previousMobilePageURI', 'nextMobilePageURI', 'externalResources', 'searchObject', 'pageScripts', 'documentScript', 'zoomLevel', 'pageContainerStyle', 'rightToLeft', 'isMobile', 'mobileSwitch', 'videoURL', 'showContents', 'showLanguages', 'showSearch', 'showGuide', 'isZoomed', 'isIE11', 'isPhantom', 'companyLogo', 'publishURL', 'galleryImages', 'galleryCaptions', 'isDoublePage', 'audioURL'])),
  mounted: function mounted() {
    var _this = this;

    // console.log('mounted app component')
    this.setTitle();
    this.setDescription();
    if (this.publishURL != '') this.setOGImage();
    if (!(this.isMobile && this.mobileSwitch || this.isPhantom)) {
      this.loadScripts();
      window.addEventListener("load", function (event) {
        var p = parseInt(Publish.currentPage.pageIndex);
        var s = parseInt(Publish.currentPage.sectionIndex);
        if (window["p" + p + "s" + s + "onPageEnter"]) {
          window["p" + p + "s" + s + "onPageEnter"]();
        }
      });
      this.buildSearchIndex();
      this.resetSectionIndices();
    }
    if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
      this.setInitialWindowSize({
        width: screen.height,
        height: screen.width - 60
      });
      this.changeWindowSize({
        width: screen.height,
        height: screen.width - 60
      });
    } else if (document.documentElement.dataset.mobile == "android") {
      this.setInitialWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
      this.changeWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
    } else {
      this.changeWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    window.addEventListener("orientationchange", function () {
      if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
        _this.setInitialWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
        _this.changeWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
      } else {
        _this.setInitialWindowSize({
          width: screen.width,
          height: screen.height
        });
        _this.changeWindowSize({
          width: screen.width,
          height: screen.height
        });
      }
    });
  },

  watch: {
    currentPage: function currentPage(oldPage, newPage) {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
    }
  },
  methods: extends_default()({
    setTitle: function setTitle() {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
      var meta = document.createElement('meta');
      meta.name = "og:title";
      meta.content = newTitle;
      meta.setAttribute('property', 'og:title');
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    setDescription: function setDescription() {
      var newDescription = this.description;
      if (this.currentPage.searchText && this.currentPage.searchText.length > 0) {
        newDescription = this.currentPage.searchText.substr(0, 250);
      }
      var meta = document.createElement('meta');
      meta.name = "description";
      meta.content = newDescription;
      document.getElementsByTagName('head')[0].appendChild(meta);
      var og = document.createElement('meta');
      og.name = "og:description";
      og.content = newDescription;
      og.setAttribute('property', 'og:description');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    setOGImage: function setOGImage() {
      var og = document.createElement('meta');
      og.name = "og:image";
      og.content = this.publishURL + (this.currentPage.index + 1) + '.png';
      og.setAttribute('property', 'og:image');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    buildSearchIndex: function buildSearchIndex() {
      window.search = new commonjs["Search"]('id');
      window.search.searchIndex = new commonjs["UnorderedSearchIndex"]();
      window.search.addIndex('title');
      window.search.addIndex('body');
      window.search.addDocuments(this.searchObject);
    },
    loadScripts: function loadScripts() {
      this.loadDocumentScript();
      this.loadPageScript();
      this.loadAddThis();
    },
    loadDocumentScript: function loadDocumentScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.documentScript);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadPageScript: function loadPageScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.pageScripts);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadAddThis: function loadAddThis() {
      if (!this.isMobile) {
        var addthisScript = document.createElement('script');
        addthisScript.setAttribute('src', 'https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5a2eb48d8548953f');
        document.body.appendChild(addthisScript);
      }
    }
  }, Object(vuex_esm["b" /* mapActions */])(['goToPage', 'goToNextPage', 'goToPreviousPage', 'goToNextSection', 'goToPreviousSection', 'resetSectionIndices', 'checkMobileLanding', 'goToPreviousMobilePage', 'goToNextMobilePage', 'changeWindowSize', 'setInitialWindowSize']), {
    onLeave: function onLeave(el) {
      el.style.opacity = 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b3078df0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{class:{'right-to-left': _vm.rightToLeft, 'mobile': _vm.isMobile, 'zoomed': _vm.isZoomed, 'mobile-switch': _vm.mobileSwitch, 'ie11': _vm.isIE11, 'reader': _vm.isReader, 'doublePage': _vm.isDoublePage},attrs:{"id":"app"}},[(_vm.isPhantom)?[_c('img',{staticClass:"logo-loading centre",attrs:{"src":_vm.companyLogo,"alt":""}})]:[_c('navigation-bar',{attrs:{"title":_vm.title,"page":_vm.currentPage.title}}),_vm._v(" "),((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader)?[_c('mobile-container'),_vm._v(" "),(_vm.isReader)?[(_vm.previousMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToPreviousMobilePage,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToNextMobilePage,"classes":"navigation-link--next"}}):_vm._e()]:_vm._e()]:[_c('transition-group',{style:(_vm.pageContainerStyle),attrs:{"name":"pages","tag":"div","id":"page-container"},on:{"leave":_vm.onLeave}},[_c('page-dots',{key:"page-dots"}),_vm._v(" "),_vm._l((_vm.visiblePages),function(page,key){return (page)?_c('publish-page',{key:page.pageIndex + 'a' + page.sectionIndex,attrs:{"classes":key,"page":page,"width":_vm.width,"height":_vm.height}}):_vm._e()})],2),_vm._v(" "),((_vm.isMobile && !_vm.isDoublePage))?void 0:[(_vm.previousPageURI)?_c('navigation-link',{attrs:{"to":_vm.previousPageURI,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.previousSectionURI)?_c('navigation-link',{attrs:{"to":_vm.previousSectionURI,"rotation":"270","classes":"navigation-link--up"}}):_vm._e(),_vm._v(" "),(_vm.nextPageURI)?_c('navigation-link',{attrs:{"to":_vm.nextPageURI,"classes":"navigation-link--next"}}):_vm._e(),_vm._v(" "),(_vm.nextSectionURI)?_c('navigation-link',{attrs:{"to":_vm.nextSectionURI,"rotation":"90","classes":"navigation-link--down"}}):_vm._e()],_vm._v(" "),_c('contents-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}]}),_vm._v(" "),_c('search-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSearch),expression:"showSearch"}]}),_vm._v(" "),_c('guide-container',{directives:[{name:"show",rawName:"v-show",value:(_vm.showGuide),expression:"showGuide"}]}),_vm._v(" "),_vm._l((_vm.externalResources),function(resource){return (_vm.externalResources.length > 0)?_c('external-resource',{key:resource,attrs:{"source":resource}}):_vm._e()})]],_vm._v(" "),(_vm.videoURL != '')?_c('video-container'):_vm._e(),_vm._v(" "),(_vm.galleryImages.length)?_c('gallery-container'):_vm._e(),_vm._v(" "),(_vm.audioURL !=  '')?_c('audio-container'):_vm._e()],2)])}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("eBnN")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/store/mutation-types.js
// Toggles for panels/overlays/zoom
var TOGGLE_CONTENTS = 'TOGGLE_CONTENTS';
var TOGGLE_LANGUAGES = 'TOGGLE_LANGUAGES';
var TOGGLE_GUIDE = 'TOGGLE_GUIDE';

var TOGGLE_ZOOM = 'TOGGLE_ZOOM';
var UPDATE_ZOOM = 'UPDATE_ZOOM';

var TOGGLE_SEARCH = 'TOGGLE_SEARCH';
var TOGGLE_READER = 'TOGGLE_READER';

var RESET_SECTION_INDICES = 'RESET_SECTION_INDICES';
var CHANGE_SECTION_INDEX = 'CHANGE_SECTION_INDEX';
var UPDATE_INITIAL_WINDOW_SIZE = 'UPDATE_INITIAL_WINDOW_SIZE';
var UPDATE_PAGE_SCALE = 'UPDATE_PAGE_SCALE';
var UPDATE_VIDEO_URL = 'UPDATE_VIDEO_URL';
var UPDATE_AUDIO_URL = 'UPDATE_AUDIO_URL';
var UPDATE_IS_DOUBLE_PAGE = 'UPDATE_IS_DOUBLE_PAGE';
var UPDATE_GALLERY = 'UPDATE_GALLERY';
var UPDATE_GALLERY_INDEX = 'UPDATE_GALLERY_INDEX';
// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./src/document.js


var _ref;

/* harmony default export */ var src_document = ({
  "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
  "title": "Olympic Review - Issue 111",
  "shortTitle": "",
  "description": "",
  "width": 800,
  "height": 900,
  "currentLanguage": "EN",
  "languages": [{
    "code": "EN",
    "text": "English",
    "href": "http://olympicreview.touchlines.com/111"
  }, {
    "code": "FR",
    "text": "French",
    "href": "http://revueolympique.touchlines.com/111"
  }],
  // "basePath": "",
  "basePath": "/111",
  "companyLogo": "1-logo.png",
  "publishURL": "http://olympic-review.s3-website-eu-west-1.amazonaws.com/111/static/_thumbs/",
  "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
  "options": {
    "doublePage": true,
    "rightToLeft": false,
    "searchEnabled": true,
    "downloadEnabled": false,
    "downloadPath": '',
    "printEnabled": false,
    "zoomEnabled": true,
    "contentsEnabled": true,
    "languagesEnabled": true,
    "mobileSwitch": false,
    "guideEnabled": false,
    "galleryCaptions": {}
  },
  "pages": [[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 0,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg1.jpg",
    "zoom": null,
    "content": "\n      <img id=\"1-title\" class=\"halfScale\" style=\"top:14px;left:3px\" src=\"/111/static/_content/1-title.png\">\n      <img id=\"1-sub-1\" class=\"halfScale\" style=\"top:134px;left:501px\" src=\"/111/static/_content/1-sub-1.png\">\n      <img id=\"1-sub-2\" class=\"halfScale\" style=\"top:135px;left:16px\" src=\"/111/static/_content/1-sub-2.png\">\n      <img id=\"1-sub-3\" class=\"halfScale\" style=\"top:197px;left:265px\" src=\"/111/static/_content/1-sub-3.png\">\n      <img id=\"1-sub-4\" class=\"halfScale\" style=\"top:248px;left:277px\" src=\"/111/static/_content/1-sub-4.png\">\n      \n      <img id=\"1-logo\" class=\"halfScale\" style=\"top:812px;left:664px\" src=\"/111/static/_content/1-logo.png\">\n      <div class=\"addContentLink\" style=\"top:868px;left:664px;height:16px;width:120px;\">\n        <a href=\"http://www.olympic.org/en\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg1Anim = new TimelineMax();\n          pg1Anim.fromTo(idOf(\"1-title\"), 0.8, {opacity:0, y:-228},{opacity:1, y:0, ease: Power4.easeOut}, 1)\n          .fromTo(idOf(\"1-sub-1\"), 0.6, {opacity:0, x:80},{opacity:1, x:0, ease: Power2.easeOut}, \"-=0.3\")\n          .fromTo(idOf(\"1-sub-2\"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, \"-=0.4\")\n          .fromTo(idOf(\"1-sub-3\"), 0.6, {opacity:0, y:-80},{opacity:1, y:0, ease: Power2.easeOut}, \"-=0.3\")\n          .fromTo(idOf(\"1-sub-4\"), 0.6, {opacity:0, y:80},{opacity:1, y:0, ease: Power2.easeOut}, \"-=0.3\")\n          .fromTo(idOf(\"1-logo\"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut, addContentLinks}, \"-=0.3\")\n        }\n\n        function onPageLeave() {\n          pg1Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "OFFICIAL PUBLICATION OF THE OLYMPIC MOVEMENT APRIL-MAY-JUNE 2019 NUMBER 111  TOGETHER UNDER ONE ROOF THE IOC’S NEW HEADQUARTERS, OLYMPIC HOUSE, IS SET TO SERVE AS A MODEL OF SUSTAINABILITY, COLLABORATION AND OPERATIONAL EFFICIENCY  WWW.OLYMPIC.ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 1,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg2.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 2,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg3.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 3,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg4.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 4-title\" style=\"top:133px;left:66px\" src=\"/111/static/_content/4-title.png\">\n        <img class=\"halfScale 4-title\" style=\"top:181px;left:67px\" src=\"/111/static/_content/4-title-2.png\">\n        <img id=\"4-img\" class=\"halfScale\" style=\"top:239px;left:66px\" src=\"/111/static/_content/4-img-1.jpg\">\n        <img class=\"halfScale 4-imgs\" style=\"top:364px;left:67px\" src=\"/111/static/_content/4-img-2.jpg\">\n        <img class=\"halfScale 4-imgs\" style=\"top:487px;left:67px\" src=\"/111/static/_content/4-img-3.jpg\">\n        <img class=\"halfScale 4-imgs\" style=\"top:610px;left:67px\" src=\"/111/static/_content/4-img-4.jpg\">\n        <img class=\"halfScale 4-imgs\" style=\"top:733px;left:67px\" src=\"/111/static/_content/4-img-5.jpg\">\n\n\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(7)\" style=\"top:240px;left:67px;width:100px;height:100px\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(26)\" style=\"top:365px;left:67px;width:104px;height:98px\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(40)\" style=\"top:488px;left:67px;width:104px;height:98px\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(64)\" style=\"top:611px;left:67px;width:104px;height:98px\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(74)\" style=\"top:734px;left:67px;width:104px;height:98px\"></div>\n        \n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(7)\" style=\"top:237px;left:196px;width:101px;height:13px\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(8)\" style=\"top:272px;left:196px;width:99px;height:13px\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(12)\" style=\"top:308px;left:196px;width:69px;height:13px\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(24)\" style=\"top:344px;left:196px;width:169px;height:13px\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(26)\" style=\"top:393px;left:196px;width:262px;height:13px\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(40)\" style=\"top:451px;left:196px;width:142px;height:13px\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(52)\" style=\"top:499px;left:196px;width:174px;height:13px\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(58)\" style=\"top:546px;left:196px;width:204px;height:13px\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(64)\" style=\"top:595px;left:196px;width:196px;height:13px\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(70)\" style=\"top:642px;left:196px;width:247px;height:13px\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(74)\" style=\"top:690px;left:196px;width:107px;height:13px\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(78)\" style=\"top:737px;left:196px;width:158px;height:13px\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(81)\" style=\"top:774px;left:196px;width:112px;height:13px\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(82)\" style=\"top:809px;left:196px;width:112px;height:13px\"></div>\n\n        <div class=\"addContentLink\" style=\"top:701px;left:628px;width:56px;height:9px\">\n        <a href=\"http://www.olympic.org\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:710px;left:608px;width:88px;height:9px\">\n        <a href=\"mailto:olympicreview@olympic.org\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg4Anim = new TimelineMax();\n          pg4Anim.staggerFromTo(cOf(\"4-title\"), 0.8, {opacity:0, x:-80}, {opacity:1, x:0, ease: Power4.easeOut}, 0.4, 1)\n          .fromTo(idOf(\"4-img\"), 0.6, {opacity:0, x:-80}, {opacity:1, x:0, ease: Power2.easeOut}, \"-=0.4\")\n          .staggerFromTo(cOf(\"4-imgs\"), 0.6, {opacity:0, y:-120},{opacity:1, y:0, ease: Power2.easeOut}, 0.2, \"-=0.2\", addContentLinks)\n        }\n\n        function onPageLeave() {\n          pg4Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "OLYMPIC REVIEW  CONTENTS OFFICIAL PUBLICATION OF THE OLYMPIC MOVEMENT APRIL-MAY-JUNE 2019  7 FOREWORD By IOC President Thomas Bach.  8 SNAPSHOT Eye-catching sporting images from the past quarter.  The latest news and events from around the Olympic Movement.  24 BEYOND THE RINGS Jan Ammundsen, Head of Design at 3XN Architects, describes how his company worked with the IOC to create Olympic House.  26 COVER STORY: OLYMPIC HOUSE We look at how the new headquarters will bring all the IOC’s staff together under one roof, while serving as a model of sustainability, collaboration and operational efficiency.  40 THE IOC AT 125 On the 125th anniversary of the IOC, Olympic Review traces the history of the organisation and looks at how its values remain as relevant as ever.  52 THROUGH THE LENS We take a pictorial look through the history of Olympic Day, which was first celebrated in 1948 and continues to be recognised in all corners of the globe.  58 CANDIDATE CITIES 2026 Stockholm-Åre and Milan-Cortina on their sustainability and legacy plans ahead of the vote to decide the host of the Olympic Winter Games 2026.  64 TOKYO 2020 VISION French surfing star and IOC Clean Seas Ambassador Justine Dupont speaks about her excitement for the sport’s Olympic debut in Japan.  70 INSIDE THE OLYMPIC CHANNEL German weightlifting champion Matthias Steiner features in the Olympic Channel’s second series of Legends Live On.  74 MY GAMES Swiss ski racer and downhill course designer Bernhard Russi reflects on his Olympic experiences.  78 OLYMPIC STUDIES News and book reviews from the IOC Olympic Studies Centre.  81 OBITUARIES Olympians and figures from the Olympic Movement who have passed away.  82 FAST FACTS Facts and figures about Olympic House.  4 OLYMPIC REVIEW  EXECUTIVE BOARD President Thomas Bach Vice-Presidents Juan Antonio Samaranch, Uğur Erdener, Anita L. DeFrantz, Zaiqing Yu Members Gunilla Lindberg, Sergey Bubka, Ser Miang Ng, Willi Kaltschmitt Luján, Robin E. Mitchell, Nicole Hoevertsz, Denis Oswald, Nenad Lalović, Kirsty Coventry, Ivo Ferriani OLYMPIC REVIEW Strategic Communications Director, a.i. Christian Klaue Editor-in-Chief Katharine Mann French Edition Karin Reiss Spanish Edition Dolores Blázquez Production Agency Touchline Production Michael Stoneman, Glyn Wilmshurst, John Murray, Sam Price, Gruffudd Owen, Daniel Gardre Design John Paul Yetton, Vanesha Ramdoyal, Liz Rankin, Ana Burmester Image retouching Jason Dutch Translation Denis Echard, Héctor López Conceiro, Libero Language Lab Proofreading Libero Language Lab ISSN: 0377-192X Printed in the UK IMAGES Cover image: IOC/ Luca Delachaux. Inside: IOC; IOC/ Alexander Hassenstein; IOC/ Greg Martin; IOC/ Christophe Moratal; IOC/ Luca Delachaux; IOC/ Catherine Leutenegger; IOC/ Fabrice Coffrini; IOC/ Franck Fife; IOC/ Charles Meadows; Getty Images; Olympic Channel; 3XN Architects; WSL/ Masurel; ISA; Xabi Barreneche/ Red Bull; Hugo Silva/ Red Bull; Diego Gaspari Bandion; Municipality of Milan; Robert Henriksson/ TT; Jonas Ekströmer/ TT; Mattias Fredriksson/ TT; Flexyfit Sports Academy. CONTACTS Please send your letters to: Olympic Review, IOC Strategic Communications Department, Château de Vidy, 1007 Lausanne, Switzerland website: www.olympic.org email: olympicreview@olympic.org tel +41 (0)21 621 6111 Olympic Review uses PEFCcertified paper stock sourced from sustainably managed forests. Olympic Review is published by the International Olympic Committee. The articles published in Olympic Review do not necessarily reflect the opinions of the International Olympic Committee. No articles may be reproduced without the permission of the IOC Strategic Communications Department.  All information correct at the time of going to press  12 NEWS"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 4,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg5.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Pictured Tug of war at the Olympic Games Antwerp 1920. Read about the history of the IOC from page 40"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 5,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg6.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 6,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg7.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 7-title\" style=\"top:459px;left:150px\" src=\"/111/static/_content/7-title.png\">\n        <img class=\"halfScale 7-title\" style=\"top:548px;left:150px\" src=\"/111/static/_content/7-sub.png\">\n       \n        <div id=\"7-sig\" class=\"abs noOverflow\" style=\"top:801px;left:581px;height:33px;width:123px\">\n          <img class=\"halfScale\" src=\"/111/static/_content/7-sig.png\">\n        </div>\n\n        <img id=\"7-ctr\" style=\"top:468px;left:41px;cursor:pointer;\" onclick=\"pg7show();\" src=\"/111/static/_content/clicktoread.png\">\n        \n        <div id=\"pg7read\" class=\"d-hidden\">\n          <img id=\"pg7close\" onclick=\"pg7readclose();\" src=\"/111/static/_content/x-button.png\">\n          <p>\n            The Olympic Day celebrations this year hold a special significance for the Olympic Movement, as it marks the 125th anniversary of the creation of the International Olympic Committee (IOC) in1894 by our founder Pierre de Coubertin.\n          </p>\n          <p>\n            Coubertin, the young French educator with big ideas, was perhaps ahead of his time with his vision of the Olympic Games as a way to bring together all people of he world in peaceful competition. In fact, his ideas ran counter to the prevailing spirit of his times, dominated by aggressive nationalism and imperialism. But Coubertin never gave up on his Olympic dream, convinced that bringing people together through sport would help bring more understanding and promote peace between nations.\n          </p>\n          <p>\n            Fast-forward to 2019. As the IOC celebrates 125 years since its founding, it is striking how the values that Coubertin established in 1894 are still very much applicable in today\u2019s world. It is a testament to the enduring values that are at the heart of our mission.\n          </p>\n          <p>\n            One hundred and twenty-five years is an impressive age for any organisation, but even more so when we consider the tumultuous times that have accompanied the IOC since it was established. To me, the endurance of the IOC and the Olympic Games stems from the fact that from the very beginning, Coubertin saw sport and its values of peace and friendship as inherently linked. It is because of these timeless values that our mission, to make the world a better place through sport, continues to be relevant today.\n          </p>\n          <p>\n            Another important milestone to coincide with Olympic Day and the 125th anniversary will be the inauguration of Olympic House, the new headquarters of the IOC. Seven years after the decision was taken to consolidate all IOC offices in Lausanne under one roof, Olympic House opens its doors on 23 June, in a fitting culmination of the anniversary celebrations.\n          </p>\n          <p>\n            More than just simply another office building, Olympic House is intended as a symbol and embodiment of our values and mission. The design of the building, which is inspired by the movement of an athlete, is intended to reflect fluidity and agility \u2013 both important qualities of any organisation \u2013 while the dove form visible from above is the universal symbol of peace, one of the most important values that defines our Olympic Movement.\n          </p>\n          <p>\n            Sustainability is another core value that we wanted to incorporate in the building. This is why the building has been constructed according to the highest sustainability standards. The electricity generated by the solar panels on the roof will allow the building to be self-sufficient in terms of its heating, ventilation, cooling and hot water system.\n          </p>\n          <p>\n            Transparency is a key element of many of our Olympic Agenda 2020 reforms around governance. This is reflected in the building through its glass facades and open office spaces. The design is intended to make the building welcoming and also reflect the IOC\u2019s spirit of transparency.\n          </p>\n          <p>\n            This edition of Olympic Review traces both the remarkable history of the IOC over its 125 years of existence in the modern era and the journey of Olympic House. The two are intimately interwoven. It comes at a pivotal moment in the life of the IOC and the Olympic Movement and one from which we look forward to the future with optimism.\n          </p>\n        </div>\n      \n      ",
    "script": "\n      function onPageEnter() {\n        pg7Anim = new TimelineMax();\n        pg7Anim.staggerFromTo(cOf(\"7-title\"), 0.8, {opacity:0, x:-80}, {opacity:1, x:0, ease: Power4.easeOut}, 0.4, 1)\n        .fromTo(idOf(\"7-sig\"), 0.6, {width:\"0px\"}, {width:\"123px\", ease: Power2.easeOut}, \"-=0.4\")\n        .fromTo(idOf(\"7-ctr\"), 0.6, {opacity:0}, {opacity:1, ease: Power2.easeOut}, \"-=0.4\")\n      }\n\n      function pg7show() {\n        var k =  document.getElementById(\"pg7read\")\n        k.className = \"readOverlay visible\"\n      }\n\n      function pg7readclose() {\n        var k =  document.getElementById(\"pg7read\")\n        k.className = \"d-hidden\"\n      }\n\n      function onPageLeave() {\n        pg7readclose();\n        pg7Anim.stop();\n      }\n      ",
    "searchText": "FOREWORD  FOREWORD BY THOMAS BACH PRESIDENT, INTERNATIONAL OLYMPIC COMMITTEE  T  Above Olympic House draws on the IOC’s rich heritage while looking to the future  he Olympic Day celebrations this year hold a special significance for the Olympic Movement, as it marks the 125th anniversary of the creation of the International Olympic Committee (IOC) in 1894 by our founder Pierre de Coubertin. Coubertin, the young French educator with big ideas, was perhaps ahead of his time with his vision of the Olympic Games as a way to bring together all people of the world in peaceful competition. In fact, his ideas ran counter to the prevailing spirit of his times, dominated by aggressive nationalism and imperialism. But Coubertin never gave up on his Olympic dream, convinced that bringing people together through sport would help bring more understanding and promote peace between nations.  Fast-forward to 2019. As the IOC celebrates 125 years since its founding, it is striking how the values that Coubertin established in 1894 are still very much applicable in today’s world. It is a testament to the enduring values that are at the heart of our mission. One hundred and twenty-five years is an impressive age for any organisation, but even more so when we consider the tumultuous times that have accompanied the IOC since it was established. To me, the endurance of the IOC and the Olympic Games stems from the fact that from the very beginning, Coubertin saw sport and its values of peace and friendship as inherently linked. It is because of these timeless values that our mission, to make the world a better place through sport, continues to be relevant today.  Another important milestone to coincide with Olympic Day and the 125th anniversary will be the inauguration of Olympic House, the new headquarters of the IOC. Seven years after the decision was taken to consolidate all IOC offices in Lausanne under one roof, Olympic House opens its doors on 23 June, in a fitting culmination of the anniversary celebrations. More than just simply another office building, Olympic House is intended as a symbol and embodiment of our values and mission. The design of the building, which is inspired by the movement of an athlete, is intended to reflect fluidity and agility – both important qualities of any organisation – while the dove form visible from above is the universal symbol of peace, one of the most important values that defines our Olympic Movement. Sustainability is another core value that we wanted to incorporate in the building. This is why the building has been constructed according to the highest sustainability standards. The electricity generated by the solar panels on the roof will allow the building to be self-sufficient in terms of its heating, ventilation, cooling and hot water system. Transparency is a key element of many of our Olympic Agenda 2020 reforms around governance. This is reflected in the building through its glass facades and open office spaces. The design is intended to make the building welcoming and also reflect the IOC’s spirit of transparency. This edition of Olympic Review traces both the remarkable history of the IOC over its 125 years of existence in the modern era and the journey of Olympic House. The two are intimately interwoven. It comes at a pivotal moment in the life of the IOC and the Olympic Movement and one from which we look forward to the future with optimism. ■  OLYMPIC REVIEW 7"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 7,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg8.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 8,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg9.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SNAPSHOT  16/03/2019 BIATHLON  Athletes round a bend during the IBU Biathlon World Championships men’s relay at the Swedish National Biathlon Arena in Östersund. Norway won the event, with Germany and Russia second and third respectively. Norway also finished top of the overall medal table with nine medals, followed by Germany and Italy. Photo: Getty Images / Bongarts"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 9,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg10.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SNAPSHOT  15/04/2019 ATHLETICS  Kenya’s Lawrence Cherono crosses the finish line first at the 2019 Boston Marathon (USA), just two seconds ahead of Lelisa Desisa of Ethiopia in the closest finish to the men’s race since 2000. Meanwhile, the women’s race was won by Ethiopia’s Worknesh Degefa who, like Cherono, was claiming her first victory in a major marathon. Photo: Getty Images / Boston Globe"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 10,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg11.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "RECORDING O LYM P I C D R E A M S  Since 1932, OMEGA has known that the Olympic Games is a stage for dedicated athletes to reach their dreams. That’s why we’re so passionate about providing trusted precision in every single event."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 11,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg12.jpg",
    "zoom": null,
    "content": "\n        <div class=\"abs noOverflow\" style=\"top:477px;left:66px;width:454px;height:54px\">\n          <img class=\"halfScale\" id=\"12-title-1\" src=\"/111/static/_content/12-title-1.png\">\n        </div>\n        <div class=\"abs noOverflow\" style=\"top:345px;left:603px;width:124px;height:53px\">\n          <img class=\"halfScale\" id=\"12-title-2\" src=\"/111/static/_content/12-title-2.png\">\n        </div>\n\n        <a href=\"https://www.olympic.org/news/ioc-awards-2019-women-and-sport-trophies-to-gender-equality-advocates\" target=\"_blank\">\n          <div class=\"addContentLink\" style=\"top:472px;left:62px;width:456px;height:49px\"></div>\n        </a>\n        \n        <a href=\"https://tokyo2020.org/en\" target=\"_blank\">\n          <div class=\"addContentLink\" style=\"top:615px;left:637px;width:57px;height:13px\"></div>\n        </a>\n\n        <a href=\"https://www.youtube.com/watch?v=nc17klNeGBc\" target=\"_blank\">\n          <div class=\"addContentLink\" style=\"top:701px;left:602px;width:133px;height:24px\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg12Anim = new TimelineMax();\n          pg12Anim.fromTo(idOf(\"12-title-1\"), 0.6, {y:60}, {y:0, ease: Power2.easeOut}, 1)\n                  .fromTo(idOf(\"12-title-2\"), 0.6, {y:60}, {y:0, ease: Power2.easeOut, onComplete: addContentLinks}, \"-=0.2\")\n        }\n    \n        function onPageLeave() {\n          pg12Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "IOC PRESIDENT VISITS UN IN NEW YORK  2019 IOC WOMEN AND SPORT AWARDS FOR SIX ROLE MODELS On 19 March, the International Olympic Committee (IOC) celebrated six role models and change-makers in advancing women and girls in and through sport. In partnership with UN Women, a dedicated awards ceremony was held on the sidelines of the Commission on the Status of Women at the United Nations (UN) headquarters in New York (USA). International baseball umpire Ms Po Chun Liu was awarded the World Trophy for her staunch advocacy for female empowerment through sport. Liu’s determination saw her progress from a grassroots volunteer to the first female baseball umpire in her native Chinese Taipei, and she has  12 OLYMPIC REVIEW  worked relentlessly to create opportunities for girls and women to get involved in sport. Five Continental Trophies were awarded to Ms Djatougbe 'Nathalie' Noameshie (Togo), receiving the award for Africa; the Comisión Mujer y deporte de Costa Rica, for the Americas; Ms Saada Al-Ismaili (Oman) for Asia; Ms Morana Paliković Gruden (Croatia) for Europe; and the Vanuatu Volleyball Federation for Oceania. Attendees at the ceremony included IOC President Thomas Bach, UN Women Executive Director and UN UnderSecretary-General Phumzile Mlambo-Ngcuka, and UN Women Goodwill Ambassador, Olympian and renowned  Brazilian footballer Marta Vieira da Silva, who delivered a very personal speech on the power of sport to change lives. IOC President Thomas Bach congratulated the winners on their achievements and said: “The Women and Sport Awards are very important because these personalities we are honouring have shown what can be achieved by empowering women and girls through sport. The awardees bring about change not only on the field of play, but also in the workplace, at home, in schools and in other areas of society.” Above The IOC Women and Sport award winners with President Bach  On 19 March, IOC President Thomas Bach met with UN Secretary-General, António Guterres, in New York (USA). The UN Secretary-General expressed the commitment of the UN to working with the IOC for a better and more peaceful world through sport, adding that the UN appreciated the work done by the IOC with regards to peace on the Korean Peninsula. President Bach updated him on the latest developments with regards to the planned joint participation of South and North Korean athletes at the Olympic Games Tokyo 2020, and also on the potential joint candidature for the Olympic Games 2032. President Bach was also able to inform him of the progress towards a Refugee Olympic Team in Tokyo, following the successful Refugee Olympic Team at Rio 2016. In addition, IOC Member Luis Moreno was presented as the IOC’s new permanent observer at the UN, following in the footsteps of Mario Pescante. Above President Bach with UN Secretary-General António Guterres in New York"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 12,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg13.jpg",
    "zoom": null,
    "content": "\n        <div class=\"abs noOverflow\" style=\"top:187px;left:50px;width:634px;height:52px\">\n          <img class=\"halfScale\" id=\"13-title-1\" src=\"/111/static/_content/13-title-1.png\">\n        </div>\n\n        <a href=\"https://www.olympic.org/athlete365/voice/42857/\" target=\"_blank\">\n          <div class=\"addContentLink\" style=\"top:251px;left:48px;width:514px;height:293px\"></div>\n        </a>\n        <a href=\"https://www.olympic.org/athlete365/business-accelerator/\" target=\"_blank\">\n          <div class=\"addContentLink\" style=\"top:566px;left:587px;width:97px;height:13px\"></div>\n        </a>\n        <a href=\"https://www.olympic.org/athlete365/business-accelerator/\" target=\"_blank\">\n          <div class=\"addContentLink\" style=\"top:579px;left:571px;width:56px;height:13px\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg13Anim = new TimelineMax();\n          pg13Anim.fromTo(idOf(\"13-title-1\"), 0.6, {y:60}, {y:0, ease: Power2.easeOut, onComplete: addContentLinks}, 1)\n        }\n    \n        function onPageLeave() {\n          pg13Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "BIGGEST-EVER INTERNATIONAL ATHLETES’ FORUM COMMITS TO INCREASED SUPPORT FOR ATHLETES • To strengthen athletes’ representation; • To strengthen the solidarity funding model; • To strengthen direct financial support for NOC Athletes’ Commissions; • To strengthen the support for career transition; • To strengthen the protection of clean athletes and the fight against doping; • To focus on athletes’ mental health; • Support for the Athletes’ Declaration • To invite athletes to be ambassadors for the Olympic Movement; • To foster engagement and communication among the Athletes’ Commissions’ network.  Between 12-14 April, some 350 athlete representatives from 185 National Olympic Committees (NOCs), 50 International Federations (IFs), five Continental Athletes Commissions (ACs), the ACs of all the Organising Committees of the upcoming Olympic Games, the International Paralympic Committee, the World Anti-Doping Agency and the World Olympians Association met in Lausanne for the ninth edition of the International Athletes’ Forum (IAF). It was the biggest-ever gathering of official athlete representatives, to which athletes from all 206 NOCs were invited. Also in attendance was IOC President Thomas Bach, member of the first IOC AC in 1981. “This IAF was empowering, exciting and unifying,” highlighted  Kirsty Coventry, IOC AC Chair, who was unable to attend as she was about to give birth to her first child, but joined the Forum online. “We had a very fruitful meeting,” said IOC AC vice-chair Danka Barteková, who led discussions in the absence of Coventry. “The IOC Athletes’ Commission will take the proposals to the IOC Executive Board, where we are directly represented. “The IOC President has told me in our discussions during the Forum that he will fully support our recommendations. We look forward to their implementation, which will ensure that the support for athletes at all levels is improved even further  and the solidarity model of the Olympic Games is reinforced for the benefit of all athletes.” Discussions produced a set of recommendations, which were unanimously supported in a vote during the closing session. The nine recommendations of the Forum were as follows:  Also recommended was strengthening the support for career transition through the Athlete365 Business Accelerator, which aims to support athletes with dual careers or those transitioning from their athletic careers by helping them develop their business ideas by working with experts in the field.  Pictured The Forum included breakout sessions, panel discussions and presentations  OLYMPIC REVIEW 13"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 13,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg14.jpg",
    "zoom": null,
    "content": "\n        <div class=\"abs noOverflow\" style=\"top:345px;left:241px;width:284px;height:65px\">\n          <img class=\"halfScale\" id=\"14-title-1\" src=\"/111/static/_content/14-title-1.png\">\n        </div>\n        <div class=\"abs noOverflow\" style=\"top:309px;left:67px;width:151px;height:52px\">\n          <img class=\"halfScale\" id=\"14-title-2\" src=\"/111/static/_content/14-title-2.png\">\n        </div>\n        <div class=\"abs noOverflow\" style=\"top:701px;left:67px;width:364px;height:40px\">\n          <img class=\"halfScale\" id=\"14-title-3\" src=\"/111/static/_content/14-title-3.png\">\n        </div>\n        <div class=\"abs noOverflow\" style=\"top:188px;left:604px;width:154px;height:52px\">\n          <img class=\"halfScale\" id=\"14-title-4\" src=\"/111/static/_content/14-title-4.png\">\n        </div>\n\n        <a href=\"https://stillmed.olympic.org/media/Document%20Library/OlympicOrg/IOC/What-We-Do/celebrate-olympic-games/Sustainability/Olympic-Games-Guide-on-Sustainable-Sourcing-2019.pdf\" target=\"_blank\">\n          <div class=\"addContentLink\" style=\"top:321px;left:63px;width:155px;height:29px\"></div>\n        </a>\n        <a href=\"https://bjsm.bmj.com/content/53/11/667\" target=\"_blank\">\n          <div class=\"addContentLink\" style=\"top:361px;left:238px;width:221px;height:19px\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg14Anim = new TimelineMax();\n          pg14Anim.fromTo(idOf(\"14-title-1\"), 0.6, {y:70}, {y:0, ease: Power2.easeOut}, 1)\n                  .fromTo(idOf(\"14-title-2\"), 0.6, {y:60}, {y:0, ease: Power2.easeOut}, \"-=0.3\")\n                  .fromTo(idOf(\"14-title-3\"), 0.6, {y:45}, {y:0, ease: Power2.easeOut}, \"-=0.3\")\n                  .fromTo(idOf(\"14-title-4\"), 0.6, {y:60}, {y:0, ease: Power2.easeOut, onComplete: addContentLinks}, \"-=0.3\")\n        }\n    \n        function onPageLeave() {\n          pg14Anim.stop();\n          removeContentLinks()\n        }\n      ",
    "searchText": "RESEARCH SHOWS STRENGTH OF THE OLYMPIC VALUES  IOC PRODUCES SUSTAINABLE SOURCING GUIDES On 22 April, the IOC released two guides that will help the Organising Committees for the Olympic Games and the Olympic Movement source goods and services in a way that results in positive social, environmental, ethical and economic outcomes. The publications add to the IOC’s series of sustainability guides. They complement the IOC’s own Supplier Code, which outlines the requirements related to human rights, labour conditions, waste management, transport and ethics. “We hope that these new guides will help the Olympic Games organisers and the sports sector at large adopt a more sustainable approach, and become an inspiration and a role model for others,” said Michelle Lemaitre, IOC Head of Sustainability.  IOC PUBLISHES CONSENSUS PAPER ON ATHLETE MENTAL HEALTH Addressing the multifaceted aspects of mental health symptoms and disorders in elite athletes, the IOC Medical and Scientific Commission has published a consensus paper on mental health in the British Journal of Sports Medicine (BJSM). It was written by an IOC Consensus Group coordinated by the commission, made up of 20 experts from different professions and countries. “Mental health disorders can impair performances and increase the risk of physical Above Panel discussion on mental health at the International Athletes’ Forum  injuries,” said Professor Uğur Erdener, IOC VicePresident and chair of the IOC Medical and Scientific Commission. “There is no evidence to suggest that mental health symptoms and disorders are more prevalent in elite athletes, but it is estimated that a significant number of elite athletes are affected.” The paper is aimed at sports medicine physicians and clinicians, psychiatrists, researchers, as well as other mental health and performance professionals who work with elite athletes, and clinical stakeholders in sport.  NEW IOC-SUPPORTED GUIDE FOCUSES ON SUSTAINABLE VENUES AND FACILITIES A new guide developed by the International Union for Conservation of Nature (IUCN), in partnership with the IOC, outlines how the careful planning, location and design of new sports venues and facilities can help avoid  14 OLYMPIC REVIEW  potential negative impacts on nature – and even contribute to its conservation. Titled “Sport and Biodiversity: Guidelines for mitigating biodiversity impacts of new sports venues”, the guide was  released at the UN Environment Assembly that took place in March in Nairobi, Kenya. It offers the global sports sector detailed guidance on how to integrate biodiversity considerations into the development of sports venues.  The Olympic rings remain one of the world’s most widely recognised symbols, with nine out of 10 people correctly identifying the symbol, according to research conducted following the Olympic Winter Games PyeongChang 2018. The Olympic rings outperformed other globally recognised symbols across a range of values, including “global”, “diversity”, “heritage and tradition”, and “inspirational”, as well as the Olympic values of “excellence” and “friendship”. With regard to the IOC, respondents identified “promoting peace through sport” as the organisation’s most important role, followed by “promoting sport and its benefits, including a better quality of life, for all”, “running global initiatives, which mix culture and sport, to improve people's understanding of the Olympic ideals”, “social development through sport” and “leading the Olympic Movement”. The research also demonstrated that the Olympic Games continue to be the most appealing sports and entertainment property in the world. Some 93 per cent of respondents were aware of the Games – more than any other major sporting or entertainment event. The Games also scored highest for appeal, with a mean rating of 7.5 out of 10. The major global study, conducted by Publicis Sport & Entertainment in March 2018, surveyed 36,000 people in total."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 14,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg15.jpg",
    "zoom": null,
    "content": "\n        <div class=\"abs noOverflow\" style=\"top:189px;left:50px;width:504px;height:50px\">\n          <img class=\"halfScale\" id=\"15-title-1\" src=\"/111/static/_content/15-title-1.png\">\n        </div>\n        <div class=\"abs noOverflow\" style=\"top:346px;left:587px;width:131px;height:52px\">\n          <img class=\"halfScale\" id=\"15-title-2\" src=\"/111/static/_content/15-title-2.png\">\n        </div>\n\n        <a href=\"https://www.olympic.org/news/levelling-the-field-a-snapshot-of-how-the-ioc-is-advancing-gender-equality-in-sport\" target=\"_blank\">\n          <div class=\"addContentLink\" style=\"top:313px;left:233px;width:84px;height:13px\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg15Anim = new TimelineMax();\n          pg15Anim.fromTo(idOf(\"15-title-1\"), 0.6, {y:55}, {y:0, ease: Power2.easeOut}, 1)\n                  .fromTo(idOf(\"15-title-2\"), 0.6, {y:60}, {y:0, ease: Power2.easeOut, onComplete: addContentLinks}, \"-=0.3\")\n        }\n    \n        function onPageLeave() {\n          pg15Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "FEMALE AND YOUTH MEMBERSHIP OF IOC COMMISSIONS AT AN ALL-TIME HIGH On 15 May, the IOC announced the composition of its commissions for 2019. Most significantly, the composition is marked by further growth in female membership, three additional female chairs and an increase in Young Change-Makers’ (YCMs) participation within IOC comissions. With 45.4 per cent of the positions across its 27 commissions now occupied by women – an historic high – the IOC continues its advance  towards gender equality. As a result of Olympic Agenda 2020, female participation in the IOC commissions has more than doubled since 2013. “Gender equality, both on and off the field of play, is one of the key focus areas of Olympic Agenda 2020,” said IOC President Thomas Bach. “With the number of female athletes participating at the Olympic Games, we are practically there for Tokyo 2020. Off the field of play, we will continue our  efforts, but we are very proud of having reached such strong female and youth participation in a very short time.” Honouring his commitment made during the Youth Summit in Tokyo last December, President Bach has also increased the positions held by YCMs across the IOC commissions, from seven in 2018 to 16 in 2019. Below President Bach speaks to some Young Change-Makers at last year’s Youth Summit in Tokyo  FOUR NGOS AWARDED GRANTS BY IOC On 6 April, Terres en Mêlées, FundLife International, Altus Sport, and Cross Cultures Project Association North Macedonia were announced as the latest recipients of the IOC’s Sport and Active Society development grants for 2019. The projects that received the grants reflect the key values celebrated by the International Day of Sport for Development and Peace (IDSDP). Every year, the Sport and Active Society Commission selects a series of grassroots organisations across the world – which are using sport and physical activity as a means to tackle key social issues – to receive its development grants, worth CHF 20,000 each. This year, the four grants on offer were based on the themes of social inclusion of refugees through sport; promoting gender equality at all levels of sport; bringing sport and physical activity to the urban setting; and engaging youth and the elderly in physical activities. Above The four grants were awarded by the IOC on the occasion of the IDSDP  OLYMPIC REVIEW 15"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 15,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg16.jpg",
    "zoom": null,
    "content": "\n        <div class=\"abs noOverflow\" style=\"top:187px;left:263px;width:404px;height:53px\">\n          <img class=\"halfScale\" id=\"16-title-1\" src=\"/111/static/_content/16-title-1.png\">\n        </div>\n        <div class=\"abs noOverflow\" style=\"top:369px;left:66px;width:126px;height:52px\">\n          <img class=\"halfScale\" id=\"16-title-2\" src=\"/111/static/_content/16-title-2.png\">\n        </div>\n        <a href=\"https://www.youtube.com/watch?v=_gqFJARlVAE\" target=\"_blank\">\n          <svg class=\"abs pulse animatedpulse pointer\" style=\"width:30px; height:30px;left:178px;top:382px\" version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"675px\" height=\"675px\" viewBox=\"0 0 675 675\" enable-background=\"new 0 0 675 675\" xml:space=\"preserve\">\n            <circle fill=\"none\" stroke=\"#000\" stroke-width=\"30\" stroke-miterlimit=\"10\" cx=\"339.195\" cy=\"340\" r=\"321\"/>\n            <polyline fill=\"#000\" points=\"558,356 207,563 207,117 \"/>\n          </svg>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg16Anim = new TimelineMax();\n          pg16Anim.fromTo(idOf(\"16-title-1\"), 0.6, {y:55}, {y:0, ease: Power2.easeOut}, 1)\n                  .fromTo(idOf(\"16-title-2\"), 0.6, {y:55}, {y:0, ease: Power2.easeOut}, \"-=0.3\")\n        }\n    \n        function onPageLeave() {\n          pg16Anim.stop();\n        }\n      ",
    "searchText": "SONY PICTURES NETWORKS INDIA TO SHOW TOKYO 2020  IOC PRESIDENT VISITS NOCS IN OCEANIA On 11 May, IOC President Thomas Bach wrapped up a tour of the NOCs of three islands in Oceania with a stop in Guam. After a gala dinner as the guest of the NOC and its President Rick Blas, he visited the governor of the island, Lourdes Leon Guerrero. The two leaders discussed the benefits of sport for health and education, and also the development of Olympic sport on the island. This followed two days spent in the island republic of Palau, where President Bach visited several sports facilities and was invited to address Congress, and a day in Papua New Guinea as a guest of the NOC. President Bach met young athletes at the impressive Taurama Aquatic & Indoor Centre in the capital, Port Moresby, joining in with basketball and badminton practice before passing on some fencing know-how. Above President Bach joined in with a number of sports activities in Papua New Guinea  16 OLYMPIC REVIEW  On 14 March, the IOC announced that Sony Pictures Networks India (SPN) has been awarded the broadcast rights in India and the Subcontinent for the Olympic Games Tokyo 2020, as well as the Winter Youth Olympic Games Lausanne 2020. In addition to the coverage on Sony’s digital platform, SonyLIV,  the Olympic Channel and other IOC digital platforms will feature highlights and replays of key events at the Games. IOC President Thomas Bach said: “The IOC is pleased to be working with Sony Pictures Networks India to collaborate together to bring the best coverage of Tokyo 2020 and  the Youth Olympic Games to fans across the region, on their platform of choice, with the aim of inspiring young people to engage with Olympic sports and the Olympic values.” Below India’s PV Sindhu will be watched by millions in India at Tokyo 2020"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 16,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg17.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Imagine if the world could see what a mom sees. #LoveOverBias"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 17,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg18.jpg",
    "zoom": null,
    "content": "\n        <div class=\"abs noOverflow\" style=\"top:189px;left:263px;width:454px;height:52px\">\n          <img class=\"halfScale\" id=\"18-title-1\" src=\"/111/static/_content/18-title-1.png\">\n        </div>\n        <div class=\"abs noOverflow\" style=\"top:188px;left:66px;width:126px;height:52px\">\n          <img class=\"halfScale\" id=\"18-title-2\" src=\"/111/static/_content/18-title-2.png\">\n        </div>\n        <div class=\"abs noOverflow\" style=\"top:712px;left:246px;width:500px;height:27px\">\n          <img class=\"halfScale\" id=\"18-title-3\" src=\"/111/static/_content/18-title-3.png\">\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg18Anim = new TimelineMax();\n          pg18Anim.fromTo(idOf(\"18-title-1\"), 0.6, {y:55}, {y:0, ease: Power2.easeOut}, 1)\n                  .fromTo(idOf(\"18-title-2\"), 0.6, {y:55}, {y:0, ease: Power2.easeOut}, \"-=0.3\")\n                  .fromTo(idOf(\"18-title-3\"), 0.6, {y:30}, {y:0, ease: Power2.easeOut}, \"-=0.3\")\n        }\n    \n        function onPageLeave() {\n          pg18Anim.stop();\n        }\n      ",
    "searchText": "TOKYO 2020 UNVEILS GAMES ROBOTS  TOKYO 2020 REVEALS OLYMPIC TORCH DESIGN AND AMBASSADORS  On 15 March, the Tokyo 2020 Organising Committee announced the launch of its new Tokyo 2020 Robot Project – one of the programmes aimed at ensuring that the Games will be the most innovative ever and will provide visiting fans with an experience they are unlikely to forget. The Human Support Robot and Delivery Support Robot, developed by Worldwide Olympic Partner Toyota, will allow all spectators to enjoy watching the Games in greater comfort. The robots will guide people to their seats, provide event information, and give assistance to spectators in wheelchairs at the Olympic Stadium by carrying food and other goods. Overall, robot technology will help deliver safer and smoother Games, and while the robots will be deployed only in specific roles during the Games, the project is expected to showcase their potential for wider application in everyday life.  With one year to go until the Olympic Torch Relay touches down in Japan, the Organising Committee for the Olympic Games Tokyo 2020 revealed the Olympic Torch design and the ambassadors for the Olympic Torch Relay. The Olympic torch merges elements of Japanese  culture, and reinforces Tokyo 2020’s Olympic Torch Relay concept, “Hope lights our way”. It will arrive in east Japan on 20 March 2020, where it will be displayed in the areas most affected by the 2011 Great East Japan Earthquake and Tsunami, before the relay commences on  Below The Tokyo 2020 Robot Project can help spectators in wheelchairs by carrying goods  26 March. The ambassadors will include three-time judo Olympic gold medallist Tadahiro Nomura, Paralympian Aki Taguchi and actress Satomi Ishihara. Also in March, Tokyo 2020 unveiled the official sports pictograms of the Games, which will be used for a variety of purposes, including wayfinding, signage at competition venues, decoration around the Japanese capital, and on licensed products, posters and tickets, as well as in guidebooks. In addition, on 16 April, the organisers announced the order of events for each sporting session at Tokyo 2020. Applications for participation in a lottery for the initial offering of Olympic Games tickets were accepted from residents of Japan from 9 to 28 May 2019, with the results announced on 20 June. A further phase of ticket sales will start in the spring of 2020, while people living outside Japan will be able to purchase tickets through Authorised Ticket Resellers. Left The Tokyo 2020 Olympic Torch design evokes the famed Japanese cherry blossom  BEIJING 2022 CELEBRATES 1,000 DAYS TO GO On 10 May, Beijing 2022 celebrated 1,000 days to go until the Opening Ceremony of the XXIV Olympic Winter Games with a ceremony at the Linglong Tower on the Beijing Olympic Green. During the celebration, actor Jackie Chan,  18 OLYMPIC REVIEW  Olympic gold medallist Wu Dajing, para snowboarder Pang Qiaorong and IOC Vice-Presidents Juan Antonio Samaranch and Yu Zaiqing joined Cai Qi, Secretary of the CPC Beijing Municipal Committee and President of Beijing 2022,  to unveil a large screen that started counting down to the Games. The screen spans from the fourth to the seventh floor of Linglong Tower, which served as a broadcasting facility for Beijing 2008 and will do so again for Beijing 2022."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 18,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg19.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://www.mobilityforall.com\" target=\"_blank\">\n          <div class=\"addContentLink\" style=\"top:39px;left:684px;width:94px;height:16px\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "MobilityForAll.com  W H E N W E A R E F R E E TO M OV E , A N Y T H I N G I S P O S S I B L E ."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 19,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg20.jpg",
    "zoom": null,
    "content": "\n        <div class=\"abs noOverflow\" style=\"top:579px;left:246px;width:328px;height:49px\">\n          <img class=\"halfScale\" id=\"20-title-1\" src=\"/111/static/_content/20-title-1.png\">\n        </div>\n        <div class=\"abs noOverflow\" style=\"top:357px;left:66px;width:149px;height:52px\">\n          <img class=\"halfScale\" id=\"20-title-2\" src=\"/111/static/_content/20-title-2.png\">\n        </div>\n        <div class=\"abs noOverflow\" style=\"top:189px;left:604px;width:150px;height:50px\">\n          <img class=\"halfScale\" id=\"20-title-3\" src=\"/111/static/_content/20-title-3.png\">\n        </div>\n        <div class=\"abs noOverflow\" style=\"top:514px;left:604px;width:115px;height:53px\">\n          <img class=\"halfScale\" id=\"20-title-4\" src=\"/111/static/_content/20-title-4.png\">\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg20Anim = new TimelineMax();\n          pg20Anim.fromTo(idOf(\"20-title-1\"), 0.6, {y:50}, {y:0, ease: Power2.easeOut}, 1)\n                  .fromTo(idOf(\"20-title-2\"), 0.6, {y:55}, {y:0, ease: Power2.easeOut}, \"-=0.3\")\n                  .fromTo(idOf(\"20-title-3\"), 0.6, {y:55}, {y:0, ease: Power2.easeOut}, \"-=0.3\")\n                  .fromTo(idOf(\"20-title-4\"), 0.6, {y:55}, {y:0, ease: Power2.easeOut}, \"-=0.3\")\n        }\n    \n        function onPageLeave() {\n          pg20Anim.stop();\n        }\n      ",
    "searchText": "IWF TEAMS UP WITH ANTI-DOPING STAKEHOLDERS Educating the next generation of elite weightlifters on the importance of clean sport and the workings of the anti-doping process was a prominent feature at the Youth World Championships held in Las Vegas (USA) in March. The International Weightlifting Federation (IWF) teamed up with leading players in the anti-doping system, including the World Anti-Doping Agency (WADA), the US AntiDoping Agency (USADA) and the International Testing Agency (ITA), and organised an education seminar for competitors, their parents, coaches and support staff.  FIH FOCUSES ON INCLUSION AND ATHLETE WELFARE The International Hockey Federation’s (FIH) Executive Board held its first meeting of the year on 15 and 16 March at the IF’s headquarters in Lausanne. Chaired by FIH President Narinder Batra, the board reaffirmed the importance of establishing a rolling four-year international competition calendar that balances opportunity for all countries to participate, athlete welfare and the commercial realities of international travel. Other topics addressed included the world ranking system, the FIH Pro League and the implementation of “Hockey 2024”, the FIH’s development strategy. Meanwhile, IOC President Thomas Bach was a recipient of the FIH President’s Award, in recognition of his longstanding support for the sport and the FIH. He was presented with the award by President Batra at a ceremony at the FIH headquarters. Above President Bach receives the FIH President’s Award from Narinder Batra  20 OLYMPIC REVIEW  ITF REVAMPS TOKYO 2020 TENNIS EVENT  2021 BEACH VOLLEYBALL CHAMPIONSHIPS IN ROME On 20 March, Rome (Italy) was announced as the host city of the 2021 FIVB Beach Volleyball World Championships. The championships form a central part of the joint 2019-2022 strategy of the International Volleyball Federation (FIVB), the Italian Volleyball Federation and the Italian Olympic Committee, with the aim of developing beach volleyball in Italy and bringing flagship beach volleyball events to the country each year. Furthermore, FIVB has teamed up with a marine conservation  group, the Ghost Fishing Foundation, to launch Good Net, a project designed to recover discarded fishing nets from the world’s oceans, with many to be recycled into volleyball nets for local community use around the world. Good Net is being launched on Copacabana Beach in Rio de Janeiro (Brazil), the site of the Rio 2016 beach volleyball tournament and home to a school that was completely renovated by the FIVB. Above FIVB hopes to further develop beach volleyball in Italy  On 3 April, the International Tennis Federation (ITF) announced changes to its match formats for the tennis events at the Olympic Games Tokyo 2020. The men’s singles gold match will be played as bestof-three tiebreak sets rather than best-of-five, aligning it with the other matches in the men’s and women’s singles events. Meanwhile, the men’s and women’s doubles will now include a tiebreak up to ten points if the score is level at one-set all, matching the mixed doubles event. The revisions have been brought into effect to reduce the risk of overplay."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 20,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg21.jpg",
    "zoom": null,
    "content": "\n        <div class=\"abs noOverflow\" style=\"top:187px;left:49px;width:388px;height:53px\">\n          <img class=\"halfScale\" id=\"21-title-1\" src=\"/111/static/_content/21-title-1.png\">\n        </div>\n        <div class=\"abs noOverflow\" style=\"top:654px;left:49px;width:402px;height:48px\">\n          <img class=\"halfScale\" id=\"21-title-2\" src=\"/111/static/_content/21-title-2.png\">\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg21Anim = new TimelineMax();\n          pg21Anim.fromTo(idOf(\"21-title-1\"), 0.6, {y:55}, {y:0, ease: Power2.easeOut}, 1)\n                  .fromTo(idOf(\"21-title-2\"), 0.6, {y:50}, {y:0, ease: Power2.easeOut}, \"-=0.3\")\n        }\n    \n        function onPageLeave() {\n          pg21Anim.stop();\n        }\n      ",
    "searchText": "AUSTRALIAN NOC EXPANDS COMMUNITY PROGRAMME  The Australian Olympic Committee (AOC) has expanded its community outreach programme, “Olympics Unleashed”, into schools across Australia’s most populous state, New South Wales. The project takes Olympians and elite athletes into schools to teach students important lessons in goal-setting,  working hard, building resilience and overcoming setbacks. More than 100 Olympians will be trained by experts in education and presentation on how to effectively tell their Olympic journey stories to teenage children in a classroom. Before the Olympic Games Tokyo 2020, the AOC hopes that more than  85,000 students will benefit from having an Olympian come to their school. Only a few months after the project was launched in the state of Queensland, 30,000 children have already had lessons from athletes. Above “Olympics Unleashed” aims to reach 85,000 students in Australia  COLOMBIA TO WELCOME FIRST-EVER JUNIOR PAN AM GAMES IN 2021 The Colombian NOC has announced that the city of Cali has been chosen as host for the first Junior Pan American Games in 2021. The decision was made by the Executive Committee of the Pan American Sports Organization (PASO), chaired by IOC Member Neven Ilic (pictured right), at its meeting in San José (Costa Rica).  The Junior Pan Am Games will welcome athletes from 41 countries, and between the ages of 18 and 22. The city of Cali has already hosted several international sports competitions, including the FIFA U-20 World Cup in 2011, the World Games in 2013 and the 2015 IAAF World Junior Athletics Championships.  NEWS IN BRIEF Greek NOC Athletes’ Commission holds first event In March, the first event of the Hellenic Olympic Committee (HOC) Athletes’ Commission was successfully held in order to raise awareness about the dual career concept for athletes, based on the experiences of athletes and their entourage. Olympic gymnastics champion Eleftherios Petrounias, Olympic sailing bronze medallist Pavlos Kagialis, cycling champion Christos Volikakis, HOC Athletes’ Commission chair Vasiliki Millousi, and the HOC President, Spyros Capralos were among those in attendance. Côte d’Ivoire NOC identifies talent for Dakar 2022 On 12 March, the Côte d’Ivoire NOC launched a programme aimed at helping Ivorian athletes aged from nine to 13 prepare for the Youth Olympic Games Dakar 2022 and the African Youth Games 2022 in Maseru (Lesotho). The programme will consist of identifying talented male and female athletes in various disciplines, who will then follow a training and preparation programme until 2022, which will include taking part in international competitions.  OLYMPIC REVIEW 21"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 21,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg22.jpg",
    "zoom": null,
    "content": "\n        <div class=\"abs noOverflow\" style=\"top:191px;left:67px;width:338px;height:58px\">\n          <img class=\"halfScale\" id=\"22-title-1\" src=\"/111/static/_content/22-title-1.png\">\n        </div>\n        <div class=\"abs noOverflow\" style=\"top:569px;left:67px;width:593px;height:58px\">\n          <img class=\"halfScale\" id=\"22-title-2\" src=\"/111/static/_content/22-title-2.png\">\n        </div>\n\n        <a href=\"https://www.youtube.com/watch?v=28m8k5Kg9Ek\" target=\"_blank\">\n          <svg class=\"abs pulse animatedpulse pointer\" style=\"width:50px; height:50px;left:678px;top:564px\" version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"675px\" height=\"675px\" viewBox=\"0 0 675 675\" enable-background=\"new 0 0 675 675\" xml:space=\"preserve\">\n            <circle fill=\"none\" stroke=\"#000\" stroke-width=\"30\" stroke-miterlimit=\"10\" cx=\"339.195\" cy=\"340\" r=\"321\"/>\n            <polyline fill=\"#000\" points=\"558,356 207,563 207,117 \"/>\n          </svg>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg22Anim = new TimelineMax();\n          pg22Anim.fromTo(idOf(\"22-title-1\"), 0.6, {y:60}, {y:0, ease: Power2.easeOut}, 1)\n                  .fromTo(idOf(\"22-title-2\"), 0.6, {y:60}, {y:0, ease: Power2.easeOut}, \"-=0.3\")\n        }\n    \n        function onPageLeave() {\n          pg22Anim.stop();\n        }\n      ",
    "searchText": "LAUSANNE 2020 MEDAL DESIGN SELECTED On 23 April, the winning entry of the IOC's medal design competition for the Winter Youth Olympic Games (YOG) Lausanne 2020 was chosen. It was submitted by 20-year-old Zakea Page from New Zealand and is entitled “Beauty in Diversity”. Chosen from close to 300 entries from 60 nations, the winning design was picked by a panel of judges made up of Young Change-Makers, Young Reporters, IOC Member Danka Barteková, Lausanne 2020 President Virginie Faivre and ERACOM (Lausanne art and communication school) Dean Viviane Morey. The Medal Design Competition winner said of his design: “It is inspired by Maya Angelou’s quote, ‘In diversity there is beauty’. This is fitting because the Youth Olympic Games are not only a celebration  of human excellence, but also of culture and humanity. The spiral represents a culture of respect, friendship and excellence as young athletes gather to celebrate their success.” Winner Zakea will attend Lausanne 2020, including the Opening Ceremony, and witness first-hand athletes being awarded medals featuring his design. In addition, he will receive his own set of medals and a Samsung tablet. Pictured Zakea Page and his winning medal design, entitled “Beauty in Diversity”  LAUSANNE 2020 UNVEILS YOUTH OLYMPIC PICTOGRAMS TO MARK 300 DAYS TO GO On 15 March, the Lausanne 2020 Organising Committee marked the 300-days-to-go milestone by unveiling the Games pictograms, the graphic representations of the sports that will feature on the programme at next year’s Winter YOG, which will take place from 9 January 2020. In line with the Youth Olympic approach of ensuring that the Games are “by and for young people”, the Lausanne 2020 team entrusted the design and development of the pictograms to ERACOM, the art and  22 OLYMPIC REVIEW  communication school located in the host city. Students of ERACOM already created the mascot, Yodli, which was presented to the public in January. Some 36 students also collaborated to deliver the final work on the 16 pictograms that represent events in the eight sports that will feature at Lausanne 2020, including the animated versions. Pictured Lausanne 2020’s pictograms were designed by local art students"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 22,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg23.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 23,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg24.jpg",
    "zoom": null,
    "content": "\n        <div class=\"abs noOverflow\" style=\"top:201px;left:266px;width:338px;height:88px\">\n          <img class=\"halfScale\" id=\"24-title-1\" style=\"top:20px\" src=\"/111/static/_content/24-title-1.png\">\n        </div>\n        <img id=\"24-title-2\" class=\"halfScale\" style=\"top:305px;left:266px;\" src=\"/111/static/_content/24-title-2.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg24Anim = new TimelineMax();\n          pg24Anim.fromTo(idOf(\"24-title-1\"), 0.6, {y:-90}, {y:0, ease: Power2.easeOut}, 1)\n                  .fromTo(idOf(\"24-title-2\"), 0.6, {y:60, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut}, \"-=0.3\")\n        }\n    \n        function onPageLeave() {\n          pg24Anim.stop();\n        }\n      ",
    "searchText": "COLUMN  BEYOND THE RINGS  BRINGING A VISION TO LIFE JAN AMMUNDSEN, HEAD OF DESIGN AT 3XN ARCHITECTS, DESCRIBES HOW HIS COMPANY WORKED WITH THE IOC TO CREATE OLYMPIC HOUSE, DRIVEN BY THE BELIEF THAT ARCHITECTURE CAN SHAPE BEHAVIOUR  T  here were more than 100 firms interested in the international architecture competition for the Olympic House project, from which 3XN was selected along with 11 others to develop our idea. I came to Lausanne for the first site visit in July 2013, when we were introduced to the brief and the IOC’s vision for the project. One of the things I remember vividly from that day was that they showed a clip containing old footage of past Olympic Games. Clearly, the history and the storytelling were really important for the IOC, and that was one of the things that we took away from that first visit: to try to capture some of the essence of the organisation, and to interpret these sporting moments into a building. After that, the tender process was divided in two stages, and we – together with two other teams – were among the finalists in the second phase, before 3XN was selected as the preferred architecture partner in April 2014. From the start of the process, we felt the IOC’s ambition. We as architects can push the ambitions to a certain place, but from then on we cannot do it anymore. You need to have a client that is in it with you and wants to do something really special with the building. Often, with our designs there is a clear connection from the initial concept to the end result. But in this case, it actually evolved quite a lot, and that was mostly due to comments from the  24 OLYMPIC REVIEW  IOC saying they wanted to do a little bit more here, a little bit more there. All of the feedback helped the design process reach a point where the project became stronger and more powerful in the expression, and clearer in the story about an organisation with a proud history that wants to open up to become more visible and transparent. Olympic House is designed around five key objectives that translate the Olympic Movement’s principles into built form: movement, transparency, flexibility, sustainability, and collaboration. It has been a long, interesting and challenging process, and throughout it we have used these five factors as guidelines to evaluate where we were with the design, and whether we were going in the right direction. There are two main elements to the Olympic House site. First, the Château de Vidy – the old building – which provides the background to the story. And now this glass, undulating, dynamic facade, which appears differently from all angles and conveys the energy of an athlete in motion. And then there is a connecting piece: the plinth (the lower part of the building) that integrates with the park. From the inside, in a symbolic way the story is also clear because we have the Olympic rings staircase, which is a really strong visual identity for the IOC. One of the key features of the staircase is that it’s not just something that connects the floors; it actually creates  a social zone, which will help staff make stronger internal connections. These are often seen as small things in a building, but I believe it’s really important, because that is how you start to work as an organisation – and not just as individuals sitting in the same office. We’ve been saying that now for years: architecture definitely changes behaviour, and it can help certain behaviours to move in a different direction. A building can help a way of working, but it can also prevent a way of working. For example, if there is a wall between two people then they can’t talk, but if you can move the wall they can – and it’s like that. You can build up a lot of different, smaller elements to help a certain behaviour to appear. For 3XN, this is the most important building we have ever done. To see it open will be rewarding, but it’s also really scary because you’re going from the drawings and the model that you’ve been looking at on the computer for years – back and forth, changing it again and again, with many hours put in from everybody involved in the project – to seeing it built, when you cannot change it any more. ■ Jan Ammundsen is a Senior Partner and Head of Design at Copenhagenbased studio 3XN Architects. He has been involved in high-profile projects such as The Blue Planet (National Aquarium of Copenhagen) and the Sports Arena Olympiapark Munich."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 24,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg25.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://www.intel.com/olympics\" target=\"_blank\">\n          <div class=\"addContentLink\" style=\"top:799px;left:381px;width:135px;height:22px\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "AMAZING AHEAD Intel is proud to be a worldwide partner of the Olympic Games and to play a key role in accelerating the adoption of new technologies like drones, virtual reality, 5G, and artificial intelligence platforms. Together with partners, we are creating Olympic experiences that are more innovative and immersive than ever before. Learn more at intel.com/olympics  © Intel Corporation. Intel and the Intel logo are trademarks of Intel Corporation or its subsidiaries in the U.S. and/or other countries."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 25,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg26.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OLYMPIC LEGACY  26 OLYMPIC REVIEW"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 26,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg27.jpg",
    "zoom": null,
    "content": "\n        <img id=\"27-title\" class=\"halfScale\" style=\"top:92px;left:147px;\" src=\"/111/static/_content/27-title.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg27Anim = new TimelineMax();\n          pg27Anim.fromTo(idOf(\"27-title\"), 0.6, {y:60, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut}, 1)\n        }\n    \n        function onPageLeave() {\n          pg27Anim.stop();\n        }\n      ",
    "searchText": "OLYMPIC LEGACY  TOGETHER UNDER ONE ROOF  AHEAD OF THE OFFICIAL OPENING OF OLYMPIC HOUSE ON 23 JUNE, WHICH MARKS THE 125TH ANNIVERSARY OF THE IOC, OLYMPIC REVIEW LOOKS AT HOW THE NEW HEADQUARTERS WILL BRING ALL OF THE IOC STAFF TOGETHER UNDER ONE ROOF, SERVING AS A MODEL OF SUSTAINABILITY, COLLABORATION AND OPERATIONAL EFFICIENCY. BY SAM PRICE"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 27,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg28.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://www.olympic.org/olympic-day\" target=\"_blank\">\n          <div class=\"addContentLink\" style=\"top:640px;left:231px;width:64px;height:13px\"></div>\n        </a>\n\n        <svg onclick=\"Publish.openGallery(['28-gal-1.jpg', '28-gal-2.jpg', '28-gal-3.jpg', '28-gal-4.jpg', '28-gal-5.jpg', '28-gal-6.jpg', '28-gal-7.jpg', '28-gal-8.jpg'])\" class=\"abs pointer\" style=\"left:506px;width:50px; top:41px; height:50px\" viewBox=\"0 0 160.62 157.733\" enable-background=\"new 0 0 160.62 157.733\">\n          <g>\n            <path fill=\"#000\" d=\"M81.691,67.001c7.996,0,14.477,6.481,14.477,14.477s-6.481,14.477-14.477,14.477\n              c-7.995,0-14.476-6.482-14.476-14.477S73.697,67.001,81.691,67.001z\"/>\n            <path fill=\"#000\" d=\"M124.263,52.933h-23.92l-0.716-5.581c0-3.189-2.585-5.774-5.774-5.774H69.218\n              c-3.188,0-5.773,2.585-5.773,5.774l-0.716,5.581H39.001c-2.126,0-3.85,1.627-3.85,3.753v49.656c0,2.126,1.724,3.945,3.85,3.945\n              h85.262c2.125,0,3.849-1.819,3.849-3.945V56.686C128.112,54.56,126.388,52.933,124.263,52.933z M81.65,105.2\n              c-13.074,0-23.672-10.599-23.672-23.672S68.576,57.856,81.65,57.856s23.672,10.598,23.672,23.671S94.724,105.2,81.65,105.2z\n              M123.685,63.134h-20.209v-5.966h20.209V63.134z\"/>\n          </g>\n          <g>\n            <path fill=\"#000\" d=\"M154.856,78.867h-5.764c-0.001,9.313-1.884,18.156-5.29,26.209c-5.107,12.077-13.654,22.371-24.404,29.633\n              c-5.375,3.631-11.298,6.504-17.62,8.47s-13.041,3.026-20.026,3.027c-9.314-0.001-18.156-1.884-26.21-5.29\n              c-12.077-5.107-22.371-13.653-29.632-24.404c-3.631-5.375-6.504-11.298-8.471-17.62c-1.966-6.322-3.026-13.041-3.026-20.026\n              c0.001-9.314,1.884-18.157,5.29-26.21C24.81,40.58,33.357,30.286,44.107,23.024c5.375-3.631,11.298-6.504,17.619-8.471\n              c6.322-1.966,13.041-3.026,20.027-3.026c9.313,0,18.156,1.884,26.209,5.29c12.077,5.107,22.371,13.653,29.632,24.404\n              c3.631,5.375,6.504,11.298,8.471,17.619c1.966,6.322,3.026,13.041,3.026,20.027H154.856h5.764c0.001-10.874-2.207-21.262-6.2-30.7\n              c-5.991-14.161-15.983-26.191-28.567-34.694c-6.292-4.251-13.235-7.62-20.649-9.926C97.791,1.241,89.907,0,81.753,0\n              C70.88-0.001,60.491,2.207,51.052,6.2c-14.161,5.991-26.19,15.983-34.693,28.567c-4.251,6.292-7.62,13.235-9.926,20.648\n              c-2.306,7.413-3.547,15.296-3.546,23.451c-0.001,10.873,2.207,21.262,6.2,30.7c5.991,14.161,15.983,26.191,28.567,34.694\n              c6.292,4.251,13.235,7.62,20.648,9.926c7.413,2.306,15.296,3.547,23.451,3.546c10.874,0.001,21.262-2.207,30.7-6.2\n              c14.161-5.991,26.191-15.984,34.694-28.568c4.251-6.292,7.621-13.235,9.926-20.648c2.306-7.413,3.547-15.296,3.547-23.45H154.856\n              L154.856,78.867z\"/>\n          </g>\n        </svg>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "OLYMPIC HOUSE  03  02  01  une 23rd, popularly known as Olympic Day, is already a permanent ﬁxture in the international sports calendar, with Olympic Movement stakeholders coming together since 1948 to celebrate the birth date of the International Olympic Committee (IOC). Every year, sport initiation activities and fun-runs aimed at inspiring youth and communicating the Olympic values take place in all corners of the globe, but the 2019 celebrations promise to be extra special. That is not just because this year represents the landmark 125th anniversary of the IOC’s creation in 1894, but because it will also see the inauguration of Olympic House: the new, state-ofthe-art building that will bring all of the IOC’s staff under one roof in Lausanne, and serve as the home of the Olympic Movement for many years to come.  28 OLYMPIC REVIEW"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 28,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg29.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OLYMPIC HOUSE  04  The inauguration will gather together representatives of the Olympic Movement – including National Olympic Committees (NOCs), International Federations (IFs) and athletes – to celebrate what IOC President Thomas Bach, who moved into the new headquarters on 27 May along with the 500-strong IOC workforce, has described as “a bridge between the roots of the IOC in Lausanne and our vision for the future”. “It allows us to bring together all our staff under one roof while reﬂecting the principles of transparency, unity and peace that drive the Olympic Movement and the reforms undertaken over the last ﬁve years,” he said. “With Olympic House, we respect the highest international sustainability standards.” Designed by Copenhagen-based architecture ﬁrm 3XN in partnership with Swiss ﬁrm IttenBrechbühl, Olympic House clearly demonstrates this contemporary outlook and desire to shape the future with a glass facade that showcases openness and a strong commitment to sustainability. But it also draws on the IOC’s rich history and core values, through a building that mimics the movement of an athlete, a dove-shaped roof that symbolises peace, and a staircase based upon the Olympic rings to connect the different ﬂoors. Iconic without being ostentatious, the building is a powerful expression of the Olympic brand. “It was the essence of the Olympic Movement and its values that served as the basis of inspiration for the design,” according to Kim Herforth Nielsen, founder and principal of 3XN. “Every decision we made was evaluated for its applicability to the primary goals and values of the IOC.” Olympic House was designed and built around ﬁve key success factors: symbolism; collaboration; ﬂexibility; commitment to sustainability; and respectful integration with the historical Château as well as the landscape, namely the Louis Bourget Park. These factors have remained consistent ever since a detailed functional brief was provided for the international architecture competition in 2013, after a feasibility study in 2012 had determined that the IOC administration, previously spread out over several locations across Lausanne, would beneﬁt operationally from being brought together in one building. 01 02 03 04  Ninety per cent of regularly occupied spaces at Olympic House will have access to quality views. The dove-shaped roof of Olympic House is intended to symbolise peace. The building was designed by Danish architecture firm 3XN in partnership with Swiss firm IttenBrechbühl. Olympic House will provide 135 bicycle parking spaces to encourage active and sustainable mobility.  OLYMPIC REVIEW 29"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 29,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg30.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "01  AN INVESTMENT IN OPERATIONS In truth, though, the roots of this project can be traced back much further, all the way to 2006. It was then that the IOC President at the time, Jacques Rogge, conscious that the IOC administration was spread over different offices, told a member of staff of his desire to unite everyone in one building. Thirteen years later, that same staff member, Marie Sallois – now the IOC’s Director of Corporate Development, Brand and Sustainability, and who has been in charge of the Olympic House project since its inception – is excited to deliver a building that will positively impact not only the staff who will work inside, but also the local economy and the Olympic Movement as a whole.  30 OLYMPIC REVIEW  “Olympic House is an organisational development project, whereby we aim at evolving the way we work,” says Christophe De Kepper, IOC Director General. “It really was born out of an operational need to bring everyone together under one roof. “From the beginning I felt that Olympic House would be more than a building but an important element in the transformation journey undertaken by the IOC over the last five years towards more openness and collaboration.” Olympic House is a CHF 145 million privately funded investment by the IOC, which came in under the original envelope of CHF 200 million after a threeyear construction phase, despite parts of the process that were not anticipated, such as the deconstruction  02"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 30,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg31.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OLYMPIC HOUSE  03  ‘OLYMPIC HOUSE ALLOWS US TO BRING TOGETHER ALL OUR STAFF UNDER ONE ROOF WHILE REFLECTING THE PRINCIPLES OF TRANSPARENCY, UNITY AND PEACE’ IOC PRESIDENT THOMAS BACH  04  01 02 03 04  The staircase connecting the different floors is based upon the Olympic rings. The curved facades will bring a maximum amount of light into the interior spaces. IOC staff have provided valuable input through seminars, surveys and space occupation studies. Communal spaces for collaborative work are an important part of the new building.  of the previous administrative buildings and the archaeological work that needed to be carried out at the site. It represents a continuation of the IOC’s strong commitment to Lausanne and to developing competencies in the region, with 80 per cent of all construction costs being spent on companies located less than 50km away. It is also a sustainable investment for the IOC in two key ways. First, it has allowed the organisation to invest in an asset which it owns, and which will appreciate over time, instead of paying out in rents. And second, because of the improved resource efficiency, synergy and collaboration between the IOC administration, Olympic House is expected to provide cost optimisation at a projected CHF 80 million over the next 50 years. Now and in the future, instead of having multiple locations, the IOC will benefit from two Olympic centres in Lausanne: the Olympic House in Vidy to cater for its administration and offer a welcoming meeting place for IOC Members and the entire Olympic Movement; and the Olympic Museum and Olympic Studies Centre in Ouchy to host the general public. By addressing individual and collective needs, Olympic House is set to enable the IOC workforce to work even more collaboratively in a quality workplace, which has been built to adapt to strategic or organisational changes through an agile work environment. “And since it was an operational need that triggered the project, it was natural that we involved the IOC staff from the very beginning,” adds Sallois. IOC employees have been involved at every stage and at all levels, providing valuable input through surveys, seminars and space occupation studies to define user needs and guidelines for the inside of the building. They were also involved in the choice of furniture, development of workplace policies, and preparation for the move, while 40 chosen Olympic House Ambassadors have made further contributions in areas such as interior design, ergonomics and user comfort – with a clear focus on quality of space, light, air and views to enhance productivity and collaboration.  OLYMPIC REVIEW 31"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 31,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg32.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://stillmed.olympic.org/Documents/Olympic_Agenda_2020/Olympic_Agenda_2020-20-20_Recommendations-ENG.pdf\" target=\"_blank\">\n          <div class=\"addContentLink\" style=\"top:506px;left:149px;width:106px;height:13px\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "OLYMPIC HOUSE  01  A BEACON OF SUSTAINABILITY The importance attached to user wellness is reflective of a wider focus on sustainability, which has been embedded at the very core of the Olympic House project from the outset. Using a holistic approach, the IOC has ensured that sustainability has been a key consideration during every decision throughout the process, from planning and construction to operations. Indeed, with sustainability one of the three key pillars of Olympic Agenda 2020, and following the publication of the IOC Sustainability Strategy in 2017, Olympic House has provided a golden opportunity for the IOC to demonstrate its strong commitment to sustainability, and that it walks the talk and leads by example. This led to the IOC’s ambition for Olympic House to meet very demanding sustainability standards both locally, with the National Sustainable Construction Standard (SNBS) and Minergie, and internationally though Leadership in Energy and Environmental Design (LEED), the most widely used green building rating system in the world (see page 38). According to Sallois, trying to balance the strict criteria with high-quality architecture has presented some significant challenges. “When you want to go this far in sustainability while being extremely creative in the design of your building, it creates tension,” she says. “But we didn’t want to compromise one or the other, so we pushed for both. This has not been done to that extent before. We had a few challenges, but we tried to turn them into opportunities.” A key example of this approach in action can be seen in the deconstruction of the former headquarters, which was not initially planned for but proved unavoidable. However, by devising an innovative  32 OLYMPIC REVIEW  02  03  04  01 02 03 04  Local students participated in a workshop focused on the deconstruction of the old buildings. The construction of Olympic House took place over a three-year period. Bathroom fittings were retrieved from the previous headquarters and donated to local associations. Olympic House has been integrated into its environmental and historical setting.  ‘OLYMPIC HOUSE WAS A UNIQUE CHANCE TO DEMONSTRATE THAT WE WALK THE TALK WHEN IT COMES TO SUSTAINABILITY. AND WE HAVE TAKEN THIS RESPONSIBILITY VERY SERIOUSLY’ MARIE SALLOIS"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 32,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg33.jpg",
    "zoom": null,
    "content": "\n        <div class=\"addContentLink\" style=\"top:808px;left:712px;height:14px;width:57px;\">\n          <a href=\"https://twitter.com/dowsports?lang=en\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:822px;left:651px;height:14px;width:121px;\">\n          <a href=\"https://www.linkedin.com/company/dow-chemical\" target=\"_blank\"></a>\n        </div>\n\n        <div class=\"addContentLink\" style=\"top:836px;left:704px;height:14px;width:67px;\">\n          <a href=\"https://www.dow.com\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 33,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg34.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OLYMPIC HOUSE  01  02  solution that embraced the concept of circular economy, the IOC was able to deconstruct the old buildings bit by bit, with 95 per cent of the materials reused or recycled and going on to second lives. Notably, concrete was crushed on site and reused in the foundations of the new building, while bathroom fittings and electronic boards were donated to local associations. More than 700 apprentices have since trained on the 350 circuit-breakers salvaged from the former administrative building, leading to the development of new skills in the area. More broadly, the project has minimised the environmental footprint and total cost occupancy of Olympic House without compromising the quality of the working environment. The ground floor, which hosts a restaurant, conference centre and gym, is covered by a green plinth to foster integration with the park, where a new children’s playground has been built, and more than 50 additional trees planted. The IOC also worked with the local authorities to prioritise sustainable access, 01 02 03 04 05  34 OLYMPIC REVIEW  03  The historical Château de Vidy (left) has been renovated and remains a key feature of the IOC headquarters. A 3D rendering of one of the top-floor meeting rooms, provided by the architects. IOC President Thomas Bach and the IOC Executive Board conducted a site visit in March 2019. More than half of the Olympic House site area is vegetated, and 50 additional trees have been planted. The building provides a state-of-the-art space for the 500-strong workforce."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 34,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg35.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "04  with a new bus route to the site. In addition, Olympic House offers 135 bicycle parking spaces to encourage active and environmentally-friendly mobility, as well as charging stations for electric cars. “At every stage, we looked with the city at how to enhance the park experience for the general public, and how best to integrate our building into the green and historical environment,” says Sallois. Benefiting from its surroundings is the building itself, which is extremely resource-efficient and will be powered mainly by renewable energy. A pumping station has been installed to take water from the lake, to use both for cooling the building and heating it, while rainwater will be collected in a 300m² tank and used in the toilets and for plant irrigation. In addition, solar panels located on the roof will produce an amount of electricity equivalent to the yearly consumption of 60 Swiss households, reducing dependence on the grid, while enhanced insulation, smart building features and LED lighting means that Olympic House won’t use any more energy than the previous HQ despite being three times the size. In fact, it is anticipated that Olympic House will deliver a 35 per cent reduction in energy consumption and a 60 per cent reduction in municipal water consumption compared to a standard new office building in Switzerland. The IOC also pushed the boundaries when it came to the materials and furniture, which were screened to make sure their impact on the environment was limited and that they contained minimal amounts of hazardous chemicals. This had an impact on the value  05  chain, with some suppliers updating their practices and developing new materials as a result of the high demands placed on them, and the main furniture manufacturer for Olympic House deciding to certify some of the products in its catalogue according to the Greenguard Gold standard. “Olympic House was a unique chance to demonstrate that we walk the talk when it comes to sustainability,” adds Sallois. “And we have taken this responsibility very seriously. We are happy to share our knowledge, experience and network of stakeholders with the wider Olympic Movement.”  COLLABORATION AT THE HEART Collaboration with this network of stakeholders has driven the project from the beginning, with Olympic House proving to be a catalyst for innovative collaboration with architects, engineers, sustainability certification bodies, local authorities, suppliers, academics, Worldwide Olympic Partners and IOC  OLYMPIC REVIEW 35"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 35,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg36.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OLYMPIC HOUSE  staff. Over a six-year period, collectively they were able to turn an idea into reality by challenging each other every step of the way, and Sallois highlights the direct relationship that the IOC had with 3XN, IttenBrechbühl and the engineering team as a crucial factor in the successful delivery of the project. “We didn’t have a general contractor between us and them, which means that we were able to have dialogue at every phase of the project in order to enhance flexibility, collaboration and sustainability,” she says. “We had this continuous-improvement approach, so that everyone who could see that we could enhance the project could always suggest an improvement. That’s quite unusual – especially for an organisation that is not in real estate, like us – but I think it proved very successful.” Additionally, the IOC has been able to draw upon the expertise of a number of other local and international partners, with Dow – the Official Carbon Partner for the Olympic Movement – delivering a mitigation programme to compensate carbon emissions associated with the construction and operation of Olympic House, and providing products and solutions used in the facade and car park to further enhance the building’s architectural and environmental performance. Other TOP Partners have been involved as well, with Panasonic providing the audio-visual equipment in the meeting rooms to support interactive physical and remote communications, and Toyota working with local stakeholders to develop a hydrogen station pilot project that will help the IOC reduce the carbon footprint of its vehicle fleet. In fact, collaboration with local authorities has been apparent at almost every stage of the process, with the Canton of Vaud involved not only in the renovation of the historic Château de Vidy, but also in the archaeological work that unearthed the remains of the Roman port of Lousonna, deemed to be a discovery of national importance. Meanwhile, the IOC has also taken advantage of its relationship with different academic institutions in the area, most significantly through an innovative collaboration with the Swiss Federal Institute of Technology in Lausanne (EPFL) on the deconstruction of the old headquarters. This led to 23 architecture students at EPFL participating in a workshop at the site in February 2016, testing the old materials and taking their findings to the IOC boardroom, where they proposed the most impactful and sustainable ways to reuse them. “It’s good to ingrain seeds in youth to think about reuse and recycling, because it’s a very important issue,” says Martin Fröhlich, the Associate Professor of Architecture at EPFL who led the ‘Youth for Reuse’ workshop. “There are a number of students who are  36 OLYMPIC REVIEW  still working on this topic and are now very active in reuse discussions in the local area, so the seed has been growing into a small plant.” From local students and artists who have contributed their work to Olympic House, to the IOC administration who will inhabit the building and the guests they will welcome, Olympic House promises to provide inspiration for everyone who comes into contact with it, with the partnerships forged during the process set to bear fruit for years to come. And its long-awaited inauguration on 23 June will provide an opportunity to celebrate what, at its core, has been a “people project”, according to Sallois. “Because of the convening power of the Olympic rings that makes everybody dream, we have been able to attract the best – and they have given their best,” she says. “It’s not just the building, but the human adventure behind it. I think this is the feeling that everybody who has been contributing to this project will be left with.” By opening Olympic House, the IOC is sending a strong, confident statement about the continuing relevance of the Olympic Games, and of its leadership role in building a better world through sport. A new era awaits, for the IOC, the Olympic Movement and the city of Lausanne. ■ IN THE NEXT ISSUE: With one year to go until the Olympic Games Tokyo 2020, we look at how preparations in the host city are progressing, and highlight what fans and athletes can expect from the state-of-the-art venues and ground-breaking sports programme.  01  02"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 36,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg37.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OLYMPIC HOUSE TIMELINE  2012 DECEMBER Presentation of the feasibility study  03  2014 APRIL Choice of the preferred architecture partner by the IOC EB  2013 MARCH Launch of international architecture competition  2015 JULY Request for building permit  2016 01  02  03  The IOC’s Official Carbon Partner Dow provided the energy-saving sealant material that holds the glass panels and metal frames together. Local schoolchildren were invited to attend art workshops and contribute to the production of frescoes on the construction fence. The furniture used in Olympic House has been screened to ensure it meets strict environmental criteria.  DECEMBER Symbolic laying of the first stone of the new IOC headquarters  FEBRUARY Launch of archaeological studies and start of deconstruction SUMMER Start of construction  2019 JUNE Inauguration"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 37,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg38.jpg",
    "zoom": null,
    "content": "\n        <img id=\"38-title\" class=\"halfScale\" style=\"top:184px;left:108px;\" src=\"/111/static/_content/38-title.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg38Anim = new TimelineMax();\n          pg38Anim.fromTo(idOf(\"38-title\"), 0.6, {y:60, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut}, 1)\n        }\n    \n        function onPageLeave() {\n          pg38Anim.stop();\n        }\n      ",
    "searchText": "OLYMPIC HOUSE  THE HIGHEST SUSTAINABILITY STANDARDS 01 A sustainable building requires detailed planning, many components, and careful consideration whenever a decision is made. But when you aim for more than one sustainability label – which often have very different specifications or requirements – as the IOC has done with Olympic House, the demands become even greater. “We set the bar very high by going for global certification as well as local certification, always at the maximum,” explains Marie Sallois, IOC Director of Corporate Development, Brand and Sustainability, who oversaw the Olympic House project. “We didn’t satisfy ourselves with just getting the points and reaching the certification – we really tried to go as far as we could, in every dimension.” Somebody well aware of the challenges of obtaining Leadership in Energy and Environmental Design (LEED) certification is Mahesh Ramanujam, President and CEO of the U.S. Green Building Council, the organisation that created LEED. It is now the most widely used green building rating system in the world, and a globally recognised symbol of sustainability achievement. “LEED, as I normally explain it, is a nutrition label for a building,” he explains. “It tells of how the building saves energy, water and waste, and it helps you to  38 OLYMPIC REVIEW  02  03  01 02 03  Olympic House balances high-quality architecture with strict local and global sustainability certification standards. Mahesh Ramanujam, President and CEO of the U.S. Green Building Council, visited Olympic House in March 2019. Solar panels on the roof are part of a strong commitment to using renewable energies to power the building.  build green buildings through better design, better construction and, most importantly, better operations, so that you can actually deliver better performance for the humans who occupy it.” By targeting LEED platinum – the latest version in the new building category – the IOC has not only provided a best-in-class example for Olympic Movement stakeholders to follow, but has transformed local and international supply chains by demanding new, more environmentally-friendly products from manufacturers, something that will benefit buildings of the future. “When I walked into Olympic House, what I experienced was a commitment to leadership, a commitment to transform, and a commitment to not cut corners,” reveals Ramanujam. “When you try to attempt platinum, you are going for extraordinary leadership; you’re trying to define what’s possible. Olympic House is a milestone for the global green building movement, and examples like this will help us to really build the case for a carbon neutral world.” ■"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 38,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg39.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 39,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg40.jpg",
    "zoom": null,
    "content": "\n        <img id=\"40-title-1\" class=\"halfScale\" style=\"top:446px;left:73px;\" src=\"/111/static/_content/40-title-1.png\">\n        <img id=\"40-title-2\" class=\"halfScale\" style=\"top:506px;left:155px;\" src=\"/111/static/_content/40-title-2.png\">\n        <img id=\"40-sub-1\" class=\"halfScale\" style=\"top:740px;left:175px;\" src=\"/111/static/_content/40-sub-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg40Anim = new TimelineMax();\n          pg40Anim.fromTo(idOf(\"40-title-1\"), 0.6, {x:60, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, 1)\n          .fromTo(idOf(\"40-title-2\"), 0.6, {opacity:0}, {opacity:1, ease: Power2.easeOut}, \"-=0.2\")\n          .fromTo(idOf(\"40-sub-1\"), 0.6, {x:60, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, \"-=0.2\")\n        }\n    \n        function onPageLeave() {\n          pg40Anim.stop();\n        }\n      ",
    "searchText": "THE IOC AT 125  Pictured Athens hosted the first modern Olympic Games, since when there have been nine IOC presidents, most recently Jacques Rogge (below) and Thomas Bach  THE IOC AT  125  ON THE 125TH ANNIVERSARY OF THE CREATION OF THE IOC, OLYMPIC REVIEW TRACES THE HISTORY OF THE ORGANISATION, AND SPEAKS TO IOC PRESIDENT THOMAS BACH AND IOC HONORARY PRESIDENT JACQUES ROGGE TO UNDERSTAND HOW, IN SPITE OF VARIOUS CHALLENGES, THE VALUES THAT UNDERPIN THE OLYMPIC GAMES REMAIN AS RELEVANT TODAY AS EVER. BY STEPHEN WILSON  40 OLYMPIC REVIEW"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 40,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg41.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "THE IOC AT 125"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 41,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg42.jpg",
    "zoom": null,
    "content": "\n        <img id=\"42-quote\" class=\"halfScale\" style=\"top:168px;left:66px;\" src=\"/111/static/_content/42-quote.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg42Anim = new TimelineMax();\n          pg42Anim.fromTo(idOf(\"42-quote\"), 0.6, {x:60, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, 1)\n        }\n    \n        function onPageLeave() {\n          pg42Anim.stop();\n        }\n      ",
    "searchText": "THE IOC AT 125  TH BEST WAY THE OF PAYING TRIBUTE TO O AN A ILLUSTRIOUS PAST T IS OBVIOUSLY LEARNING NG FROM ITS TEACHIN INGS IN ORDER TO PRE REPARE FOR THE FUTURE RE.Õ  T  hose words were spoken by Pierre de Coubertin, the young French educator who 125 years ago founded the modern Olympic Games and created the International Olympic Committee (IOC). Coubertin could hardly have known at the time that the Olympic Games and IOC would still be going strong a century-and-a-quarter later. His vision of bringing the world together in peaceful sporting competition has stood the test of time and remains as relevant today as ever before. “I can’t repeat it enough,’’ says IOC President Thomas Bach. “Pierre de Coubertin was a genius who gives me, and can give us all, inspiration still today. He was a visionary.” As the IOC prepares to celebrate its 125th anniversary on 23 June, including the inauguration of its new headquarters in Lausanne, Coubertin might be surprised at how the IOC and the Games look today. But he surely would be proud of how the institution has endured and continues to thrive. Few world bodies or NGOs have lasted so long, and few could have survived two world wars, crippling boycotts, near bankruptcy, terrorism,  42 OLYMPIC REVIEW  Left to right Pierre de Coubertin founded the IOC in 1894; the IOC Members at the 2nd IOC Session two years later; fencing has featured at every Olympic Games since 1896.  and doping and ethical scandals. Yet the IOC and the Games have managed to overcome the threats and evolve through turbulent times to achieve their current success and stability. What’s the secret of the IOC’s longevity? “There are two reasons,” says President Bach. “The first is that the values established by Pierre de Coubertin are still important, and are even more important in times of political and financial crisis. We saw how the values led to the revival of the Games after World War I and World War II.  “The second is that the IOC, in the most determining moments, always adapted to modern times and did not rely on tradition. That means keeping the values and holding the values high up, but adapting how to promote the values, how to interpret them, to a given time.” Bach’s predecessor, IOC Honorary President Jacques Rogge, says it boils down to the basics: inspiring generation after generation of athletes to pursue the dream of participating in the Olympic Games."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 42,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg43.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "“The IOC has been able not only to survive but also to flourish based on very simple things,” says the three-time Belgian Olympian in sailing. “It’s the desire of the athletes to compete with others. Athletes want to meet together in the Olympic Village and compete with the best of them. That is the basis of everything – the pursuit of excellence and the basic universal values.” Those basic values weren’t enough to convince sceptics when Coubertin appealed in 1892 for a revival of the  Olympic Games – begun by the Greeks in 776 B.C. and discontinued in 393 A.D. Critics called the idea absurd. “Some people became indignant and damned me to hell, accusing me of blasphemy and desecration,” Coubertin later recalled. But the French aristocrat persevered and lobbied vigorously to garner support for his long-held dream. By the time he convened a special Congress at the Sorbonne in Paris in 1894, the tide had turned in the 31-year-old Coubertin’s  favour. What was initially planned as a conference on amateurism in sport was renamed the “International Congress for the Re-establishment of the Olympic Games”. The Congress convened in the grand amphitheatre of the Sorbonne on 16 June 1894. Seven days later, on 23 June, in the final session of the meeting, 79 delegates from 11 countries unanimously approved the revival of the Games. Coubertin hailed “the restoration of a 2,000-year-old idea which today, as in the past, still quickens the hearts of men, for it satisfies one of its most vital and – regardless of what may have been said on the subject – one of its most noble instincts”. The Congress agreed that the Games should be held every four years in different locations, and Athens was selected to host the first modern Olympic Games in 1896. The delegates passed a resolution on amateurism, opening the Games only to nonprofessionals, except in fencing. The Congress also established the International Committee for the Olympic Games, starting with 12 members, increasing to 14 by the end of 1894  OLYMPIC REVIEW 43"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 43,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg44.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://www.olympic.org/news/ioc-considers-request-for-unified-korean-teams-to-enter-qualification-for-olympic-games-tokyo-2020\" target=\"_blank\">\n          <div class=\"addContentLink\" style=\"top:361px;left:493px;width:143px;height:13px\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "THE IOC AT 125  and 16 in 1895. The current name of the organisation, International Olympic Committee, did not become official until 1901. Demetrius Vikelas of Greece was named the committee’s first president, a post he held for two years until Coubertin took over in 1896 and served until 1925. From 1894 until now, the IOC has had nine presidents and a total of 570 members, including a current membership of 95*. President Bach sees direct parallels between the challenges Coubertin faced  in the 1890s and the era that the IOC and the world are living through today. “When Pierre de Coubertin founded the IOC, his vision and values at the time went against nationalism, against aggressivity among nations,’’ he says. “It was about friendship and understanding. It was about bringing people together. It was about making the world less fragile.” More than a century later, those same ideals are more pertinent than ever. “This is somehow a position we are in at this moment with regard to the  Games,” says President Bach. “We see this zeitgeist of rising nationalism. We see this zeitgeist of aggression. It is a great opportunity because we can demonstrate how relevant, how important our values are. We have to fight even more for understanding, for dialogue and respect.” President Bach cites the IOC’s role in negotiations that led to athletes from North and South Korea marching together in the Opening Ceremony under one flag and fielding a unified women’s hockey team at the Olympic Winter Games PyeongChang 2018. Talks are continuing on the possibility of the two Koreas fielding joint teams at Tokyo 2020. Throughout its history, the IOC has managed to navigate world crises as well as crises close to home. After the outbreak of World War I, Coubertin transferred the IOC headquarters from France to Lausanne"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 44,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg45.jpg",
    "zoom": null,
    "content": "\n        <img id=\"45-quote\" class=\"halfScale\" style=\"top:739px;left:550px;\" src=\"/111/static/_content/45-quote.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg45Anim = new TimelineMax();\n          pg45Anim.fromTo(idOf(\"45-quote\"), 0.6, {x:60, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, 1)\n        }\n    \n        function onPageLeave() {\n          pg45Anim.stop();\n        }\n      ",
    "searchText": "THE IOC AT 125  in 1915 because of the safe haven offered in neutral Switzerland. The Villa Mon Repos served as the home of the IOC from 1922 to 1968, when the IOC moved to the Château de Vidy on the shores of Lake Geneva. While the Olympic Games were cancelled during the two World Wars, they were resumed after each of the conflicts, underlining the Games’ enduring and powerful message of peace and international goodwill. The 1970s and ’80s proved to be a particularly trying period in IOC history.  The attack on the Israeli team at Munich 1972 was one of the darkest chapters in Olympic history, claiming the lives of 11 Israeli athletes and coaches and one German policeman. Then came the successive political boycotts of the 1976, 1980 and 1984 Games. By the early 1980s, the IOC was teetering on the edge of bankruptcy. The situation was so grim that Los Angeles was the only candidate to host the 1984 Olympic Games. But LA 1984 proved to be a turning point, as the highly successful privately-financed  ‘THE VALUES ESTABLISHED BY COUBERTIN ARE STILL IMPORTANT, AND EVEN MORE IMPORTANT IN TIMES OF CRISIS’ PRESIDENT BACH  * AT THE TIME OF PUBLICATION  Clockwise from left The men’s steeplechase at London 1948; an Olympic Village memorial to the athletes murdered at Munich 1972; the Villa Mon Repos was the IOC’s home from 1922 to 1968; the unified Korean hockey team sent out a message of peace in PyeongChang.  OLYMPIC REVIEW 45"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 45,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg46.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "THE IOC AT 125"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 46,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg47.jpg",
    "zoom": null,
    "content": "\n        <img id=\"47-quote\" class=\"halfScale\" style=\"top:433px;left:50px;\" src=\"/111/static/_content/47-quote.png\">\n\n        <a href=\"https://www.olympic.org/partners\" target=\"_blank\">\n          <div class=\"addContentLink\" style=\"top:676px;left:125px;width:104px;height:14px\"></div>\n        </a>\n        <a href=\"https://www.olympic.org/olympic-solidarity\" target=\"_blank\">\n          <div class=\"addContentLink\" style=\"top:725px;left:248px;width:87px;height:14px\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg47Anim = new TimelineMax();\n          pg47Anim.fromTo(idOf(\"47-quote\"), 0.6, {x:60, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut, onComplete: addContentLinks}, 1)\n        }\n    \n        function onPageLeave() {\n          pg47Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "THE IOC AT 125  ‘THE DESIRE OF THE ATHLETES TO COMPETE WITH OTHERS... THAT IS THE BASIS OF EVERYTHING’ JACQUES ROGGE Games produced a profit of USD $223 million and became a model for future Games. Cities began to clamour to host the Games again. The IOC President at the time, Juan Antonio Samaranch, played a pivotal role during his 21-year term in strengthening the Olympic Games and restoring the IOC to firm financial footing. The launch of The Olympic Partners (TOP) programme in 1985 was a landmark, bringing in many of the world’s best-known multinational companies to support the Games. The IOC also negotiated highly lucrative television rights deals with world broadcasters. As a result, the IOC’s coffers grew and financial stability was secured for the Olympic Movement (the IOC achieved revenues of USD $5.7 billion for the 2013-2106 period, mainly through broadcast  Left to right British decathlete Daley Thompson starred at Los Angeles 1984; Olympic Solidarity funds coaches’ education around the world; since 1994, the Winter Games has taken place on different years to the Summer Games.  and sponsorship rights, 90 per cent of which is redistributed to the wider sporting movement). Olympic Solidarity was created more than 50 years ago to provide assistance to National Olympic Committees, particularly those with the greatest financial needs. For 2017-2020, the programme will provide more than half a billion dollars towards athlete development and coaches’ education. Another historic step came in 1986 with the decision to separate the Summer and Winter Games and  schedule them in alternating evennumbered years after 1992. The IOC also opened the Games to professionals to attract the world’s best athletes, clearing the way for the participation of the US basketball “Dream Team” at Barcelona 1992. But the boom times were jolted in the late 1990s by the bidding scandal involving the Olympic Winter Games Salt Lake City 2002. Facing intense international criticism and scrutiny, Samaranch and the IOC used the crisis as a catalyst to clean up the  OLYMPIC REVIEW 47"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 47,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg48.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "THE IOC AT 125  organisation and enact a set of wideranging reforms. These included establishment of an Ethics Commission and election of athlete members to the IOC and IOC Executive Board. “The Salt Lake City crisis was really a pivotal turning point,” says Rogge, who sat on the Inquiry Commission and went on to serve as IOC President from 2001 to 2013. “It changed the IOC for the good.” Ever since the Ben Johnson scandal at Seoul 1988, doping has been a vexing issue in global sport. The IOC has  48 OLYMPIC REVIEW  taken the lead by storing and reanalysing doping samples, founding the World Anti-Doping Agency in 1999 and supporting the creation of the International Testing Agency in 2018. The IOC also set up the Court of Arbitration for Sport (CAS) in 1984 to adjudicate doping and other sporting disputes. Since Rio 2016, the IOC has delegated sanctioning of Olympic doping cases to CAS and its anti-doping division to ensure the independence of the process.  Clockwise from left The IOC Executive Board now includes an elected athlete representative; the Olympic Museum opened in 1993; the International Testing Agency was set up in 2018 to strengthen anti-doping.  “You have to be conscious of the fact that doping, like theft, like tax evasion, like fraud, cannot be eradicated 100 per cent,” says President Bach. “This should not discourage you. It should encourage you to do better every day.” In 1993, the current Olympic Museum was opened in Lausanne, fulfilling Coubertin’s dream of having a repository for the history of the Olympic Games and IOC. Linked to the Museum is the IOC Olympic Studies Centre, offering a trove of material for researchers, students and scholars. The IOC’s engagement in international diplomacy over the years has coincided with the establishment of close links with the United Nations (UN). In 1993, the UN General Assembly approved a resolution to revive the Olympic Truce, an initiative which has been applied to every Games since. The IOC was granted Permanent Observer Status by the UN General"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 48,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg49.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 49,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg50.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://www.youtube.com/watch?v=yFh1otyJY8k\" target=\"_blank\">\n          <svg class=\"abs pointer\" style=\"width:50px; height:50px;left:275px;top:606px\" version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"675px\" height=\"675px\" viewBox=\"0 0 675 675\" enable-background=\"new 0 0 675 675\" xml:space=\"preserve\">\n            <circle fill=\"none\" stroke=\"#000\" stroke-width=\"30\" stroke-miterlimit=\"10\" cx=\"339.195\" cy=\"340\" r=\"321\"/>\n            <polyline fill=\"#000\" points=\"558,356 207,563 207,117 \"/>\n          </svg>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "THE IOC AT 125  Assembly in 2009. In 2014, the UN formally recognised the autonomy of the IOC and sport. The former UN Secretary General, Ban Ki-moon, was elected as IOC Ethics Commission chair in 2017. Recent decades have also seen changes to the Olympic sports programme, including the addition of taekwondo, beach volleyball, triathlon, golf and rugby sevens. Surfing, skateboarding, sport climbing, karate and baseball/softball have been included for Tokyo 2020. Break dancing  50 OLYMPIC REVIEW  Left to right President Bach with Ban Ki-moon; Australia won the first-ever Olympic gold medal in rugby sevens; sport climbing will debut in Tokyo; Dakar 2022 will be the first Olympic competition held in Africa.  (or “breaking”) has been proposed for Paris 2024. For the Olympic Winter Games, snowboarding was introduced at Nagano 1998. The new sports tie in with the IOC push to make the Games more relevant for young people, most notably through the creation in 2007 of the Youth Olympic Games (YOG), a project spearheaded by Rogge. Three summer and two winter editions of the YOG have been held to date. In an historic decision, the IOC voted in October 2018 to award the YOG 2022 to Dakar, Senegal, marking the first time an Olympic competition will be held on the African continent. The IOC has also been at the forefront of promoting gender equality, adding new events for women and bringing the ratio of male to female athletes at the Games to nearly 50-50. For Tokyo 2020, female participation will rise to a projected 48.8 per cent, while Beijing 2022 is expected to reach a Winter Games record of 45.44 per cent female representation."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 50,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg51.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "THE IOC AT 125  Since his election in 2013, President Bach has been busy seeing through the reforms of his Olympic Agenda 2020, the IOC’s strategic roadmap for the future of the Games. It’s part of the drive to stay relevant and adapt Coubertin’s vision to the trends of today’s society. What would Coubertin, who died in 1937, make of the Games and the IOC today? Would he be satisfied or horrified? A little of both, says President Bach. “On one hand, he would be very happy to see the Games being so relevant and the Games being adapted to modern times,’’ he says. “On the other hand, when we are discussing our sports reform programme for Tokyo, I sometimes wonder if he would be turning over in his grave. “But overall,” the IOC President adds, “I think he would be pretty pleased.” ■ Steve Wilson is the former European Sports Editor and Olympic Correspondent of The Associated Press and former President of the Olympic Journalists Association. He has covered 15 Olympic Games and Olympic Winter Games, and served as a mentor in the IOC Young Reporters Programme at the YOG Buenos Aires 2018.  OLYMPIC REVIEW 51"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 51,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg52.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "THROUGH THE LENS OLYMPIC DAY"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 52,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg53.jpg",
    "zoom": null,
    "content": "\n        <img id=\"53-title-1\" class=\"halfScale\" style=\"top:162px;left:450px;\" src=\"/111/static/_content/53-title-1.png\">\n        <img id=\"53-title-2\" class=\"halfScale\" style=\"top:265px;left:450px;\" src=\"/111/static/_content/53-title-2.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg53Anim = new TimelineMax();\n          pg53Anim.fromTo(idOf(\"53-title-1\"), 0.6, {x:60, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, 1)\n          .fromTo(idOf(\"53-title-2\"), 0.6, {x:60, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, \"-=0.2\")\n        }\n    \n        function onPageLeave() {\n          pg53Anim.stop();\n        }\n      ",
    "searchText": "THROUGH THE LENS WITH 23 JUNE MARKING THE 125TH ANNIVERSARY OF THE IOC, WE TAKE A LOOK AT HOW THE DATE HAS BECOME SYNONYMOUS WITH OLYMPIC DAY – AN ANNUAL CELEBRATION FIRST HELD IN 1948 THAT HELPS PROMOTE SPORTS PARTICIPATION AND THE OLYMPIC VALUES THROUGHOUT THE WORLD  New Zealand, 2018 In 2018, the New Zealand Olympic Committee held an Olympic Day event for 300 refugees aged between 11 and 18, giving them the chance to try nine Olympic sports while meeting some of New Zealand’s Olympic athletes. The event, which also coincided with World Refugee Day, aimed to show how sport can help integrate refugees into local society, while also having a positive impact on their wellbeing. Here, Hibo Musa tries her hand at judo.  OLYMPIC REVIEW 53"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 53,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg54.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "THROUGH THE LENS OLYMPIC DAY  01 Italy, 1958 Members of the public look at posters promoting the Olympic Day celebrations held in Modena, northern Italy, in 1958. The historic city has a strong Olympic tradition as the hometown of gold medallists Claudio Vandelli, Guido Romano, Alfredo Gollini and Arnaldo Andreoli.  02 Greece, 1967 Every year, Olympic Day is especially celebrated in Greece, the birthplace of the modern Olympic Games, with fans packing out the iconic Olympic Stadium in Athens in 1967 for a one-day festival of sport.  03 Japan, 1970 Many Olympic Day events offer training sessions to young people in various Olympic sports, with the aim of getting as many people involved in sport as possible. Here, the Japanese Olympic Committee is hosting a football session for children in Kagoshima, on the island of Kyushu, as part of its celebrations in 1970.  04 Chinese Taipei, 1988 Starting in 1987, many National Olympic Committees (NOCs) began celebrating Olympic Day with the Olympic Day Run – a 10km fun run aimed at encouraging all of society to be active. One year later in Chinese Taipei, thousands of people – seen here running past the main gate of the city’s historic Liberty Square – would participate. The number of NOCs hosting an Olympic Day Run has grown from 45 in 1987 to more than 150 today, with people now taking part over distances of 1.5km, 5km and 10km.  54 OLYMPIC REVIEW  01  02"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 54,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg55.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "03  04"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 55,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg56.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "01  THROUGH THE LENS OLYMPIC DAY  02  56 OLYMPIC REVIEW  03"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 56,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg57.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "THROUGH THE LENS  01 Algeria, 1993 Perhaps inspired by Hassiba Boulmerka winning Algeria’s first-ever Olympic gold medal just a year earlier – in the 1,500m at the Olympic Games Barcelona 1992 – the country’s Olympic Day celebrations in 1993 attracted many young Algerians, including to this cycling event in Zéralda.  02 São Tomé and Príncipe, 1995 The growth of the Olympic Movement has helped spread the Olympic Day message around the world. Following its recognition by the IOC in 1993, the NOC of São Tomé and Príncipe joined the Olympic Day celebrations, including hosting this basketball session in 1995.  04  03 Cyprus, 2003 Since its establishment, Olympic Day has developed into much more than just a sports event. Based on the three pillars “move”, “learn” and “discover”, NOCs now organise sports, cultural and educational activities, including this children’s art workshop that was held in Cyprus in 2003.  05 04 Kenya, 2005 Tug of war was contested as an Olympic medal event at every edition of the Games from 1900 to 1920. The event is now a fun and competitive activity for many Olympic Day celebrations, as demonstrated here in Kenya.  05 Czech Republic, 2014 One of the greatest features of Olympic Day is the opportunity it gives people to try new sports. Here, members of the public enjoy the chance to try white-water rafting in the Czech Republic.  OLYMPIC REVIEW 57"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 57,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg58.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "58 OLYMPIC REVIEW"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 58,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg59.jpg",
    "zoom": null,
    "content": "\n        <img id=\"59-title\" class=\"halfScale\" style=\"top:179px;left:166px;\" src=\"/111/static/_content/59-title.png\">\n\n        <a href=\"https://www.olympic.org/news/ioc-releases-evaluation-commission-2026-report\" target=\"_blank\">\n          <div class=\"addContentLink\" style=\"top:530px;left:609px;width:109px;height:14px\"></div>\n        </a>\n        <a href=\"https://www.olympic.org/benefits-of-the-2026-process\" target=\"_blank\">\n          <div class=\"addContentLink\" style=\"top:506px;left:455px;width:82px;height:14px\"></div>\n        </a>\n        <a href=\"https://www.olympic.org/benefits-of-the-2026-process\" target=\"_blank\">\n          <div class=\"addContentLink\" style=\"top:519px;left:398px;width:89px;height:14px\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg59Anim = new TimelineMax();\n          pg59Anim.fromTo(idOf(\"59-title\"), 0.6, {x:60, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut, onComplete: addContentLinks}, 1)\n        }\n    \n        function onPageLeave() {\n          pg59Anim.stop();\n          removeContentLinks()\n        }\n      ",
    "searchText": "CANDIDATE CITIES 2026  AHEAD OF THE VOTE TO DECIDE THE HOST OF THE OLYMPIC WINTER GAMES 2026 AT THE IOC SESSION IN JUNE, CANDIDATE CITIES STOCKHOLM-ÅRE AND MILAN-CORTINA PRESENT THEIR SUSTAINABILITY AND LEGACY PLANS  A  s the first to fully benefit from Olympic Agenda 2020/ New Norm, the 2026 Candidature Process marked the start of a new era, reflecting the International Olympic Committee’s (IOC) reimagined approach to planning and delivering the Games. This new process – based on increased flexibility and an indepth dialogue between the IOC, National Olympic Committees (NOCs) and potential host cities – was launched in October 2017, designed to help cities and NOCs stage even more sustainable, feasible and cost-effective Games that benefit residents and align with local, regional and national development goals. At the start of 2019 – following a one-year, non-committal Dialogue Stage and a shortened formal Candidature Stage – the IOC received candidature files from Stockholm-Åre (Sweden) and Milan-Cortina (Italy) and, on 24 June, the IOC Members will vote to decide which candidate has been successful in its bid to host the Olympic Winter Games 2026.  These were the first candidature files produced since Olympic Agenda 2020/The New Norm was approved by the IOC Session in February 2018, and its recommendations are already delivering substantial benefits to the cities and their projects. On average, the Candidate Cities 2026 will use 80 per cent existing or temporary venues, compared to 60 per cent among the candidates for the Olympic Winter Games 2018 and 2022. In addition, the initial Games operating costs projected by the Cities are on average 20 per cent lower than those in the two previous candidature processes. “With these two traditional sports countries as candidates, we see the very positive impact of the Olympic Agenda 2020 reforms,” said Octavian Morariu, the Chair of the IOC Evaluation Commission for the Olympic Winter Games 2026. On the following pages, Olympic Review has invited each city to present their visions for the Games, as well as their sustainability and legacy plans.  * CITIES ARE LISTED IN THE ORDER OF DRAWING OF LOTS AS PERFORMED BY THE IOC EXECUTIVE BOARD.  ALL EYES ON 2026  OLYMPIC REVIEW 59"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 59,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg60.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://stockholm-are2026.com/en/\" target=\"_blank\">\n          <div class=\"addContentLink\" style=\"top:247px;left:60px;width:280px;height:32px\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "CANDIDATE CITIES 2026  STOCKHOLM-ÅRE The Stockholm-Åre 2026 vision is bold and profound, and it is reflected in our slogan, “Made in Sweden”; our goal is to create a transformative Olympic and Paralympic Winter Games for the future that: • Uses the Winter Games to encourage more physical activity and sports to promote healthy lifestyles among Swedish youth; • Harnesses the Olympic and Paralympic values to create a more united, integrated and inclusive society for all Swedes; • Highlights our diverse nation and culture as a great place to visit; • Reaffirms Sweden’s recognised financial stability and our leadership in sustainability and delivery; • Creates an authentic and magical Swedish Winter Games experience for all stakeholders; • Creates a new and responsible hosting model, setting new standards as well as a platform for innovation for sustainability, creativity and fiscal responsibility for every Winter Games beyond 2026. Sweden is a multifaceted gem, where our respect for moderation and order meet ground-breaking social, technological and environmental advancements. Our country and culture embody a respect towards human and natural capital, where the richest and most precious investment we can make is in every member of our society and the world in which we share. All new construction of competition venues serves a very real need and benefits the people of Stockholm and Sweden. A new ski area for biathlon and cross-country skiing with  60 OLYMPIC REVIEW  snowmaking systems in the town of Botkyrka, approximately 20km from the centre of Stockholm, will be of great value for children, youth, exercise enthusiasts and the hosting of future events. Swedes are passionate about these sports. Popular amateur races such as the Vasaloppet attract 100,000 participants yearly and generate approximately EUR $30 million in tourismrelated revenue. These dedicated participants travel over 300km to train for this weekend race and, as such, a more local venue is of great legacy value. Furthermore, Stockholm has struggled in accommodating all training and competition needs for ice sports. Consequently, the Speed Skating Oval, converted into a multi-sport venue after the Games, will be of great value for youth, recreation and competitive sports in Stockholm. A healthy environment contributes to healthy people, therefore we must act to preserve our natural resources and constantly work to reduce greenhouse emissions. This is why sustainability and green living are an integral part of the Swedish identity. Sustainability and legacy are not only part of the core values of StockholmÅre 2026, they are part of our DNA. The Stockholm-Åre 2026 Olympic and Paralympic Winter Games are not just for our benefit in 2026 – they are for the future of the entire Olympic and Paralympic Movements, in Sweden and around the world. Our vision is not “neutral” Games when it comes to sustainability – our vision is that the Games should contribute to a stronger, better and more sustainable world."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 60,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg61.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 61,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg62.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://milanocortina2026.coni.it/en/\" target=\"_blank\">\n          <div class=\"addContentLink\" style=\"top:251px;left:60px;width:254px;height:28px\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "CANDIDATE CITIES 2026  MILAN-CORTINA The Milan-Cortina 2026 Candidature fully embraces the IOC’s Olympic Agenda 2020/New Norm, putting the long-term development strategies and challenges of the host cities and regions at the centre. We will contribute to a golden decade of Olympic and Paralympic sport, placing Milan-Cortina alongside other leading international cities, to help reposition the Games in modern society. The selection of the venues is fully aligned with the ambition of northern Italy to become a world-class hub of excellence for winter sports. The Games will showcase the quality of the selected sports infrastructure and help to invest in renovating/upgrading those venues that need investments. The Games will also be conducive to greater cooperation in the entire Alpine macro-region, to improve the attractiveness of the mountains as a place to live and reverse the trend of depopulation. Finally, the Games are a unique opportunity to showcase Italy’s design style that has seen the “Made in Italy” brand become synonymous with excellence all over the world. With 87 per cent overarching support from our community (and 83 per cent nationally), our Games will be positioned to improve the lives of inhabitants, visitor experience, and invite community engagement in sport, health and physical activity. We will use inspirational images and athlete stories to drive sports development and educational programmes in the build-up to Games-time, involving more than 8.8 million students. Sports presentation and ceremonies will be world class and will include innovative ideas and technology to enhance spectator engagement and experience. High quality,  62 OLYMPIC REVIEW  interactive activities at fan zones will help spectators live a “round-the-clock” Olympic experience and indulge in the Italian way of life as part of their visit through tailored packages relating to food, culture and tourism. The Olympic Winter Games are fully aligned with and will act as a catalyst for the city and regional long-term development plans. We want to build on our strong environmental credentials and use the Games to help accelerate our sustainability plans, by exceeding ISO 20121: Event Sustainability Management System. In this way, we will help the IOC to attract a wider audience of cities to bid in the future. The Master Plan has been conceived to minimise the environmental impact, thanks to the wide use of existing infrastructures. The Strategic Environmental Assessment for the MilanCortina 2026 Olympic Winter Games will ensure that environmental considerations are taken on board, with a coherent stakeholder engagement programme. Our legacy vision is to use the “power of the Games” as a catalyst to deliver our long-term strategic plans. We have identified four priority themes: sport, social, economic and environmental. A Sustainability and Legacy Permanent Forum will be immediately established to coordinate all the organisations with responsibilities for legacy delivery, through a comprehensive legacy programme, with quantified indicators and clear monitoring and evaluation. Our Generation 2026 will play sports regularly, recycle three quarters of the waste they produce, use sustainable means of transportation only, use sport to understand cultural diversity, and grow in a more inclusive and integrated society."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 62,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg63.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 63,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg64.jpg",
    "zoom": null,
    "content": "\n        <img id=\"64-title-1\" class=\"halfScale\" style=\"top:254px;left:42px;\" src=\"/111/static/_content/64-title-1.png\">\n        <img id=\"64-title-2\" class=\"halfScale\" style=\"top:206px;left:68px;\" src=\"/111/static/_content/64-title-2.png\">\n\n        <a href=\"https://www.youtube.com/watch?v=zwXp8lmeUuA\" target=\"_blank\">\n          <svg class=\"abs pointer\" style=\"width:50px; height:50px;left:690px;top:86px\" version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"675px\" height=\"675px\" viewBox=\"0 0 675 675\" enable-background=\"new 0 0 675 675\" xml:space=\"preserve\">\n            <circle fill=\"none\" stroke=\"#000\" stroke-width=\"30\" stroke-miterlimit=\"10\" cx=\"339.195\" cy=\"340\" r=\"321\"/>\n            <polyline fill=\"#000\" points=\"558,356 207,563 207,117 \"/>\n          </svg>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg64Anim = new TimelineMax();\n          pg64Anim.fromTo(idOf(\"64-title-1\"), 0.6, {x:60, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, 1)\n          .fromTo(idOf(\"64-title-2\"), 0.6, {x:60, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, \"-=0.3\")\n        }\n    \n        function onPageLeave() {\n          pg64Anim.stop();\n        }\n      ",
    "searchText": "TOKYO 2020 VISION  TOKYO 2020 VISION  JUSTINE DUPONT THE FRENCH SURFING STAR SPEAKS TO SAM PRICE ABOUT HER EXCITEMENT AHEAD OF THE SPORT’S OLYMPIC DEBUT IN TOKYO, AND EXPLAINS HOW A PASSION FOR ENVIRONMENTAL ISSUES PERSUADED HER TO BECOME AN IOC CLEAN SEAS AMBASSADOR  64 OLYMPIC REVIEW  W  hile surﬁng will make its Olympic debut next year in Tokyo, the sport in fact has a long and cherished association with the Olympic Games. Duke Kahanamoku, the Hawaiian who is considered the founding father of modern surﬁng, was also an elitelevel swimmer, and won ﬁve Olympic medals for the United States – including three golds – across three editions of the Games between 1912 and 1924. Kahanamoku had a vision that surﬁng would one day feature at the world’s biggest sporting event, even putting his case forward to the IOC in 1920. One hundred years on, with the sport enjoying increased popularity across the globe, his dream will be realised. The latter part of the intervening period has seen tireless work from the International Surﬁng Association (ISA) and its charismatic Argentinian  president Fernando Aguerre, who has been able to draw upon high-proﬁle athletes from within the sport to aid his cause. One such athlete is Justine Dupont, a trailblazer from the southwest coast of France who is equally accomplished on big or smaller waves, and who has been working closely with the ISA on preparations for surﬁng’s inaugural Olympic competition as part of her role as chair of the ISA Athletes’ Commission. Surﬁng’s addition to the Games seems to have happened at the perfect point in the 27-year-old’s career. And with the sport recently put forward for inclusion on the sport programme by the Paris 2024 Organising Committee, Dupont can even start dreaming about winning an Olympic medal on home waves. “Only a few years ago, it was hard to imagine surﬁng being part of the"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 64,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg65.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OLYMPIC REVIEW 65"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 65,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg66.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "TOKYO 2020 VISION  Olympic Games, but now it looks like it will be included through Tokyo 2020 and Paris 2024 – and hopefully Los Angeles 2028,” she says. “It is a really exciting time for the surﬁng community, but the ﬁrst one is really important. We have to make sure we put on a great show.” The men’s and women’s events in Tokyo will feature 20 athletes each, with surﬁng superstars such as Australia’s Stephanie Gilmore and Brazil’s Gabriel Medina expected to line up at Tsurigasaki Beach, located 90km south-east of Tokyo. But despite its distance from the Olympic Village, Dupont believes that all of the athletes and fans there will feel the Olympic spirit, and that surﬁng will bring a culture and vibe that ﬁts well with the Games. “We already have our World Surﬁng Games, which we used to call our ‘little Olympics’,” she explains. “So we are used to the values of Olympism: the culture around athletes from different countries and speaking different languages coming together to share the same sport. “The IOC also seems to really want to embrace all of the culture around surﬁng, and take all of the things that are working well in the existing tour. It will be the same format as a normal competition, but the stakes will be way higher, and we’ll be showcasing the sport to a new and bigger audience.” Dupont can qualify by performing well on the World Surf League’s Championship Tour – which hands out equal prize money to men and women, demonstrating the sport’s commitment to gender equality – and at the ISA World Surﬁng Games, which will be held in Japan this year and expects to welcome athletes from more than 40 countries and all ﬁve continents, highlighting surﬁng’s global appeal. Should she achieve qualiﬁcation then high stakes should be no problem for Dupont. As one of the most versatile surfers in the world with medals to her name in longboard and stand-up paddling, she competes in another discipline – 'Big Wave' surﬁng. This daredevil event will never be seen at the Games because such waves only appear in a handful of countries, and are completely dependent on weather conditions. In Big Wave, participants wait for huge swells – which are usually forecast only days before they arrive – and try to ride the wave, with Dupont one of the world’s best practitioners having competed against and even beaten her male counterparts.  66 OLYMPIC REVIEW"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 66,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg67.jpg",
    "zoom": null,
    "content": "\n        <img id=\"67-quote\" class=\"halfScale\" style=\"top:556px;left:69px;\" src=\"/111/static/_content/67-title-1.png\">\n        <a href=\"https://www.cleanseas.org/\" target=\"_blank\">\n          <div class=\"addContentLink\" style=\"top:822px;left:280px;width:57px;height:13px\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg67Anim = new TimelineMax();\n          pg67Anim.fromTo(idOf(\"67-quote\"), 0.6, {y:60, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut, onComplete: addContentLinks}, 1)\n        }\n    \n        function onPageLeave() {\n          pg67Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "TOKYO 2020 VISION  Clockwise from far left Justine Dupont during a Big Wave session; on the road to recovery from injury; at her winter training base in Nazaré  ‘WHEN I GO TO THE GYM, IN THE BACK OF MY MIND IS THE FACT THAT I’M DOING IT TO SAVE MY LIFE’ JUSTINE DUPONT “While [an Olympic medal] is a big goal, it’s not the main goal of my life – because I’m really enjoying Big Wave surﬁng as well, and I have a goal to set a world record,” explains Dupont, who in 2013 became the ﬁrst woman to tame the 15m monster of Belharra in her home country. “This goal is very intense and I need to be training at the highest possible level to achieve it.” The perils associated with Big Wave surﬁng were experienced ﬁrst-hand by Dupont in November 2018, when she dislocated her shoulder and knee during a competition in Hawaii. Now on the comeback trail, Dupont  has been working extra hard on her ﬁtness, equipment and safety protocol at her winter training base in Nazaré (Portugal) to minimise the risk of a repeat. “When I’m training, I know that I have to do a little more, because there is a risk that I want to reduce when I’m competing,” she says. “I will never be stronger than the ocean and I can risk my life in Big Wave surﬁng, so when I go to the gym, all the time in the back of my mind is the fact that I’m doing it to save my life. “That helps me a lot, especially on the mental side. Of course you get scared in Big Wave, but you learn a lot about yourself by pushing your limits, which is useful for other events like the Olympic Games. I’m trying to pick all the ingredients to build the best preparation I can for Tokyo 2020.” Dupont’s passions extend beyond catching a wave, and spending so much time in the ocean has provoked a strong interest in environmental issues. Recently, she was appointed an IOC Clean Seas Ambassador as part of a campaign  launched by the UN Environment Programme and the IOC to raise awareness on the issue of marine litter, which has secured active participation from a number of International Federations, including the ISA. “Our sport is in the ocean, so we are well connected with nature, climate and the environment,” she explains. “It’s part of surﬁng. I’m passionate about the feeling of nature; and when you’re passionate about it, you have to be respectful of it. We can see the direct impact of throwing something away in the city, because that little piece of waste will probably end up in the sea. “You also learn and realise that being an athlete, you reach more people. And as an athlete, the more that you can push [these kind of issues], the better. I believe that big changes start from the bottom up, so we can all take little, yet important, steps to protect our oceans for future generations to enjoy. “There are a lot of people thinking more and more [about these issues], and now  OLYMPIC REVIEW 67"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 67,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg68.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://www.olympicchannel.com/en/video/detail/justine-dupont-how-pollution-affects-my-surfing/\" target=\"_blank\">\n          <svg class=\"abs pulse animatedpulse pointer\" style=\"width:50px; height:50px;left:80px;top:186px\" version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"675px\" height=\"675px\" viewBox=\"0 0 675 675\" enable-background=\"new 0 0 675 675\" xml:space=\"preserve\">\n            <circle fill=\"none\" stroke=\"#000\" stroke-width=\"30\" stroke-miterlimit=\"10\" cx=\"339.195\" cy=\"340\" r=\"321\"/>\n            <polyline fill=\"#000\" points=\"558,356 207,563 207,117 \"/>\n          </svg>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "TOKYO 2020 VISION  some brands are running great campaigns about solutions to protect nature and the ocean, so I think we’re on a good wave.” The Ichinomiya town in Chiba that will host the Olympic surﬁng events has pledged to support the Clean Seas campaign in the build-up to and during the Games. In addition to the art, yoga, music and “try the sport” sessions set to feature at a surﬁng festival complementing the four days of competition, there will be activations and panel discussions around a range of sustainability topics. Dupont’s excitement for next summer is evident, and she believes that adding surﬁng to the Games – along with other youthoriented sports such as skateboarding and sport climbing – will be mutually beneﬁcial for her sport and the Olympic Movement, with surﬁng promising to bring a unique culture, an engaged fanbase, and an awareness of environmental issues to the two-week extravaganza in Tokyo. And having already achieved recordbreaking success within her sport, if Dupont can mark the celebrations with a medal, the fearless Frenchwoman’s place in Olympic history will be secure. ■  68 OLYMPIC REVIEW  Above Collecting marine litter as part of her work as an IOC Clean Seas Ambassador Right Dupont has excelled at a range of surﬁng disciplines such as longboard"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 68,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg69.jpg",
    "zoom": null,
    "content": "\n        <img id=\"69-quote\" class=\"halfScale\" style=\"top:302px;left:326px;\" src=\"/111/static/_content/69-quote.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg69Anim = new TimelineMax();\n          pg69Anim.fromTo(idOf(\"69-quote\"), 0.6, {y:-60, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut}, 1)\n        }\n    \n        function onPageLeave() {\n          pg69Anim.stop();\n        }\n      ",
    "searchText": "TOKYO 2020 VISION  TALKING TOKYO  Justine Dupont on…  ‘WE CAN ALL TAKE LITTLE STEPS TO PROTECT OUR OCEANS FOR FUTURE GENERATIONS’ JUSTINE DUPONT  Competing at the Games “For me, it’s a big goal for sure. It’s a little more than one year to go, so it’s going to come up fast, and the preparation has already started. Obviously there are a lot of competitions between now and then, but we all want to be ready for next summer. The ﬁrst one is going to be really, really exciting.”  Local knowledge “I have been to competitions in Japan before, and it’s been nice to get used to the culture of the country, and the surf camps where you can prepare. It reduces the unknown, and you can think about how you will perform. Since the venue is not in Tokyo we will have our own little athletes’ village, and we’re going to bring all the festivities around surﬁng with us.”  Impact and legacy “For me, being a part of the Olympic Games means greater exposure, more people involved, and more people discovering surﬁng and the values of the sport. More girls, more boys, and more youths will have a goal to go to the Olympic Games, to perform and to push the level of surﬁng higher and higher.”  OLYMPIC REVIEW 69"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 69,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg70.jpg",
    "zoom": null,
    "content": "\n        <img id=\"70-title-1\" class=\"halfScale\" style=\"top:380px;left:67px;\" src=\"/111/static/_content/70-title-1.png\">\n        <img id=\"70-title-2\" class=\"halfScale\" style=\"top:521px;left:66px;\" src=\"/111/static/_content/70-title-2.png\">\n\n        <a href=\"https://www.olympicchannel.com/en/original-series/detail/legends-live-on/\" target=\"_blank\">\n          <div class=\"addContentLink\" style=\"top:519px;left:354px;width:101px;height:13px\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg70Anim = new TimelineMax();\n          pg70Anim.fromTo(idOf(\"70-title-1\"), 0.6, {x:60, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, 1)\n          .fromTo(idOf(\"70-title-2\"), 0.6, {x:60, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut, onComplete: addContentLinks}, \"-=0.3\")\n        }\n    \n        function onPageLeave() {\n          pg70Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "LEGENDS LIVE ON SUBJECT OF AN EPISODE OF THE OLYMPIC CHANNEL’S LEGENDS LIVE ON SERIES, OLYMPIC WEIGHTLIFTING CHAMPION MATTHIAS STEINER IS SPREADING THE WORD ON HEALTHY LIVING AND DEALING WITH DIABETES IN HIS CURRENT ROLE AS A FITNESS AND NUTRITION COACH. BY GRUFFUDD OWEN  T  he road to an Olympic gold medal is a long and often torturous one. That crowning achievement of stepping onto the podium – the culmination of an athlete’s dream, the legacy by which they will be remembered – involves years of hard work, countless hours of practice and a fair share of setbacks along the way. This is what makes Matthias Steiner’s own gold medal story all the more remarkable. Aside from the everyday challenges faced by all Olympic hopefuls, the Austrian-German weightlifter had to contend not only with a diabetes Type 1 diagnosis at the age of 18, an autoimmune disease, but also the tragic death of his ﬁrst wife Susann just one year before the Olympic Games Beijing 2008.  70 OLYMPIC REVIEW  That Steiner overcame such sorrow and hardship to win gold in Beijing is testament to his character and force of personality, and his inspirational tale has now been retold in an episode of the Olympic Channel’s original series Legends Live On. Now into its second season, the show puts the spotlight on Olympic stars who have translated their success into careers and who are educating and inspiring the next generation. Other Olympians featuring in the latest series include French freestyle skiing gold medallist and motivational speaker Edgar Grospiron, double Alpine skiing gold medallist and Slovenian pop culture icon Tina Maze and six-time fencing gold medallist Valentina Vezzali, who now serves as a politician in Italy.  Among such esteemed company, Steiner had no doubts about his participation in the series. “In the past 10 years, I have often spoken about my situation and my life,” he explains. “Sometimes it felt good, and other times it wasn’t so pleasant. With the Olympic Channel, I ﬁnally got a sense that this is where my story belonged. After all, the Olympic Games were the origin for my thrilling journey, and naturally I feel honoured that my achievement puts me on the same level as other sporting greats.” The episode focuses on Steiner’s efforts to promote healthy living, and with Olympic Day taking place on 23 June – an annual event encouraging people to get active – his transformation from a super heavyweight athlete to"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 70,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg71.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Pictured Matthias Steiner, a gold medallist at Beijing 2008, tells his story in the new Olympic Channel series of Legends Live On  OLYMPIC REVIEW 71"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 71,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg72.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://www.olympicchannel.com/en/original-series/detail/legends-live-on/legends-live-on-season-season-2/episodes/where-are-they-now-matthias-steiner-s-legend-lives-on/\" target=\"_blank\">\n          <svg class=\"abs pulse animatedpulse pointer\" style=\"width:50px; height:50px;left:470px;top:176px\" version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"675px\" height=\"675px\" viewBox=\"0 0 675 675\" enable-background=\"new 0 0 675 675\" xml:space=\"preserve\">\n            <circle fill=\"none\" stroke=\"#000\" stroke-width=\"30\" stroke-miterlimit=\"10\" cx=\"339.195\" cy=\"340\" r=\"321\"/>\n            <polyline fill=\"#000\" points=\"558,356 207,563 207,117 \"/>\n          </svg>\n        </a>\n\n        <a href=\"https://www.olympicchannel.com\" target=\"_blank\">\n          <div class=\"addContentLink\" style=\"top:470px;left:293px;width:105px;height:13px\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "INSIDE THE OLYMPIC CHANNEL  a noticeably leaner ﬁtness and nutrition coach is particularly apt. Steiner shed 45kg in weight after retiring in 2013, and while bulking up is a key feature of his sport, the 36-year-old is determined to help ordinary people lead healthy and nutritious lives now that his competitive days are behind him. “It’s a fact: we live in a time where people are becoming increasingly overweight,” he says. “The temptations confronting people are too great, and they know too little about nutrition. I don’t coach athletes; I prefer to work with people who have weight problems and who feel lethargic, which is usually caused by their lack of exercise and the wrong nutrition. “I try to counter this with fun. I use humour to clear up misconceptions and would still like to have my clients decide how and how often they move about and consume food. But with my support, it’s quite a bit easier for them!” Steiner’s own experience of weight loss inspired him and his journalist wife Inge to write The Steiner Principle, which has been a best-seller in Germany. In the book, Steiner reveals his knowledge about nutrition in his own developed weight loss programme. His Type 1 diabetes gave him a greater understanding of human metabolism. Steiner’s former coach Frank Mantek appears frequently on the Olympic Channel episode, and discusses the lengths to which he had to adapt the training programme following the diagnosis. The difﬁculties Steiner faced in balancing his weightlifting ambitions with the sobering reality of his condition has driven him to help and support fellow sufferers in his current occupation as a ﬁtness and nutrition coach. “When my blood glucose levels were too high, the quality of my training suffered, and when the values were too low, I didn’t even have to bother starting, since my body was incapable of accomplishing anything,” he says. “When something like that happened, we had to either wait a while and take countermeasures – like eating dextrose when they were too low – or simply postpone the training for a day. It was not always easy for my coach and his ability to plan.  72 OLYMPIC REVIEW  “People with Type 1 diabetes are generally well informed, but sooner or later almost everyone gets to a point where they are stuck or simply have questions, especially in combination with sports. That’s where I come in. I can share my large store of experience with them, which is also exciting for me because new questions or situations are constantly coming up. I usually see successful results because I have been able to pass on something that the person in question wasn’t aware of.” For all that Steiner has been through, there is a sense that he is embracing his new life away from competitive weightlifting, and that he is excited by the possibilities of his work in ﬁtness and nutrition – while there are also plans to expand his business ventures by manufacturing low-carb products. Given his track record in overcoming adversity – both personal and professional – the signs suggest that this latest chapter in Steiner’s life can be as golden as his summer of 2008. ■ Go to olympicchannel.com or its mobile apps to watch Legends Live On  COPING WITH GRIEF AS A SPORTSPERSON Above right Steiner holds up a photo of his late wife Susann after winning gold in Beijing Below He is now a ﬁtness coach and sometimes trains athletes in weightlifting  Legends Live On touches on a tragic moment in Steiner’s life in July 2007 – one year before his career-deﬁning performance at the Olympic Games Beijing 2008 – when his ﬁrst wife Susann died in a car accident. Here, he explains how weightlifting helped him cope with the grief and depression that followed... “Weightlifting is a physically strenuous sport. You don’t really have much time for reﬂection; not even in the evenings, since you are so physically exhausted, you fall asleep the minute things quieten down. Of course, my Olympic dream was so great; I was able to cling onto that. “Seek a goal that is important to you on an emotional level. It doesn’t always have to be as ambitious as the Olympic Games, but it does have to grab hold of you and have an effect on you. “It’s important that you feel needed and loved. That was the case for me because I was the crowd puller of the national team; that’s why I quickly regained a purpose in my life. “There’s also the matter of acceptance. Accept the fact that the situation is irreversible. There are then only two paths forward: either I let myself go, or I go on. Either way, what has happened to me remains unchanged.”"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 72,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg73.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://www.olympicchannel.com\" target=\"_blank\">\n          <div class=\"addContentLink\" style=\"top:231px;left:375px;width:169px;height:24px\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 73,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg74.jpg",
    "zoom": null,
    "content": "\n        <div class=\"abs noOverflow\" style=\"top:265px;left:209px;width:304px;height:100px\">\n          <img class=\"halfScale\" id=\"74-title-1\" src=\"/111/static/_content/74-title-1.png\">\n        </div>\n        <div class=\"abs noOverflow\" style=\"top:365px;left:209px;width:376px;height:72px\">\n          <img class=\"halfScale\" id=\"74-title-2\" style=\"top:27px;\" src=\"/111/static/_content/74-title-2.png\">\n        </div>\n\n        <a href=\"https://www.youtube.com/watch?v=C79FsU-oF_Q\" target=\"_blank\">\n          <svg class=\"abs pointer\" style=\"width:50px; height:50px;left:550px;top:301px\" version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"675px\" height=\"675px\" viewBox=\"0 0 675 675\" enable-background=\"new 0 0 675 675\" xml:space=\"preserve\">\n            <circle fill=\"none\" stroke=\"#fff\" stroke-width=\"30\" stroke-miterlimit=\"10\" cx=\"339.195\" cy=\"340\" r=\"321\"/>\n            <polyline fill=\"#fff\" points=\"558,356 207,563 207,117 \"/>\n          </svg>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg74Anim = new TimelineMax();\n          pg74Anim.fromTo(idOf(\"74-title-1\"), 0.6, {y:110}, {y:0, ease: Power2.easeOut}, 1)\n                  .fromTo(idOf(\"74-title-2\"), 0.6, {y:-75}, {y:0, ease: Power2.easeOut}, \"-=0.3\")\n        }\n    \n        function onPageLeave() {\n          pg74Anim.stop();\n        }\n      ",
    "searchText": "MY GAMES  MY GAMES  BERNHARD RUSSI SWISS SKI RACER BERNHARD RUSSI WON DOWNHILL GOLD AT THE OLYMPIC WINTER GAMES SAPPORO 1972, BEFORE AN EPIC BATTLE AGAINST FRANZ KLAMMER AT INNSBRUCK 1976 THAT MANY CONSIDER THE GREATEST SKI RACE OF ALL-TIME  74 OLYMPIC REVIEW  MEMORIES OF MY FIRST GAMES  BECOMING OLYMPIC CHAMPION  It’s like yesterday – everything is very clear. The Opening Ceremony was very emotional for me because I realised this was now the moment that I’d been working towards all these years. I realised what the Olympic Games are about when I was in the middle of ice hockey players, speed skaters, bobsleigh athletes and Nordic athletes. We all had the same goal – to chase for a medal or go for gold.  On the trip from the Olympic Village to the mountain on race day, suddenly I felt this amazing pressure, but I was mentally prepared for it. I knew that I had to do more than everyone else because without 100 per cent, I would not win this downhill race. Instinctively, I had to find a line closer [to the gates], straighter and faster. Then just let it go. The big satisfaction came when I was back in my room at the Olympic Village all by myself. I took off my helmet, my ski boots and threw them into the corner. Suddenly, I realised I had done it."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 74,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg75.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "MY GAMES  Pictured Bernhard Russi won silver in an unforgettable men’s downhill at Innsbruck 1976  OLYMPIC REVIEW 75"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 75,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg76.jpg",
    "zoom": null,
    "content": "\n        <h1 id=\"76-no1\" class=\"abs 76-no hn-bde\" style=\"left:214px;top:735px; font-size: 2.2em; font-weight:300; margin:0; color:#fff; padding:0; margin:0;\"  data-number='{\"to\": 2 }' ></h1>\n        \n        <h1 id=\"76-no2\" class=\"abs 76-no hn-bde\" style=\"left:306px;top:735px; font-size: 2.2em; font-weight:300; margin:0; color:#fff; padding:0; margin:0;\"  data-number='{\"to\": 2}' ></h1>\n        <h1 id=\"76-no3\" class=\"abs 76-no hn-bde\" style=\"left:554px;top:735px; font-size: 2.2em; font-weight:300; margin:0; color:#fff; padding:0; margin:0;\"  data-number='{\"to\": 10}' ></h1>\n      ",
    "script": "\n        function onPageEnter() {\n          pg76Anim = new TimelineMax();\n          pg76Anim.fromTo(cOf(\"76-no\")[0], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"76-no\")[0]);}}, 1)\n                  .fromTo(cOf(\"76-no\")[1], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"76-no\")[1]);}}, \"-=0.3\")\n                  .fromTo(cOf(\"76-no\")[2], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"76-no\")[2]);}}, \"-=0.3\")\n\n        }\n        function onPageLeave() {\n          pg76Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "MY GAMES  DUEL WITH KLAMMER Franz Klammer was the best downhill skier of all time. He was in great shape and had won everything coming in. He had to win this gold medal – there was no other solution. For me, I already had a gold medal at home. I was down in the finish area in the lead with Klammer coming down and suddenly I felt the mountain starting to shake – 60,000 people were screaming, pulling him down, all having the same wish. Of course, I wanted to win, but at that moment I became a fan of Franz and thought, “He has to win this race”. Of course, he did. I agree with the Austrians that it was the greatest ski race of all time. When I was preparing in the starting house two minutes before the race, Franz ran in and we shook hands. He said: “I wish you good luck and let the  Above Russi won gold on his Olympic debut in the men’s downhill at Sapporo 1972 Above left Russi (left) became great friends with Franz Klammer after 1976  better man win”. This never happened to me before or after that. Today, we are best friends. We are soul brothers because of that Olympic experience shared together in Innsbruck. Every time we meet, we are not just shaking hands, but we hug each other.  downhill course, and they have already started to build the cable cars, gondolas and chairlifts. It is going to be a very serious downhill course. It will be very attractive with a lot of terrain changes – well-balanced with jumps, turns, flats and steeps.  A NEW CAREER  HOW THE GAMES CHANGED MY LIFE  Being a downhill course designer is a beautiful job. I love it, especially at the beginning of the project when you are on your own in the mountains. You can visualise what you can do, what it will look like and what you will offer to the athletes. It is an incredible experience to perform the same job in different countries, different geographical areas and on different mountains. It is not something that you can go to university for and I am very lucky to do this. Our work is underway on the Beijing 2022  At the Olympic Games, flags are not important. It becomes very neutral. It doesn’t matter what colour you are, what culture you come from or which language you speak; it is the same for everybody. That makes the Olympic Games very special. I would also say that the Olympic Games opens doors. Then you have to walk through those doors, prove that you are good at whatever you choose and deliver. ■  FACT FILE  Born 20 August 1948 in Andermatt, Switzerland  76 OLYMPIC REVIEW  2  Competed in two editions of the Olympic Winter Games: 1972, 1976  2  Olympic medals in skiing  1 gold  1 silver  Downhill (Sapporo 1972)  Downhill (Innsbruck 1976)  10  World Cup victories and 28 World Cup podiums  Designed the downhill course for PyeongChang 2018"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 76,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg77.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [(_ref = {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 77,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg78.jpg",
    "zoom": null,
    "content": ""
  }, defineProperty_default()(_ref, "content", "\n        <img id=\"78-title-1\" class=\"halfScale\" style=\"top:139px;left:109px;\" src=\"/111/static/_content/78-title-1.png\">\n        <img id=\"78-title-2\" class=\"halfScale\" style=\"top:188px;left:107px;\" src=\"/111/static/_content/78-title-2.png\">\n\n        <a href=\"https://library.olympic.org/Default/doc/SYRACUSE/184660/the-olympic-stadiums-of-the-summer-games-from-athens-1896-to-tokyo-2020-the-olympic-studies-centre\" target=\"_blank\">\n          <div class=\"addContentLink\" style=\"top:689px;left:187px;width:261px;height:24px\"></div>\n        </a>\n        <a href=\"https://library.olympic.org/Default/doc/SYRACUSE/185860\" target=\"_blank\">\n          <div class=\"addContentLink\" style=\"top:263px;left:217px;width:111px;height:38px\"></div>\n        </a>\n\n        <a href=\"https://library.olympic.org/Default/doc/SYRACUSE/172552/the-olympic-movement-the-ioc-and-the-olympic-games-the-olympic-studies-centre\" target=\"_blank\">\n          <div class=\"addContentLink\" style=\"top:577px;left:185px;width:327px;height:14px\"></div>\n        </a>\n\n        <a href=\"https://www.olympic.org/studies\" target=\"_blank\">\n          <div class=\"addContentLink\" style=\"top:481px;left:615px;width:94px;height:14px\"></div>\n        </a>\n\n        <a href=\"mailto:studies.centre@olympic.org\">\n          <div class=\"addContentLink\" style=\"top:769px;left:604px;width:137px;height:14px\"></div>\n        </a>\n        <a href=\"https://www.olympic.org/studies\" target=\"_blank\">\n          <div class=\"addContentLink\" style=\"top:781px;left:625px;width:101px;height:14px\"></div>\n        </a>\n        <a href=\"https://en-gb.facebook.com/OlympicStudiesCentre/\" target=\"_blank\">\n          <div class=\"addContentLink\" style=\"top:804px;left:605px;width:122px;height:14px\"></div>\n        </a>\n\n      "), defineProperty_default()(_ref, "script", "\n        function onPageEnter() {\n          pg78Anim = new TimelineMax();\n          pg78Anim.fromTo(idOf(\"78-title-1\"), 0.6, {x:60, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, 1)\n                  .fromTo(idOf(\"78-title-2\"), 0.6, {x:60, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut, onComplete: addContentLinks}, \"-=0.3\")\n        }\n    \n        function onPageLeave() {\n          pg78Anim.stop();\n          removeContentLinks();\n        }\n      "), defineProperty_default()(_ref, "searchText", "OLYMPIC STUDIES  OLYMPIC STUDIES THE LATEST NEWS, BOOK REVIEWS AND RESEARCH FROM THE IOC OLYMPIC STUDIES CENTRE – YOUR SOURCE OF OLYMPIC KNOWLEDGE  OFF THE SHELF THE REBELS OF 1894 AND A VISIONARY ACTIVIST The Rebels of 1894 and a Visionary Activist is the main feature in the latest issue of the Journal of Olympic History, largely dedicated to the 125th anniversary of the IOC. This article by Volker Kluge is about the preparation and holding of the Olympic Founding Congress at the Sorbonne University in Paris (France), and about Pierre de Coubertin, who proclaimed the revival of the Olympic Games in 1894 and appointed the IOC to manage them. Other articles cover the history of Olympic films and the history of the candidature process for the Olympic Games.  THE HISTORY AND POLITICS OF SPORTFOR-DEVELOPMENT: ACTIVISTS, IDEOLOGUES AND REFORMERS The high profile of sport-for-development programmes in the early 21st century, supported by the United Nations, IOC, and corporate social responsibility, suggests that such initiatives are a recent phenomenon. However, the use of sport as a means to achieve social, economic and moral goals has a long history. This book uses the popularity and institutionalisation of sport-for-development to examine the intersections between the history of sport and the history of development.  Published by International Society of Olympic Historians, Journal of Olympic History, 2019, volume 27, number 1, 80 pages, in English.  Edited by Simon C. Darnell, Russell Field and Bruce Kidd. Published by Palgrave McMillan, 2019. ISBN: 9781137439437, 380 pages, in English.  THE OLYMPIC MOVEMENT, THE IOC AND THE OLYMPIC GAMES The IOC Olympic Studies Centre has developed a reference collection offering a historic overview of various Olympic topics. Here, we present two of the latest in the series. This one looks at the organisations of the Olympic Movement, the structure of the IOC and the Olympic Games.  STUDIES CENTRE In this anniversary month of the IOC, we proudly remember that Pierre de Coubertin himself wrote shortly before his death: “I have not been able to carry out to the end what I wanted to perfect. I think that a centre of Olympic studies would aid the preservation and progress of my work more than anything else.” After early initiatives including the creation of the International Olympic Academy in 1938 and the IOC Olympic Studies Centre in 1983, we think that Coubertin would be very pleased to know that today over 40 universitybased Olympic Studies Centres on all continents are continuously contributing to the development and dissemination of Olympic knowledge. Find the full list on olympic.org/studies. In addition to the digitised collection of official reports, Olympic Reviews and Olympic Charters, we are very happy to announce that all candidature files are now accessible online on the Olympic World Library. The collection includes more than 230 files, representing 92 official Candidate Cities from 36 countries for the Summer Games from 1920 and for the Winter Games from 1936.  Published by the IOC Olympic Studies Centre, 2018, 50 pages, in English, French and Spanish.  THE OLYMPIC STADIUMS OF THE SUMMER GAMES FROM ATHENS 1896 TO TOKYO 2020 This volume documents the history of the stadiums used for the Olympic Summer Games which have hosted the athletics events and/or Opening and Closing Ceremonies, including their architecture, special features and post-Olympic use. Published by the IOC Olympic Studies Centre, 2019, 112 pages, in English and French.  78 OLYMPIC REVIEW  FIND OUT MORE For further information, resources and book loans or to sign up to our newsletter, contact us at studies.centre@olympic.org, visit olympic.org/studies or follow us on Facebook @OlympicStudiesCentre"), _ref)], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 78,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg79.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 79,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg80.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://www.atos.net/en/olympic-games\" target=\"_blank\">\n          <div class=\"addContentLink\" style=\"top:149px;left:92px;width:137px;height:20px\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "As the Worldwide IT Partner of the Olympic Games since 2001, Atos delivers critical Games applications, IT security, cloud services and many more solutions to help create the Olympic Games of the future. Want to see what the Olympic story could mean to you? Join us at atos.net/olympicgames  Maximum performance to build your journey to success Trusted partner for your Digital Journey"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 80,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg81.jpg",
    "zoom": null,
    "content": "\n        <div class=\"abs noOverflow\" style=\"top:193px;left:242px;width:294px;height:45px\">\n          <img class=\"halfScale\" id=\"81-title-1\" src=\"/111/static/_content/81-title-1.png\">\n        </div>\n        <div class=\"abs noOverflow\" style=\"top:237px;left:241px;width:256px;height:42px\">\n          <img class=\"halfScale\" id=\"81-title-2\" style=\"top:11px;\" src=\"/111/static/_content/81-title-2.png\">\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg81Anim = new TimelineMax();\n          pg81Anim.fromTo(idOf(\"81-title-1\"), 0.6, {y:50}, {y:0, ease: Power2.easeOut}, 1)\n                  .fromTo(idOf(\"81-title-2\"), 0.6, {y:-45}, {y:0, ease: Power2.easeOut}, \"-=0.3\")\n        }\n    \n        function onPageLeave() {\n          pg81Anim.stop();\n        }\n      ",
    "searchText": "OBITUARIES  HRH GRAND DUKE JEAN OF LUXEMBOURG IOC HONORARY MEMBER WHO JOINED THE IOC IN 1946 AND PLAYED AN ACTIVE ROLE WITHIN THE ORGANISATION FOR MANY DECADES  YVETTE WILLIAMS  Trailblazing Olympian Yvette Williams has died at the age of 89. The New Zealander became her country’s first-ever female Olympic gold medallist in the long jump at Helsinki 1952, leaping 6.24 metres to set a new Olympic record. She broke the women’s long jump world record in 1954 with a 6.28m jump, before retiring from competition later that year. An athlete who excelled in a range of disciplines, Williams’ other career highlights included a haul of three gold medals (long jump, discus, shot put) at the 1954 Commonwealth Games in Vancouver (Canada).  HRH Grand Duke Jean of Luxembourg, IOC Honorary Member in Luxembourg, has died at the age of 98. Grand Duke Jean had a lifelong interest in sports including riding, fencing, swimming, skiing and tennis, and served as patron of a number of Luxembourgish  PATRICK SERCU  CHO YANG-HO  Belgian cycling legend and Olympic gold medallist Patrick Sercu has passed away at the age of 74. As one of the dominant road and track cyclists of his day, Sercu won three sprint gold medals at the UCI Track Cycling World Championships in the 1960s as well as an Olympic gold medal in the men’s 1,000m time trial at the Olympic Games Tokyo 1964. His glittering career also included six stage wins at the Tour de France, with Sercu earning the green jersey at the 1974 edition.  Cho Yang-ho, who was instrumental in bringing the Olympic Winter Games to PyeongChang in 2018, has passed away, aged 70. As chairman and CEO of airline Korean Air, Cho’s expertise made him an ideal figure to serve as head of PyeongChang’s bidding committee. He later became President of the PyeongChang Organising Committee for the 2018 Olympic and Paralympic Winter Games (POCOG) following the successful bid.  sports federations in his role as Honorary President of the National Olympic Committee of Luxembourg. After initially joining the IOC in 1946, Grand Duke Jean went to on play an active role within the organisation over a period of several decades. He was a member of the IOC Commission of Enquiry for the Olympic Winter Games in 1968 and 1969, before being appointed as chairman of the IOC Rules Reviewing Commission from 1973 to 1976.  LYDIA WIDEMAN  Lydia Wideman, the history-making Finnish cross-country skier, has died at the age of 98. Born into a family of cross-country skiing enthusiasts – her twin sister Tyyne was also a multiple national champion – Wideman’s defining moment came at the Olympic Games Oslo 1952 where she became the first-ever female Olympic medallist in crosscountry skiing, winning gold in the 10km event with a time of 41:40 ahead of compatriots Mirja Hietamies and Siiri Rantanen. From February 2018 she also held the honour of being the oldest living Olympic champion.  KELLY CATLIN  American cyclist and Olympic silver medallist Kelly Catlin has passed away, aged 23. The talented Minnesotan secured her podium finish in the women’s team pursuit at the Olympic Games Rio 2016 and won three back-to-back world titles in the same event at the UCI Track Cycling World Championships between 2016 and 2018. She also achieved a bronze medal in the individual pursuit at the 2017 and 2018 World Championships.  OLYMPIC REVIEW 81"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 81,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg82.jpg",
    "zoom": null,
    "content": "\n        <img id=\"82-title-1\" class=\"halfScale\" style=\"top:97px;left:66px;\" src=\"/111/static/_content/82-title-1.png\">\n        <img id=\"82-title-2\" class=\"halfScale\" style=\"top:142px;left:66px;\" src=\"/111/static/_content/82-title-2.png\">\n        <img id=\"82-text-1\" class=\"halfScale\" style=\"top:197px;left:66px;\" src=\"/111/static/_content/82-text-1.png\">\n\n        <img id=\"82-img-1\" class=\"halfScale\" style=\"top:239px;left:66px;\" src=\"/111/static/_content/82-img-1.png\">\n        <h1 id=\"82-no1\" class=\"abs 82-no hn-lt\" style=\"left:249px;top:249px; font-size: 1.7em; font-weight:300; margin:0; color:#fff; padding:0; margin:0;\"  data-number='{\"to\": 135 }' ></h1>\n        <img id=\"82-text-2\" class=\"halfScale\" style=\"top:282px;left:253px;\" src=\"/111/static/_content/82-text-2.png\">\n\n        <img id=\"82-img-2\" class=\"halfScaleC\" style=\"top:309px;left:20px;\" src=\"/111/static/_content/82-img-2.png\">\n        <img id=\"82-img-3\" class=\"halfScaleC\" style=\"top:308px;left:106px;\" src=\"/111/static/_content/82-img-3.png\">\n        <img id=\"82-img-4\" class=\"halfScaleC\" style=\"top:310px;left:197px;\" src=\"/111/static/_content/82-img-4.png\">\n\n        <img id=\"82-text-3\" class=\"halfScale\" style=\"top:433px;left:78px;\" src=\"/111/static/_content/82-text-3.png\">\n        <img id=\"82-text-4\" class=\"halfScale\" style=\"top:433px;left:168px;\" src=\"/111/static/_content/82-text-4.png\">\n        <img id=\"82-text-5\" class=\"halfScale\" style=\"top:433px;left:249px;\" src=\"/111/static/_content/82-text-5.png\">\n\n        <img id=\"82-img-5\" class=\"halfScaleC\" style=\"top:388px;left:-85px;\" src=\"/111/static/_content/82-img-5.png\">\n        <h1 id=\"82-no2\" class=\"abs 82-no hn-bd\" style=\"left:66px;top:462px; font-size: 1.8em; font-weight:300; margin:0; color:#fff; padding:0; margin:0;\"  data-number='{\"to\": 50, \"append\": \"%\"}' ></h1>\n        <h1 id=\"82-no3\" class=\"abs 82-no hn-hv\" style=\"left:144px;top:483px; font-size: 0.7em; font-weight:300; margin:0; color:#000; padding:0; margin:0;\"  data-number='{\"to\": 2500, \"append\": \"m\xB2\", \"comma\": true}' ></h1>\n        <h1 id=\"82-no4\" class=\"abs 82-no hn-hv\" style=\"left:224px;top:521px; font-size: 0.7em; font-weight:300; margin:0; color:#000; padding:0; margin:0;\"  data-number='{\"to\": 50 }' ></h1>\n        <h1 id=\"82-no5\" class=\"abs 82-no hn-hv\" style=\"left:253px;top:573px; font-size: 0.7em; font-weight:300; margin:0; color:#000; padding:0; margin:0;\"  data-number='{\"to\": 150 }' ></h1>\n\n        <img id=\"82-text-6\" class=\"halfScale\" style=\"top:196px;left:349px;\" src=\"/111/static/_content/82-text-6.png\">\n        <img id=\"82-text-7\" class=\"halfScale\" style=\"top:230px;left:349px;\" src=\"/111/static/_content/82-text-7.png\">\n        <img id=\"82-img-6\" class=\"halfScale\" style=\"top:261px;left:349px;\" src=\"/111/static/_content/82-img-6.png\">\n        <img id=\"82-img-7\" class=\"halfScale\" style=\"top:389px;left:349px;\" src=\"/111/static/_content/82-img-7.png\">\n        <img id=\"82-img-8\" class=\"halfScale\" style=\"top:512px;left:345px;\" src=\"/111/static/_content/82-img-8.png\">\n\n        <img id=\"82-text-8\" class=\"halfScale\" style=\"top:197px;left:486px;\" src=\"/111/static/_content/82-text-8.png\">\n        <img id=\"82-img-9\" class=\"halfScale\" style=\"top:221px;left:485px;\" src=\"/111/static/_content/82-img-9.png\">\n        <h1 id=\"82-no2\" class=\"abs 82-no hn-bd\" style=\"left:484px;top:277px; font-size: 1.8em; font-weight:300; margin:0; color:#fff; padding:0; margin:0;\"  data-number='{\"to\": 90, \"append\": \"%\"}' ></h1>\n        <img id=\"82-text-9\" class=\"halfScale\" style=\"top:310px;left:485px;\" src=\"/111/static/_content/82-text-9.png\">\n\n        <img id=\"82-img-10\" class=\"halfScale\" style=\"top:215px;left:612px;\" src=\"/111/static/_content/82-img-10.png\">\n        <img id=\"82-text-10\" class=\"halfScale\" style=\"top:310px;left:613px;\" src=\"/111/static/_content/82-text-10.png\">\n        <img id=\"82-text-11\" class=\"halfScale\" style=\"top:373px;left:485px;\" src=\"/111/static/_content/82-text-11.png\">\n\n        <img id=\"82-img-11\" class=\"halfScaleC\" style=\"top:360px;left:442px;\" src=\"/111/static/_content/82-img-11.png\">\n        <img id=\"82-img-12\" class=\"halfScaleC\" style=\"top:339px;left:539px;\" src=\"/111/static/_content/82-img-11.png\">\n        <img id=\"82-img-13\" class=\"halfScaleC\" style=\"top:363px;left:636px;\" src=\"/111/static/_content/82-img-12.png\">\n\n        <h1 id=\"82-no2\" class=\"abs 82-no hn-lt\" style=\"left:507px;top:439px; font-size: 1.4em; font-weight:300; margin:0; color:#fff; padding:0; margin:0;\"  data-number='{\"to\": 95, \"append\": \"%\"}' ></h1>\n        <h1 id=\"82-no2\" class=\"abs 82-no hn-lt\" style=\"left:606px;top:418px; font-size: 1.4em; font-weight:300; margin:0; color:#fff; padding:0; margin:0;\"  data-number='{\"to\": 95, \"append\": \"%\"}' ></h1>\n        <h1 id=\"82-no2\" class=\"abs 82-no hn-lt\" style=\"left:703px;top:440px; font-size: 1.4em; font-weight:300; margin:0; color:#fff; padding:0; margin:0;\"  data-number='{\"to\": 80, \"append\": \"%\"}' ></h1>\n      \n        <img id=\"82-text-12\" class=\"halfScale\" style=\"top:501px;left:489px;\" src=\"/111/static/_content/82-text-12.png\">\n        <img id=\"82-text-13\" class=\"halfScale\" style=\"top:480px;left:586px;\" src=\"/111/static/_content/82-text-13.png\">\n        <img id=\"82-text-14\" class=\"halfScale\" style=\"top:501px;left:693px;\" src=\"/111/static/_content/82-text-14.png\">\n        ",
    "script": "\n        function onPageEnter() {\n          pg82Anim = new TimelineMax();\n          pg82Anim.fromTo(idOf(\"82-title-1\"), 0.6, {x:60, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, 1)\n                  .fromTo(idOf(\"82-title-2\"), 0.6, {x:60, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, \"-=0.4\")\n                  .fromTo(idOf(\"82-text-1\"), 0.6, {y:40, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut}, \"-=0.4\")\n                  .fromTo(idOf(\"82-img-1\"), 0.4, {opacity:0}, {opacity:1, ease: Power2.easeOut}, \"-=0.4\")\n                  .fromTo(cOf(\"82-no\")[0], 0.2, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[0]);}}, \"-=0.3\")\n                  .fromTo(idOf(\"82-text-2\"), 0.4, {y:20, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut}, \"-=0.1\")\n                  .fromTo(idOf(\"82-img-2\"), 0.4, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, \"-=0.3\")\n                  .fromTo(idOf(\"82-img-3\"), 0.4, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, \"-=0.3\")\n                  .fromTo(idOf(\"82-img-4\"), 0.4, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, \"-=0.3\")\n                  .fromTo(idOf(\"82-text-3\"), 0.4, {y:20, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut}, \"-=0.4\")\n                  .fromTo(idOf(\"82-text-4\"), 0.4, {y:20, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut}, \"-=0.3\")\n                  .fromTo(idOf(\"82-text-5\"), 0.4, {y:20, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut}, \"-=0.3\")\n                  .fromTo(idOf(\"82-img-5\"), 0.4, {opacity:0}, {opacity:1, ease: Power2.easeOut}, \"-=0.4\")\n                  .fromTo(cOf(\"82-no\")[1], 0.2, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[1]);}}, \"-=0.1\")\n                  .fromTo(cOf(\"82-no\")[2], 0.2, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[2]);}}, \"-=0.1\")\n                  .fromTo(cOf(\"82-no\")[3], 0.2, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[3]);}}, \"-=0.1\")\n                  .fromTo(cOf(\"82-no\")[4], 0.2, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[4]);}}, \"-=0.1\")\n                  .fromTo(idOf(\"82-text-6\"), 0.4, {x:20, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, \"-=0.1\")\n                  .fromTo(idOf(\"82-text-7\"), 0.4, {x:20, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, \"-=0.3\")\n                  .fromTo(idOf(\"82-img-6\"), 0.4, {opacity:0}, {opacity:1, ease: Power2.easeOut}, \"-=0.3\")\n                  .fromTo(idOf(\"82-img-7\"), 0.4, {opacity:0}, {opacity:1, ease: Power2.easeOut}, \"-=0.3\")\n                  .fromTo(idOf(\"82-img-8\"), 0.4, {opacity:0}, {opacity:1, ease: Power2.easeOut}, \"-=0.3\")\n                  .fromTo(idOf(\"82-text-8\"), 0.4, {x:20, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, \"-=0.3\")\n                  .fromTo(idOf(\"82-img-9\"), 0.4, {opacity:0}, {opacity:1, ease: Power2.easeOut}, \"-=0.3\")\n                  .fromTo(cOf(\"82-no\")[5], 0.2, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[5]);}}, \"-=0.3\")\n                  .fromTo(idOf(\"82-text-9\"), 0.4, {y:20, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut}, \"-=0.1\")\n                  .fromTo(idOf(\"82-img-10\"), 0.4, {opacity:0}, {opacity:1, ease: Power2.easeOut}, \"-=0.3\")\n                  .fromTo(idOf(\"82-text-10\"), 0.4, {y:20, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut}, \"-=0.3\")\n                  .fromTo(idOf(\"82-text-11\"), 0.4, {y:20, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut}, \"-=0.3\")\n                  .fromTo(idOf(\"82-img-11\"), 0.4, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, \"-=0.3\")\n                  .fromTo(idOf(\"82-img-12\"), 0.4, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, \"-=0.3\")\n                  .fromTo(idOf(\"82-img-13\"), 0.4, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, \"-=0.3\")\n                  .fromTo(cOf(\"82-no\")[6], 0.2, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[6]);}}, \"-=0.3\")\n                  .fromTo(cOf(\"82-no\")[7], 0.2, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[7]);}}, \"-=0.1\")\n                  .fromTo(cOf(\"82-no\")[8], 0.2, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[8]);}}, \"-=0.1\")\n                  .fromTo(idOf(\"82-text-12\"), 0.4, {y:20, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut}, \"-=0.3\")\n                  .fromTo(idOf(\"82-text-13\"), 0.4, {y:20, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut}, \"-=0.3\")\n                  .fromTo(idOf(\"82-text-14\"), 0.4, {y:20, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut}, \"-=0.3\")\n        }\n    \n        function onPageLeave() {\n          pg82Anim.stop();\n        }\n      ",
    "searchText": "FAST FACTS Key facts and ﬁgures about the sustainable features embedded within Olympic House  RESPECTFUL INTEGRATION Promotion of active and ecological mobility:  135  RESOURCE EFFICIENCY  USER COMFORT  Compared to standard new office building:  bicycle spaces  90% of regularly occupied spaces with quality views  Flexible space due to no static element within 8m of the facade  Water consumption reduced by 60%  CIRCULAR ECONOMY  50% of the site is vegetated:  Hydrogen station  Employee subsidies for sustainable mobility  95% Energy consumption reduced by 35%  2,500m2 of vegetated roof  of former buildings’ materials reused or recycled  50 additional trees on site  95% of waste produced during construction work recycled  80% of construction costs spent with local contractors  150 trees added to areas around Olympic House  On-site renewable energies (solar panels and heat pumps)  * INFORMATION SOURCED FROM IOC REPORTS  Chargers for e-cars"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 82,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg83.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "YOU PUSH YOURSELF TO NEW HEIGHTS. WE PUSH FOR NEW WAYS TO PAY.  Kanoa Igarashi Team Visa  Visa. The exclusive payment technology partner of Tokyo 2020 and Worldwide Sponsor of the Olympic Games for over 30 years."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 83,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg84.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }]],
  "script": "\n      function idOf(id) {\n        return document.getElementById(id)\n      }\n  \n      function cOf(klass) {\n        return document.getElementsByClassName(klass)\n      }\n      \n      function removeContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) { \n          return e.className = 'addContentLink'\n        })\n      }\n  \n      function addContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) {\n          return e.className = 'contentLink addContentLink'\n        })\n      }\n  \n      function showOverlay(idx) {\n        idOf(idx).className = 'contentOverlay visible'\n      }\n  \n      function hideOverlay(idx) {\n        idOf(idx).className = 'contentOverlay hidden noclick'\n      }\n\n      function animateNumber(element){\n        if(element.getAttribute(\"data-number\")){\n          var args = JSON.parse(element.getAttribute(\"data-number\"));\n          var from = 0;\n          var to = 100;\n          var append = \"\";\n          var preppend = \"\";\n          var decimals = 0;\n          var duration = 1;\n          var ease = \"Linear.easeNone\";\n          var comma = false;\n          var separator = \",\";\n          var decChar = \".\";\n          for(obj in args){\n            if(obj == \"from\") from = args[obj];\n            if(obj == \"to\") to = args[obj];\n            if(obj == \"append\") append = args[obj];\n            if(obj == \"preppend\") preppend = args[obj];\n            if(obj == \"decimals\") decimals = args[obj];\n            if(obj == \"duration\") duration = args[obj];\n            if(obj == \"ease\") ease = args[obj];\n            if(obj == \"comma\") comma = args[obj];\n            if(obj == \"separator\") separator = args[obj];\n            if(obj == \"decChar\") decChar = args[obj];\n          }\n          var obj = {number: from}\n          TweenMax.to(obj, duration, {number: to, onUpdate: function(){\n            if(comma){\n              console.log(obj.number)\n              var str = obj.number.toFixed(decimals).toString();\n              var predec = str.split(/^d*/)[0];\n              console.log(\"PREDEC\", predec, typeof(predec));\n              var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')\n              var comp = newstr.replace(/^,/, '')\n              console.log(\"NEWSTR\", newstr, typeof(newstr));\n              // console.log({newstr})\n              // var dp = str.split(/.d+/) ? str.split(/.d+/)[0] : \"\";\n              // if(dp[0]) dp = dp[0].replace(\".\", decChar);\n              var dp = \"\";\n              element.innerHTML = preppend+comp+dp+append;\n            }else{\n              element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(\".\", decChar)+append;\n            }\n          }, ease: eval(ease)});\n        }else{\n          return;\n        }\n      }\n\n      function resetNumbers(ele){\n        var numbers = cOf(ele)\n        for(var i=0; i<numbers.length; i++) {\n          numbers[i].innerText= \"\"\n        }\n      }\n    ",
  "mobilePages": null,
  "mobileTemplate": null
});
// CONCATENATED MODULE: ./src/router/index.js





vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);
/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  base: src_document.basePath,
  routes: [{
    path: '/',
    name: 'Home',
    component: src_components_PublishPage,
    redirect: '/1-1'
  }, {
    path: '/:page-:section',
    name: 'PublishPage',
    component: src_components_PublishPage
  }]
}));
// CONCATENATED MODULE: ./src/store/actions.js





/* harmony default export */ var actions = ({
  goToPage: function goToPage(context, payload) {
    if (payload === null) {
      // console.log('Page does not exist')
      return;
    }
    if (typeof payload == "number") {
      if (context.getters.pageInRange(payload, 1)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          console.log('TEST 1');
          router.push(context.getters.routeFromIndex(payload - 1, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        }
      }
    } else {
      if (context.getters.pageInRange(payload.pageIndex, payload.sectionIndex)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          router.push(context.getters.routeFromIndex(payload.pageIndex - 1, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload.pageIndex, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        }
      }
    }
  },

  goToPreviousPage: function goToPreviousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  goToNextPage: function goToNextPage(context) {
    if (context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  previousPage: function previousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  nextPage: function nextPage(context) {
    if (context.getters.nextNextPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  goToPreviousMobilePage: function goToPreviousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  goToNextMobilePage: function goToNextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  goToPreviousSection: function goToPreviousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  goToNextSection: function goToNextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },
  previousMobilePage: function previousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  nextMobilePage: function nextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  previousSection: function previousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  nextSection: function nextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },

  resetSectionIndices: function resetSectionIndices(context) {
    var sectionIndices = context.getters.pages.map(function (page, index) {
      if (index == context.getters.zeroedPageIndex) return context.getters.sectionIndex - 1;
      return page.startIndex || 0;
    });
    context.commit('RESET_SECTION_INDICES', sectionIndices);
  },

  updateVideoURL: function updateVideoURL(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  openVideo: function openVideo(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  setInitialWindowSize: function setInitialWindowSize(context, payload) {
    context.commit('UPDATE_INITIAL_WINDOW_SIZE', extends_default()({}, payload));
  },
  changeWindowSize: function changeWindowSize(context, payload) {
    var pageWidth = context.getters.width;
    var pageHeight = context.getters.height;
    var windowWidth = payload.width;
    var windowHeight = payload.height - 48;
    var widthRatio = windowWidth / pageWidth;
    var heightRatio = windowHeight / pageHeight;
    if (context.getters.doublePage) {
      if (windowWidth / (pageWidth * 2) < heightRatio) {
        context.commit('UPDATE_IS_DOUBLE_PAGE', false);
      } else {
        context.commit('UPDATE_IS_DOUBLE_PAGE', true);
      }
    }

    if (pageWidth <= windowWidth && pageHeight <= windowHeight) {
      var newScale = Math.min(widthRatio, heightRatio);
      // console.log('widthratio', widthRatio)
      // console.log('heightratio', heightRatio)
      context.commit('UPDATE_PAGE_SCALE', { pageScale: newScale });
    } else {
      var _newScale = Math.min(widthRatio, heightRatio);
      context.commit('UPDATE_PAGE_SCALE', { pageScale: _newScale });
    }
  },

  checkMobileLanding: function checkMobileLanding(context, payload) {
    var isMobile = context.getters.isMobile;
    var landingPage = context.getters.currentMobilePage;
    var mobileSwitch = context.getters.mobileSwitch;
    if (!mobileSwitch || !isMobile) return;
    if (landingPage) {
      return;
    } else {
      router.replace('/1-1');
    }
  },

  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    // if(newX < -context.getters.width  ) newX = (-context.getters.width -  100) / newZ
    // if(newY < -context.getters.height ) newY = (-context.getters.height - 100) / newZ
    // if(newX > context.getters.width ) newX = (context.getters.width + 100) / newZ
    // if(newY > context.getters.height) newY = (context.getters.height + 100) / newZ
    console.log("Update Zoom: " + newZ + ", " + newX + ", " + newY + ", " + context.state.pageScale);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  pinchZoom: function pinchZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY / newZ;
    // if(newX < -context.getters.width  ) newX = -context.getters.width -  100
    // if(newY < -context.getters.height ) newY = -context.getters.height - 100
    // if(newX > context.getters.width ) newX = context.getters.width + 100
    // if(newY > context.getters.height) newY = context.getters.height + 100
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  panZoom: function panZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - payload.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY - payload.zoomOriginY / newZ;
    console.log("Pan Zoom: " + newZ + ", " + newX + ", " + newY);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: context.state.zoomLevel });
  },
  openGallery: function openGallery(context, payload) {
    context.commit('UPDATE_GALLERY', payload);
  },
  openGalleryTwo: function openGalleryTwo(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload[1]);
    context.commit('UPDATE_GALLERY', payload[0]);
  },
  closeGallery: function closeGallery(context, payload) {
    context.commit('UPDATE_GALLERY', []);
  },
  goToGallerySlide: function goToGallerySlide(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload);
  },
  nextGallerySlide: function nextGallerySlide(context, payload) {
    if (context.state.galleryIndex < context.state.galleryImages.length - 1) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex + 1);else context.commit('UPDATE_GALLERY_INDEX', 0);
  },
  previousGallerySlide: function previousGallerySlide(context, payload) {
    if (context.state.galleryIndex > 0) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex - 1);else context.commit('UPDATE_GALLERY_INDEX', context.state.galleryImages.length - 1);
  },


  updateAudioURL: function updateAudioURL(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  },

  openAudio: function openAudio(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  }
});
// EXTERNAL MODULE: ./node_modules/util/util.js
var util = __webpack_require__("OMJi");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// CONCATENATED MODULE: ./src/store/getters.js


/* harmony default export */ var getters = ({
  title: function title(state) {
    return state.document.title;
  },
  description: function description(state) {
    return state.document.description;
  },
  basePath: function basePath(state) {
    return state.document.basePath;
  },
  pages: function pages(state) {
    return state.document.pages.map(function (page, pageIndex) {
      return page.map(function (section, sectionIndex) {
        section.pageIndex = pageIndex;
        section.sectionIndex = sectionIndex;
        return section;
      });
    });
  },
  videoURL: function videoURL(state) {
    return state.videoURL;
  },
  audioURL: function audioURL(state) {
    return state.audioURL;
  },
  showContents: function showContents(state) {
    return state.activePanel == "Contents";
  },
  showLanguages: function showLanguages(state) {
    return state.activePanel == "Languages";
  },
  showSearch: function showSearch(state) {
    return state.activePanel == "Search";
  },
  showGuide: function showGuide(state) {
    return state.activePanel == "Guide";
  },
  isZoomed: function isZoomed(state) {
    return state.zoomLevel != 1;
  },
  zoomLevel: function zoomLevel(state) {
    return state.zoomLevel;
  },
  companyLogo: function companyLogo(state, getters) {
    if (state.document.companyLogo != "") {
      return getters.basePath + "/static/_content/" + state.document.companyLogo;
    } else return getters.basePath + "/static/kp-logo-white.svg";
  },
  galleryImages: function galleryImages(state) {
    return state.galleryImages;
  },
  galleryCaptions: function galleryCaptions(state) {
    return state.document.options.galleryCaptions;
  },
  galleryIndex: function galleryIndex(state) {
    return state.galleryIndex;
  },
  isGalleryOpen: function isGalleryOpen(state) {
    return state.galleryImages.length > 0;
  },
  isMobile: function isMobile(state, getters) {
    return function (a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|)|g1 u|g560|gene|gf-5|g-mo|go(.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) return true;
    }(navigator.userAgent || navigator.vendor || window.opera) ? true : false;
  },
  isIE11: function isIE11(state, getters) {
    return !!navigator.userAgent.match(/Trident\/7\./);
  },
  isPhantom: function isPhantom(state, getters) {
    return !!(navigator.userAgent.match("PhantomJS") != null);
  },
  initialWindowWidth: function initialWindowWidth(state) {
    return state.initialWindowWidth;
  },
  initialWindowHeight: function initialWindowHeight(state) {
    return state.initialWindowHeight;
  },
  publishURL: function publishURL(state) {
    return state.document.publishURL;
  },
  doublePage: function doublePage(state) {
    return state.document.options.doublePage;
  },
  contentsEnabled: function contentsEnabled(state) {
    return state.document.options.contentsEnabled;
  },
  downloadEnabled: function downloadEnabled(state) {
    return state.document.options.downloadEnabled;
  },
  languagesEnabled: function languagesEnabled(state) {
    return state.document.options.languagesEnabled;
  },
  readerEnabled: function readerEnabled(state) {
    return state.document.options.readerEnabled;
  },
  printEnabled: function printEnabled(state) {
    return state.document.options.printEnabled;
  },
  searchEnabled: function searchEnabled(state) {
    return state.document.options.searchEnabled;
  },
  guideEnabled: function guideEnabled(state) {
    return state.document.options.guideEnabled;
  },
  zoomEnabled: function zoomEnabled(state) {
    return state.document.options.zoomEnabled;
  },
  mobileSwitch: function mobileSwitch(state) {
    return state.document.options.mobileSwitch;
  },
  rightToLeft: function rightToLeft(state, getters) {
    return state.document.options.rightToLeft;
  },
  pagesVisible: function pagesVisible(state, getters) {
    return !getters.showSearch;
  },
  downloadPath: function downloadPath(state, getters) {
    return state.document.options.downloadPath;
  },
  width: function width(state) {
    return state.document.width;
  },
  height: function height(state) {
    return state.document.height;
  },
  languages: function languages(state) {
    return state.document.languages;
  },
  zeroedPageIndex: function zeroedPageIndex(state, getters) {
    return getters.pageIndex - 1;
  },
  zeroedSectionIndex: function zeroedSectionIndex(state, getters) {
    return getters.sectionIndex - 1;
  },
  currentPages: function currentPages(state, getters) {
    return getters.pages[getters.zeroedPageIndex];
  },
  currentPage: function currentPage(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  currentSection: function currentSection(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  routeFromIndex: function routeFromIndex(state, getters) {
    return function (pageIndex, sectionIndex) {
      return "/" + pageIndex + "-" + sectionIndex;
    };
  },
  externalResources: function externalResources(state) {
    return state.document.externalResources;
  },
  pageInRange: function pageInRange(state, getters) {
    return function (pageIndex, sectionIndex) {
      return (getters.pages[pageIndex - 1] || [])[sectionIndex - 1] !== undefined;
    };
  },
  isDoublePage: function isDoublePage(state, getters) {
    return state.isDoublePage;
  },
  visiblePages: function visiblePages(state, getters) {
    if (state.isDoublePage && getters.doublePage) {
      if (getters.zeroedPageIndex == 0) {
        return {
          previousLeftPage: null,
          previousRightPage: null,
          leftPage: null,
          previousSection: getters.previousSection,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else if (getters.nextPage == null && getters.nextNextPage == null) {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: null,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: null,
          nextRightPage: null
        };
      } else if (getters.zeroedPageIndex % 2 != 1) {
        return {
          previousLeftPage: getters.previousPreviousPreviousPage,
          previousRightPage: getters.previousPreviousPage,
          previousSection: getters.previousSection,
          leftPage: getters.previousPage,
          rightPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: getters.currentPage,
          rightPage: getters.nextPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextNextPage,
          nextRightPage: getters.nextNextNextPage
        };
      }
    } else {
      return {
        previousPreviousPage: getters.previousPreviousPage,
        previousPage: getters.previousPage,
        previousSection: getters.previousSection,
        currentPage: getters.currentPage,
        nextSection: getters.nextSection,
        nextPage: getters.nextPage,
        nextNextPage: getters.nextNextPage
      };
    }
  },
  previousPreviousPreviousPage: function previousPreviousPreviousPage(state, getters) {
    if (getters.pageIndex <= 3) return null;
    return getters.pages[getters.pageIndex - 4][state.sectionIndices[0]];
  },

  previousPreviousPage: function previousPreviousPage(state, getters) {
    if (getters.pageIndex <= 2) return null;
    return getters.pages[getters.pageIndex - 3][state.sectionIndices[0]];
  },

  previousPage: function previousPage(state, getters) {
    if (getters.pageIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 2][state.sectionIndices[0]];
  },

  nextPage: function nextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length) return null;
    return getters.pages[getters.pageIndex][state.sectionIndices[0]];
  },

  nextNextPage: function nextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 1) return null;
    return getters.pages[getters.pageIndex + 1][state.sectionIndices[0]];
  },

  nextNextNextPage: function nextNextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 2) return null;
    return getters.pages[getters.pageIndex + 2][state.sectionIndices[0]];
  },

  previousSection: function previousSection(state, getters) {
    if (getters.sectionIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex - 2];
  },

  nextSection: function nextSection(state, getters) {
    if (getters.sectionIndex >= getters.pages[getters.pageIndex - 1].length) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex];
  },

  previousPageURI: function previousPageURI(state, getters) {
    if (getters.previousPage == null) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.previousPreviousPage == null) {
        return getters.routeFromIndex(1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex - 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex - 1, state.sectionIndices[getters.pageIndex - 2] + 1);
  },

  nextPageURI: function nextPageURI(state, getters) {
    if (getters.nextPage == null || getters.nextPage.index == Publish.$store.state.document.pages.length - 1) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.nextNextPage == null) {
        return getters.routeFromIndex(Publish.$store.state.document.pages.length - 1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex + 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex + 1, state.sectionIndices[getters.pageIndex] + 1);
  },

  previousSectionURI: function previousSectionURI(state, getters) {
    if (getters.previousSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex - 1);
  },

  nextSectionURI: function nextSectionURI(state, getters) {
    if (getters.nextSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex + 1);
  },

  previousPageIndices: function previousPageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: getters.pageIndex - 1,
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  previousDoublePageIndices: function previousDoublePageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: Math.ceil(getters.pageIndex - 2),
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  nextPageIndices: function nextPageIndices(state, getters) {
    if (getters.nextPage == null) return null;
    return {
      pageIndex: getters.pageIndex + 1,
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  nextDoublePageIndices: function nextDoublePageIndices(state, getters) {
    if (getters.nextNextPage == null) return null;
    return {
      pageIndex: 2 * parseInt((getters.pageIndex + 2) / 2.0),
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  previousSectionIndices: function previousSectionIndices(state, getters) {
    if (getters.previousSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex - 1
    };
  },

  nextSectionIndices: function nextSectionIndices(state, getters) {
    if (getters.nextSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex + 1
    };
  },

  pageContainerStyle: function pageContainerStyle(state, getters) {
    var styleObject = {
      transform: "scale(" + getters.pageContainerZoomLevel * state.pageScale + ")"
    };
    if (state.zoomLevel !== 1) {
      styleObject.transformOrigin = state.zoomOriginX + "px " + state.zoomOriginY + "px";
    } else {
      styleObject.transformOrigin = "0px 0px";
    }
    return styleObject;
  },

  pageContainerZoomLevel: function pageContainerZoomLevel(state, getters) {
    return state.zoomLevel;
  },

  searchObject: function searchObject(state, getters) {
    var searchArray = [];
    getters.pages.forEach(function (sections, pageIndex) {
      sections.forEach(function (section, sectionIndex) {
        searchArray.push({
          id: pageIndex + 1 + "-" + (sectionIndex + 1),
          pageIndex: pageIndex + 1,
          sectionIndex: sectionIndex + 1,
          title: section.title,
          body: section.searchText || "",
          image: section.original || "",
          thumb: section.index + 1
        });
      });
    });
    return searchArray;
  },

  pageScripts: function pageScripts(state, getters) {
    return getters.pages.map(function (page, pageIndex) {
      return page.filter(function (e) {
        return e.script;
      }).map(function (section, sectionIndex) {
        return section.script.replace("onPageEnter", "p" + pageIndex + "s" + sectionIndex + "onPageEnter").replace("onPageLeave", "p" + pageIndex + "s" + sectionIndex + "onPageLeave");
      });
    }).reduce(function (a, b) {
      return a.concat(b);
    }).join("\n");
  },

  documentScript: function documentScript(state) {
    return state.document.script;
  },

  //#region Mobile
  mobilePages: function mobilePages(state) {
    return state.document.mobilePages;
  },
  mobilePageLink: function mobilePageLink(state, getters) {
    return function (page) {
      if (page.pageLinks.length) {
        var pageLink = page.pageLinks[0];
        return "/" + (pageLink.index + 1) + "-" + (pageLink.subIndex + 1);
      }
    };
  },
  currentMobilePage: function currentMobilePage(state, getters) {
    if (!(getters.isMobile && getters.mobileSwitch || getters.readerEnabled)) return;
    var currentPage = getters.mobilePages.find(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
    if (currentPage) return currentPage;else return null;
  },
  currentMobilePageIndex: function currentMobilePageIndex(state, getters) {
    if (!getters.mobilePages) return;
    return getters.mobilePages.findIndex(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
  },
  nextMobilePage: function nextMobilePage(state, getters) {
    if (getters.currentMobilePageIndex >= getters.mobilePages.length) return null;
    return getters.mobilePages[getters.currentMobilePageIndex + 1];
  },
  nextMobilePageIndices: function nextMobilePageIndices(state, getters) {
    if (getters.nextMobilePage == null) return null;
    return {
      pageIndex: getters.nextMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.nextMobilePage.pageLinks[0].subIndex + 1
    };
  },
  previousMobilePage: function previousMobilePage(state, getters) {
    if (getters.currentMobilePageIndex <= 0) return null;
    return getters.mobilePages[getters.currentMobilePageIndex - 1];
  },
  previousMobilePageIndices: function previousMobilePageIndices(state, getters) {
    if (getters.previousMobilePage == null) return null;
    return {
      pageIndex: getters.previousMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.previousMobilePage.pageLinks[0].subIndex + 1
    };
  },

  mobilePageContent: function mobilePageContent(state, getters) {
    return function (mobilePage) {
      return mobilePage.pageLinks.map(function (e) {
        return getters.pages[e.index][e.subIndex].mobileHtml;
      }).reduce(function (a, b) {
        return a + b;
      }, "");
    };
  }

  //#endregion

  //#region doublePage

  //#endregion
});
// CONCATENATED MODULE: ./src/store/mutations.js


var _types$RESET_SECTION_;



/* harmony default export */ var mutations = (_types$RESET_SECTION_ = {}, defineProperty_default()(_types$RESET_SECTION_, RESET_SECTION_INDICES, function (state, payload) {
  state.sectionIndices = payload;
}), defineProperty_default()(_types$RESET_SECTION_, CHANGE_SECTION_INDEX, function (state, payload) {
  state.sectionIndices[payload.pageIndex] = payload.sectionIndex;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_PAGE_SCALE, function (state, payload) {
  state.pageScale = payload.pageScale;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_VIDEO_URL, function (state, payload) {
  state.videoURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_AUDIO_URL, function (state, payload) {
  state.audioURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel = "";
  } else {
    state.activePanel = "Languages";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel = "";
  } else {
    state.activePanel = "Contents";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel = "";
  } else {
    state.activePanel = "Search";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_GUIDE, function (state) {
  if (state.activePanel == "Guide") {
    state.activePanel = "";
  } else {
    state.activePanel = "Guide";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  // console.log('toggleZoom', payload.zoomOriginX)
  if (state.zoomLevel != 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
  } else {
    state.zoomLevel = payload.zoomLevel || 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  }
  console.log("Toggle Zoom: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || 2;
  // console.log('update zoom', payload)
  console.log("Update Zoom: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
  if (state.zoomLevel < 1) {
    state.zoomLevel = 1;
    console.log("Update Zoom2: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_INITIAL_WINDOW_SIZE, function (state, payload) {
  state.initialPageWidth = payload.width;
  state.initialPageHeight = payload.height;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_IS_DOUBLE_PAGE, function (state, payload) {
  state.isDoublePage = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY, function (state, payload) {
  state.galleryImages = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY_INDEX, function (state, payload) {
  state.galleryIndex = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_READER, function (state, payload) {
  state.isReader = !state.isReader;
}), _types$RESET_SECTION_);
// CONCATENATED MODULE: ./src/store/modules/contents.js



// initial state
var state = {
  showContents: false

  // getters
};var contents_getters = {};

// actions
var contents_actions = {};

// mutations
var contents_mutations = defineProperty_default()({}, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel == "";
  } else {
    state.activePanel == "Contents";
  }
});

/* harmony default export */ var contents = ({
  state: state,
  getters: contents_getters,
  actions: contents_actions,
  mutations: contents_mutations
});
// CONCATENATED MODULE: ./src/store/modules/languages.js



// initial state
var languages_state = {
  showLanguages: false

  // getters
};var languages_getters = {};

// actions
var languages_actions = {};

// mutations
var languages_mutations = defineProperty_default()({}, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel == "";
  } else {
    state.activePanel == "Languages";
  }
});

/* harmony default export */ var languages = ({
  state: languages_state,
  getters: languages_getters,
  actions: languages_actions,
  mutations: languages_mutations
});
// CONCATENATED MODULE: ./src/store/modules/zoom.js


var _mutations;



// initial state
var zoom_state = {
  isZoomed: false,
  zoomLevel: 1,
  zoomOriginX: 0,
  zoomOriginY: 0

  // getters
};var zoom_getters = {
  // isZoomed: (state, getters) => state.isZoomed,
  zoomLevel: function zoomLevel(state, getters) {
    return state.zoomLevel;
  }

  // actions
};var zoom_actions = {
  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.rootState.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    if (newX < -context.getters.width) newX = -context.getters.width;
    if (newY < -context.getters.height) newY = -context.getters.height;
    if (newX > context.getters.width) newX = context.getters.width;
    if (newY > context.getters.height) newY = context.getters.height;
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY });
  }
};

// mutations
var zoom_mutations = (_mutations = {}, defineProperty_default()(_mutations, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (state.activePanel == 'Zoom') {
    state.activePanel = "";
  } else {
    state.activePanel = 'Zoom';
  }
  if (state.activePanel == 'Zoom') {
    state.zoomLevel = 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  } else {
    state.zoomLevel = 1;
  }
}), defineProperty_default()(_mutations, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;
}), _mutations);

/* harmony default export */ var zoom = ({
  state: zoom_state,
  getters: zoom_getters,
  actions: zoom_actions,
  mutations: zoom_mutations
});
// CONCATENATED MODULE: ./src/store/modules/search.js



// initial state
var search_state = {
  showSearch: false

  // getters
};var search_getters = {}
// allProducts: state => state.all


// actions
;var search_actions = {}
// getAllProducts ({ commit }) {
//   shop.getProducts(products => {
//     commit(types.RECEIVE_PRODUCTS, { products })
//   })
// }


// mutations
;var search_mutations = defineProperty_default()({}, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel == "";
  } else {
    state.activePanel == "Search";
  }
});

/* harmony default export */ var modules_search = ({
  state: search_state,
  getters: search_getters,
  actions: search_actions,
  mutations: search_mutations
});
// CONCATENATED MODULE: ./src/store/modules/route.js



// initial state - straight from the router i.e.
// route:{
// fullPath:"/5-1",
// meta: {},
// name:"PublishPage",
// params: {
//     section: "1",
//     page: "5"
// },
// path:"/5-1",
// query: {},
// }

// getters
var route_getters = {
  pageIndex: function pageIndex(state) {
    return parseInt(state.params.page);
  },
  sectionIndex: function sectionIndex(state) {
    return parseInt(state.params.section);
  }

  // actions
};var route_actions = {};

// mutations
var route_mutations = {};

/* harmony default export */ var route = ({
  getters: route_getters,
  actions: route_actions,
  mutations: route_mutations
});
// CONCATENATED MODULE: ./src/store/index.js












vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  state: {
    document: src_document,
    sectionIndices: [],
    pageScale: 1,
    videoURL: "",
    audioURL: "",
    activePanel: "",
    zoomLevel: 1,
    zoomOriginX: 0,
    zoomOriginY: 0,
    isDoublePage: false,
    galleryImages: [],
    galleryIndex: 0,
    isReader: false,
    initialWindowWidth: 300,
    initialWindowHeight: 476
  },
  actions: actions,
  getters: getters,
  mutations: mutations,
  modules: {
    // contents,
    // languages,
    // search,
    // zoom,
    route: route
  },
  strict: debug
}));
// EXTERNAL MODULE: ./node_modules/hammerjs/hammer.js
var hammer = __webpack_require__("rxKx");
var hammer_default = /*#__PURE__*/__webpack_require__.n(hammer);

// CONCATENATED MODULE: ./src/helpers/modules/inputHandler.js


/* harmony default export */ var inputHandler = ({
  init: function init() {
    window.mouseDown = false;
    window.mouse = {
      x: 0,
      y: 0,
      startX: 0,
      startY: 0,
      lastX: 0,
      lastY: 0,
      upX: 0,
      upY: 0,
      deltaX: 0,
      deltaY: 0
      // Mouse Events
      // document.addEventListener("mousedown", this.mouseDownHandler)
      // document.addEventListener("mousemove", this.mouseMoveHandler)
      // document.addEventListener("mouseup", this.mouseUpHandler)
    };document.addEventListener("mousewheel", this.mouseWheelHandler);
    document.addEventListener("dblclick", this.doubleClickHandler);
    //Touch Events
    // document.addEventListener( "touchstart", this.touchStartHandler)
    // document.addEventListener( "touchend", this.touchEndHandler)
    // document.addEventListener( "touchmove", this.touchMoveHandler)
    //Keyboard Events
    document.onkeydown = this.keyDownHandler;
    var hammertime;
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto",
        inputClass: hammer_default.a.SUPPORT_POINTER_EVENTS ? hammer_default.a.PointerEventInput : hammer_default.a.TouchInput,
        recognizers: [[hammer_default.a.Swipe, {
          direction: hammer_default.a.DIRECTION_HORIZONTAL
        }]]
      });
      hammertime.add(new hammer_default.a.Swipe());
    } else {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto"
      });
    }

    hammertime.get("swipe").set({ direction: hammer_default.a.DIRECTION_ALL });

    // hammertime.add(new Hammer.Tap({ event: "doubletap", taps: 2 }))
    // hammertime.add(new Hammer.Tap({ event: "singletap" }))
    // hammertime.get("doubletap").recognizeWith("singletap")
    // hammertime.get("singletap").requireFailure("doubletap")

    // hammertime.on("singletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1)
    //   ) {
    //     mouse.lastX = e.srcEvent.clientX
    //     mouse.lastY = e.srcEvent.clientY
    //   } else {
    //     console.log("Could not single tap")
    //   }
    // })

    // hammertime.on("doubletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     console.log("WORKING - MOBILE")
    //     Publish.toggleZoom({
    //       zoomOriginX: e.srcEvent.clientX,
    //       zoomOriginY: e.srcEvent.clientY,
    //     })
    //   } else {
    //     console.log("Could not double tap")
    //   }
    // })

    // hammertime.on("pinchin", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch in")
    //   }
    // })


    // hammertime.on("pinchout", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch out")
    //   }
    // })

    hammertime.on("pan", function (e) {
      if (!Publish.isMobile) {
        mouse.x = e.srcEvent.clientX;
        mouse.y = e.srcEvent.clientY;
        mouse.deltaX = mouse.x - mouse.lastX;
        mouse.deltaY = mouse.y - mouse.lastY;
        mouse.lastX = mouse.x;
        mouse.lastY = mouse.y;
        // console.log(mouse.deltaX + ", " + mouse.deltaY)
        // console.log("Panning")
        if (mouseDown && Publish.isZoomed) {
          // console.log("is actually panning")
          Publish.updateZoom({
            x: mouse.x,
            y: mouse.y
          });
        }
      }
    });

    hammertime.on("panstart", function (e) {
      if (!Publish.isMobile) {
        if (Publish.isZoomed) {
          mouseDown = true;
          mouse.lastX = e.srcEvent.clientX;
          mouse.lastY = e.srcEvent.clientY;
        }
      }
    });

    hammertime.on("panend", function (e) {
      if (!Publish.isMobile) {
        if (mouseDown && Publish.pagesVisible) {
          mouse.lastX = mouse.x;
          mouse.lastX = mouse.y;
          mouseDown = false;
        }
      }
    });

    hammertime.on("swipe", function (e) {
      if (Publish.isMobile && document.documentElement.dataset.mobile == "iOS" && screen.width != window.innerWidth && screen.width != window.innerHeight) //Safari
        {
          // console.log('zoomed portrait')
        } else {
        if (Publish.isGalleryOpen) {
          if (e.direction === hammer_default.a.DIRECTION_LEFT) {
            if (!Publish.rightToLeft) {
              Publish.nextGallerySlide();
            } else {
              Publish.previousGallerySlide();
            }
          } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
            if (!Publish.rightToLeft) {
              Publish.previousGallerySlide();
            } else {
              Publish.nextGallerySlide();
            }
          }
        } else if (Publish.videoURL == "" && Publish.audioURL == "" && !Publish.isZoomed) {
          if (Publish.isMobile || Publish.isReader) {
            if (Publish.mobileSwitch || Publish.isReader) {
              if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                if (!Publish.rightToLeft) {
                  Publish.goToNextMobilePage();
                } else {
                  Publish.goToPreviousMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                if (!Publish.rightToLeft) {
                  Publish.goToPreviousMobilePage();
                } else {
                  Publish.goToNextMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                console.log('Hammering Up');
                if (Publish.pagesVisible) Publish.goToNextSection();
              } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                console.log('Hammering Down');
                if (Publish.pagesVisible) Publish.goToPreviousSection();
              }
            } else {
              if (!Publish.isZoomed) {
                if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToNextPage();
                  } else {
                    Publish.goToPreviousPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToPreviousPage();
                  } else {
                    Publish.goToNextPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                  console.log('Hammering Up');
                  if (Publish.pagesVisible) Publish.goToNextSection();
                } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                  console.log('Hammering Down');
                  if (Publish.pagesVisible) Publish.goToPreviousSection();
                }
              }
            }
          } else {
            if (e.direction === hammer_default.a.DIRECTION_LEFT) {
              if (!Publish.rightToLeft) {
                Publish.goToNextPage();
              } else {
                Publish.goToPreviousPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
              if (!Publish.rightToLeft) {
                Publish.goToPreviousPage();
              } else {
                Publish.goToNextPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_UP) {
              console.log('Hammering Up');
              if (Publish.pagesVisible) Publish.goToNextSection();
            } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
              console.log('Hammering Down');
              if (Publish.pagesVisible) Publish.goToPreviousSection();
            }
          }
        }
        // else {
        //   if (e.direction === Hammer.DIRECTION_LEFT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToNextPage()
        //     } else {
        //       Publish.goToPreviousPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_RIGHT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToPreviousPage()
        //     } else {
        //       Publish.goToNextPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_UP) {
        //     if (Publish.pagesVisible) Publish.goToPreviousSection()
        //   } else if (e.direction === Hammer.DIRECTION_DOWN) {
        //     if (Publish.pagesVisible) Publish.goToNextSection()
        //   }
        // }
      }
    });
  },
  mouseWheelHandler: function mouseWheelHandler(e) {
    if (e.wheelDelta > 0) {
      Publish.goToPreviousSection();
    } else {
      Publish.goToNextSection();
    }
  },
  mouseMoveHandler: function mouseMoveHandler(e) {
    if (Publish.pagesVisible && Publish.zoomEnabled) {
      mouse.x = e.clientX;
      mouse.y = e.clientY;
      if (mouseDown && !Publish.isZoomed) {
        if (mouse.x - mouse.lastX < -100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToPreviousPage()
          //   else
          //     Publish.goToNextPage()
          // }
          mouseDown = false;
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
        } else if (mouse.x - mouse.lastX > 100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToNextPage()
          //   else
          //     Publish.goToPreviousPage()
          // }
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY < -100) {
          // if (Publish.pagesVisible) Publish.goToNextSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY > 100) {
          // if (Publish.pagesVisible) Publish.goToPreviousSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        }
      }
      if (mouseDown && Publish.isZoomed) {
        Publish.updateZoom({
          x: mouse.x,
          y: mouse.y
        });
      }
    }
  },
  mouseDownHandler: function mouseDownHandler(e) {
    if (!mouseDown && Publish.pagesVisible) {
      mouseDown = true;
      mouse.lastX = mouse.x;
      mouse.lastY = mouse.y;
    }
  },
  mouseUpHandler: function mouseUpHandler(e, fromTouch) {
    if (mouseDown && Publish.pagesVisible) {
      mouse.upX = mouse.x;
      mouse.upY = mouse.y;
      mouseDown = false;
    }
  },
  doubleClickHandler: function doubleClickHandler(e) {
    if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" && (e.target.className.search("currentPage") !== -1 || e.target.className.search("leftPage") !== -1 || e.target.className.search("rightPage") !== -1 || e.path.indexOf(document.getElementById("page-container") !== -1))) {
      console.log("WORKING");
      Publish.toggleZoom({
        zoomOriginX: e.pageX - window.innerWidth / 2,
        zoomOriginY: e.pageY - window.innerHeight / 2
      });
    } else {
      console.log("Double click failed!");
    }
  },
  keyDownHandler: function keyDownHandler(e) {
    e = e || window.event;
    if (e.target.tagName == "INPUT" || e.ctrlKey == true || e.metaKey == true) return;
    if (Publish.isGalleryOpen) {
      if (e.keyCode == "37") {
        if (!Publish.rightToLeft) {
          Publish.previousGallerySlide();
        } else {
          Publish.nextGallerySlide();
        }
      }
      if (e.keyCode == "39") {
        if (!Publish.rightToLeft) {
          Publish.nextGallerySlide();
        } else {
          Publish.previousGallerySlide();
        }
      }
    } else if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
      // if(!Publish.isZoomed){
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextMobilePage();else Publish.goToPreviousMobilePage();
      }
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousMobilePage();else Publish.goToNextMobilePage();
      }
      // }
    } else if (!Publish.videoURL == "" || !Publish.audioURL == "") {} else {
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextPage();else Publish.goToPreviousPage();
      } // left arrow
      if (e.keyCode == "38") Publish.goToPreviousSection(); // up arrow
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousPage();else Publish.goToNextPage();
      } // right arrow
      if (e.keyCode == "40") Publish.goToNextSection(); // down arrow
    }
  },
  throttle: function throttle(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

    var timer = null;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (timer === null) {
        timer = setTimeout(function () {
          func.apply(_this, args);
          timer = null;
        }, wait);
      }
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/platformHandler.js
/* harmony default export */ var platformHandler = ({
  init: function init() {
    var documentElement = document.documentElement;
    documentElement.setAttribute("data-useragent", navigator.userAgent);
    documentElement.setAttribute("data-platform", navigator.platform);
    documentElement.setAttribute("data-mobile", this.getMobileOperatingSystem());
    documentElement.setAttribute("data-browser", this.getBrowserInformation());
  },

  /**
   * Determine the mobile operating system.
   * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
   *
   * @returns {String}
   */
  getMobileOperatingSystem: function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "Windows";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    return "unknown";
  },
  getBrowserInformation: function getBrowserInformation() {
    var ua = navigator.userAgent,
        tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return "IE " + (tem[1] || "");
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M[0];
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/pageHandler.js
/* harmony default export */ var pageHandler = ({
  init: function init() {
    var delay = 250;
    var timeout = false;
    this.actualResizeHandler();
    window.addEventListener('resize', this.debounce(this.actualResizeHandler, 250));
  },
  actualResizeHandler: function actualResizeHandler(event) {
    if (typeof Publish !== 'undefined') {
      if (!Publish.isMobile) {
        Publish.changeWindowSize({
          width: window.innerWidth,
          height: window.innerHeight
        });
      } else {
        if (document.documentElement.dataset.mobile == "Android") {
          Publish.changeWindowSize({
            width: window.innerWidth,
            height: window.innerHeight
          });
        }
      }
    }
  },
  debounce: function debounce(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;

    var timeout = void 0;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(_this, args);
      }, wait);
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/index.js





/* harmony default export */ var helpers = ({
  inputHandler: inputHandler,
  platformHandler: platformHandler,
  pageHandler: pageHandler,
  trackingHandler: trackingHandler
});
// EXTERNAL MODULE: ./node_modules/vuex-router-sync/index.js
var vuex_router_sync = __webpack_require__("9JMe");
var vuex_router_sync_default = /*#__PURE__*/__webpack_require__.n(vuex_router_sync);

// CONCATENATED MODULE: ./src/main.js

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









var unsync = Object(vuex_router_sync["sync"])(store, router);

vue_esm["a" /* default */].config.productionTip = false;

vue_esm["a" /* default */].use(vue_analytics_default.a, {
  id: 'UA-137252729-16',
  router: router
});

/* eslint-disable no-new */
window.Publish = new vue_esm["a" /* default */]({
  el: "#app",
  router: router,
  store: store,
  template: '<App ref="app"/>',
  components: {
    App: src_App
  },
  created: function created() {
    if (this.mobileSwitch) this.checkMobileLanding();
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
  }), Object(vuex_esm["c" /* mapGetters */])(["currentPage", "pagesVisible", "isZoomed", "showContents", "zoomLevel", "rightToLeft", "zoomEnabled", "isMobile", "mobileSwitch", "currentMobilePageIndex", "videoURL", "isGalleryOpen", "doublePage", "isPhantom", "isDoublePage", "showGuide", "initialWindowWidth", "initialWindowHeight", "audioURL"])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleZoom: "TOGGLE_ZOOM"
  }), Object(vuex_esm["b" /* mapActions */])(["goToPage", "goToNextPage", "goToPreviousPage", "goToNextSection", "goToPreviousSection", "goToPreviousMobilePage", "goToNextMobilePage", "nextPage", "previousPage", "nextSection", "previousSection", "previousMobilePage", "nextMobilePage", "updateZoom", "startZoom", "changeWindowSize", "checkMobileLanding", "updateVideoURL", "pinchZoom", "panZoom", "openVideo", "isPhantom", "openGallery", "openGalleryTwo", "closeGallery", "goToGallerySlide", "nextGallerySlide", "previousGallerySlide", 'changeWindowSize', 'setInitialWindowSize', "updateAudioURL", "openAudio"])),
  mounted: function mounted() {
    helpers.pageHandler.init();
    helpers.inputHandler.init();
    helpers.platformHandler.init();
    helpers.trackingHandler.init();
    // if (!Publish.isPhantom) {
    // this.changeWindowSize({
    //   width: window.innerWidth,
    //   height: window.innerHeight,
    // })
    // }
  }
});

router.beforeEach(function (to, from, next) {
  if (Publish.isMobile && Publish.mobileSwitch) next();
  // console.log('Navigating from', from, ' to ', to)
  var p = parseInt(from.params.page) - 1;
  var s = parseInt(from.params.section) - 1;
  try {
    if (window["p" + p + "s" + s + "onPageLeave"] && !Publish.$store.getters.tmpMobile) {
      window["p" + p + "s" + s + "onPageLeave"]();
    }
    if (Publish.$store.state.isDoublePage && Publish.doublePage) {
      window["p" + p + "s" + s + "onPageLeave"]();
      window["p" + (p + 1) + "s" + s + "onPageLeave"]();
    }
  } catch (err) {
    console.error("WARNING - p" + p + "s" + s + "onPageLeave caused an error:");
    console.error(err.message);
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
    document.getElementById('mobile-container').style.position = "fixed";
    setTimeout(function () {
      document.getElementById('mobile-container').style.position = "";
    }, 100);
  }
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

/***/ }),

/***/ "NZMO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Pg37":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QkI9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S4/L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T53c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U2l4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V6ic":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WN8W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZQhR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Zf2O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eBnN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "i9d8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oPvi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pXbK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.63849c162c964f77482b.js